/* Feum Umi configurator, build 2026-09-29 11:50. Generated by build/precompile.py
   (Babel 7.29.9, the same options @babel/standalone uses in the browser).
   Do not edit: change Configurator.jsx and rebuild. Upload to the theme as
   assets/umi-configurator.js together with page.configurator-umi.liquid. */
"use strict";

function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _React = React,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useRef = _React.useRef,
  useEffect = _React.useEffect;
var COLLECTION_IMG = "?width=280&height=175&crop=center";
var COLLECTIONS = [{
  id: "umi",
  label: "Umi",
  descKey: "umiDesc",
  available: true,
  photo: "textures/collections/umi.png",
  shopFile: "UMI_Modul_Narozny_Side_22.png"
}, {
  id: "noku",
  label: "Noku",
  descKey: "nokuDesc",
  available: false,
  photo: "textures/collections/noku.png",
  shopFile: "NOKU_CORNER_MODULE_SIDE_CW49.webp"
}];
function collectionPhotoUrl(c) {
  if (ASSET_BASE && c.shopFile) return ASSET_BASE + c.shopFile + COLLECTION_IMG;
  return assetUrl(c.photo);
}
var FABRIC_COLLECTIONS = [{
  id: "fabric-01",
  label: "Standard 01",
  fabrics: [{
    id: "miami-beige",
    label: "Miami Beige",
    tr: {
      pl: "Letni be\u017C",
      de: "Miami Beige"
    },
    hex: "#D4C4A8",
    mult: 1.0,
    anisotropic: true,
    texture: "textures/fabric-01/miami-beige.jpg"
  }, {
    id: "stone-black",
    label: "Stone Black",
    tr: {
      pl: "Kamienna czer\u0144",
      de: "Steinschwarz"
    },
    hex: "#2C2C2C",
    mult: 1.0,
    anisotropic: true,
    texture: "textures/fabric-01/stone-black.jpg"
  }, {
    id: "orange-fall",
    label: "Orange Fall",
    tr: {
      pl: "Jesienny pomara\u0144czowy",
      de: "Orange Fall"
    },
    hex: "#C67A3C",
    mult: 1.15,
    anisotropic: true,
    texture: "textures/fabric-01/orange-fall.jpg"
  }, {
    id: "light-green",
    label: "Light Green",
    tr: {
      pl: "Jasna ziele\u0144",
      de: "Hellgr\xFCn"
    },
    hex: "#8FAE7E",
    mult: 1.15,
    anisotropic: true,
    texture: "textures/fabric-01/light-green.jpg"
  }, {
    id: "maroon-red",
    label: "Maroon Red",
    tr: {
      pl: "Kasztanowa czerwie\u0144",
      de: "Kastanienbraun Rot"
    },
    hex: "#6B2D3E",
    mult: 1.25,
    anisotropic: true,
    texture: "textures/fabric-01/maroon-red.jpg"
  }, {
    id: "mocha-brown",
    label: "Mocha Brown",
    tr: {
      pl: "Br\u0105zowa mokka",
      de: "Moccabraun"
    },
    hex: "#6B5344",
    mult: 1.0,
    anisotropic: true,
    texture: "textures/fabric-01/mocha-brown.jpg"
  }]
}, {
  id: "colourwash-eco",
  label: "Colourwash Eco",
  fabrics: [{
    id: "colourwash-marzipan",
    label: "Marzipan",
    tr: {
      pl: "Marcepan",
      de: "Marzipan"
    },
    hex: "#C9A876",
    mult: 1.15,
    repeat: 3,
    texture: "textures/colourwash-eco/marzipan/col.jpg",
    normalMap: "textures/colourwash-eco/marzipan/nrm.jpg",
    roughnessMap: "textures/colourwash-eco/marzipan/rough.jpg",
    metalnessMap: "textures/colourwash-eco/marzipan/met.jpg"
  }, {
    id: "colourwash-earth",
    label: "Earth",
    tr: {
      pl: "Mineralny br\u0105z",
      de: "Mineralisches Braun"
    },
    hex: "#7A5C3E",
    mult: 1.15,
    repeat: 3,
    texture: "textures/colourwash-eco/earth/col.jpg",
    normalMap: "textures/colourwash-eco/earth/nrm.jpg",
    roughnessMap: "textures/colourwash-eco/earth/rough.jpg",
    metalnessMap: "textures/colourwash-eco/earth/met.jpg"
  }, {
    id: "colourwash-hedge",
    label: "Hedge",
    tr: {
      pl: "Le\u015Bna ziele\u0144",
      de: "Waldgr\xFCn"
    },
    hex: "#5C6B4E",
    mult: 1.15,
    repeat: 3,
    texture: "textures/colourwash-eco/hedge/col.jpg",
    normalMap: "textures/colourwash-eco/hedge/nrm.jpg",
    roughnessMap: "textures/colourwash-eco/hedge/rough.jpg",
    metalnessMap: "textures/colourwash-eco/hedge/met.jpg"
  }, {
    id: "colourwash-terra",
    label: "Terra",
    tr: {
      pl: "Terakota",
      de: "Terrakotta"
    },
    hex: "#A85C3E",
    mult: 1.15,
    repeat: 3,
    texture: "textures/colourwash-eco/terra/col.jpg",
    normalMap: "textures/colourwash-eco/terra/nrm.jpg",
    roughnessMap: "textures/colourwash-eco/terra/rough.jpg",
    metalnessMap: "textures/colourwash-eco/terra/met.jpg"
  }]
}];
var FABRICS = FABRIC_COLLECTIONS.flatMap(function (g) {
  return g.fabrics;
});
var PILLOW_SIZES = [{
  id: "s",
  label: "35 × 35 cm",
  price: 18500
}, {
  id: "l",
  label: "50 × 35 cm",
  price: 21500
}];
var PILLOW_COLORS = [{
  id: "beige",
  label: "Linen Beige",
  tr: {
    pl: "Lniany Be\u017C",
    de: "Leinenbeige"
  },
  hex: "#D5CFC2",
  swatch: "textures/addons/pillow/swatch-beige.jpg",
  v: {
    s: "46254991605929",
    l: "46254984429737"
  },
  h: {
    s: "miu-cushion-linen-beige-35-x-35-cm",
    l: "miu-cushion-linen-beige-50-x-35-cm"
  }
}, {
  id: "black",
  label: "Graphite Black",
  tr: {
    pl: "Grafitowa Czer\u0144",
    de: "Graphitschwarz"
  },
  hex: "#4E4E4C",
  swatch: "textures/addons/pillow/swatch-black.jpg",
  v: {
    s: "46255044853929",
    l: "46255001796777"
  },
  h: {
    s: "miu-cushion-graphite-black-35-x-35-cm",
    l: "miu-cushion-graphite-black-50-x-35-cm"
  }
}, {
  id: "brown",
  label: "Chestnut Brown",
  tr: {
    pl: "Orzechowy Br\u0105z",
    de: "Kastanienbraun"
  },
  hex: "#644E42",
  swatch: "textures/addons/pillow/swatch-brown.jpg",
  v: {
    s: "46255058583721",
    l: "46255011102889"
  },
  h: {
    s: "miu-cushion-chestnut-brown-35-x-35-cm",
    l: "miu-cushion-chestnut-brown-50-x-35-cm"
  }
}, {
  id: "green",
  label: "Olive Green",
  tr: {
    pl: "Oliwkowa Ziele\u0144",
    de: "Olivgr\xFCn"
  },
  hex: "#939168",
  swatch: "textures/addons/pillow/swatch-green.jpg",
  v: {
    s: "46255062515881",
    l: "46255018573993"
  },
  h: {
    s: "miu-cushion-olive-green-35-x-35-cm",
    l: "miu-cushion-olive-green-50-x-35-cm"
  }
}, {
  id: "orange",
  label: "Amber Orange",
  tr: {
    pl: "Bursztynowa Pomara\u0144cz",
    de: "Bernsteinorange"
  },
  hex: "#AE7E48",
  swatch: "textures/addons/pillow/swatch-orange.jpg",
  v: {
    s: "46255069495465",
    l: "46255022833833"
  },
  h: {
    s: "miu-cushion-amber-orange-35-x-35-cm",
    l: "miu-cushion-amber-orange-50-x-35-cm"
  }
}, {
  id: "red",
  label: "Carmine Red",
  tr: {
    pl: "Karminowa Czerwie\u0144",
    de: "Karminrot"
  },
  hex: "#942B32",
  swatch: "textures/addons/pillow/swatch-red.jpg",
  v: {
    s: "46239775752361",
    l: "46254841921705"
  },
  h: {
    s: "miu-cushion-carmine-red-35-x-35-cm",
    l: "miu-cushion-carmine-red-50-x-35-cm"
  }
}, {
  id: "miami-beige",
  label: "Miami Beige",
  tr: {
    pl: "Letni be\u017C",
    de: "Miami Beige"
  },
  hex: "#D4C4A8",
  swatch: "textures/fabric-01/miami-beige.jpg",
  v: {
    s: "47415119675561",
    l: "47415120101545"
  },
  h: {
    s: "miu-cushion-miami-beige-35-x-35-cm",
    l: "miu-cushion-miami-beige-50-x-35-cm"
  }
}, {
  id: "stone-black",
  label: "Stone Black",
  tr: {
    pl: "Kamienna czer\u0144",
    de: "Steinschwarz"
  },
  hex: "#2C2C2C",
  swatch: "textures/fabric-01/stone-black.jpg",
  v: {
    s: "47417067307177",
    l: "47415125901481"
  },
  h: {
    s: "miu-cushion-stone-black-35-x-35-cm",
    l: "miu-cushion-stone-black-50-x-35-cm"
  }
}, {
  id: "maroon-red",
  label: "Maroon Red",
  tr: {
    pl: "Kasztanowa czerwie\u0144",
    de: "Kastanienbraun Rot"
  },
  hex: "#6B2D3E",
  swatch: "textures/fabric-01/maroon-red.jpg",
  v: {
    s: "47417070747817",
    l: "47415126687913"
  },
  h: {
    s: "miu-cushion-maroon-red-35-x-35-cm",
    l: "miu-cushion-maroon-red-50-x-35-cm"
  }
}, {
  id: "orange-fall",
  label: "Orange Fall",
  tr: {
    pl: "Jesienny pomara\u0144czowy",
    de: "Orange Fall"
  },
  hex: "#C67A3C",
  swatch: "textures/fabric-01/orange-fall.jpg",
  v: {
    s: "47417071993001",
    l: "47415153098921"
  },
  h: {
    s: "miu-cushion-orange-fall-35-x-35-cm",
    l: "miu-cushion-orange-fall-50-x-35-cm"
  }
}, {
  id: "mocha-brown",
  label: "Mocha Brown",
  tr: {
    pl: "Br\u0105zowa mokka",
    de: "Moccabraun"
  },
  hex: "#6B5344",
  swatch: "textures/fabric-01/mocha-brown.jpg",
  v: {
    s: "47417074483369",
    l: "47415153787049"
  },
  h: {
    s: "miu-cushion-mocha-brown-35-x-35-cm",
    l: "miu-cushion-mocha-brown-50-x-35-cm"
  }
}, {
  id: "light-green",
  label: "Light Green",
  tr: {
    pl: "Jasna ziele\u0144",
    de: "Hellgr\xFCn"
  },
  hex: "#8FAE7E",
  swatch: "textures/fabric-01/light-green.jpg",
  v: {
    s: "47417076351145",
    l: "47415155032233"
  },
  h: {
    s: "miu-cushion-light-green-35-x-35-cm",
    l: "miu-cushion-light-green-50-x-35-cm"
  }
}];
var BLANKET_COLORS = [{
  id: "safari-bordeaux",
  label: "Safari Beige & Bordeaux",
  tr: {
    pl: "Piaskowy be\u017C i bordowy",
    de: "Safari Beige und Bordeaux"
  },
  hex: "#B65D56",
  swatch: "textures/addons/throw/swatch-safari-bordeaux.jpg",
  packshot: "textures/addons/throw/packshot-safari-bordeaux.jpg",
  h: "throw-safari-beige-and-bordeaux",
  v: "44373098660009"
}, {
  id: "safari-brown",
  label: "Safari Beige & Chocolate Brown",
  tr: {
    pl: "Piaskowy be\u017C i czekoladowy br\u0105z",
    de: "Safari Beige und Schokoladenbraun"
  },
  hex: "#897265",
  swatch: "textures/addons/throw/swatch-safari-brown.jpg",
  packshot: "textures/addons/throw/packshot-safari-brown.jpg",
  h: "throw-safari-beige-and-chocolate-brown",
  v: "46462084481193"
}, {
  id: "sand-orange",
  label: "Sand Beige & Pumpkin Orange",
  tr: {
    pl: "Dyniowy Pomara\u0144cz",
    de: "Sandbeige und K\xFCrbisorange"
  },
  hex: "#E8C287",
  swatch: "textures/addons/throw/swatch-sand-orange.jpg",
  packshot: "textures/addons/throw/packshot-sand-orange.jpg",
  h: "throw-sand-beige-and-pumpkin-orange",
  v: "46652496937129"
}, {
  id: "sky-ecru",
  label: "Sky Blue & Ecru",
  tr: {
    pl: "B\u0142\u0119kit nieba i ecru",
    de: "Himmelblau und Ecru"
  },
  hex: "#C4DCE2",
  swatch: "textures/addons/throw/swatch-sky-ecru.jpg",
  packshot: "textures/addons/throw/packshot-sky-ecru.jpg",
  h: "throw-sky-blue-and-ecru",
  v: "45017623036073"
}];
var BLANKET_PRICE = 34900;
var BLANKET_SIZE = "200 × 150 cm";
function addonLivePrice(variantId) {
  var f = typeof window !== "undefined" && window.FEUM_ADDON_PRICES;
  var p = variantId && f && f[variantId];
  return typeof p === "number" && p > 0 ? p : null;
}
function addonVariantId(a) {
  if (!a) return null;
  if (a.kind === "pillow") {
    var c = PILLOW_COLORS.find(function (x) {
      return x.id === a.color;
    });
    return c && c.v && c.v[a.size] || null;
  }
  var b = BLANKET_COLORS.find(function (x) {
    return x.id === a.color;
  });
  return b && b.v || null;
}
var S = "STANDARD";
function conns(sides, w, d) {
  var c = [];
  if (sides.includes("T")) c.push({
    id: "top",
    type: S,
    x: w / 2,
    y: 0,
    dir: 0,
    accepts: [S]
  });
  if (sides.includes("R")) c.push({
    id: "right",
    type: S,
    x: w,
    y: d / 2,
    dir: 90,
    accepts: [S]
  });
  if (sides.includes("B")) c.push({
    id: "bottom",
    type: S,
    x: w / 2,
    y: d,
    dir: 180,
    accepts: [S]
  });
  if (sides.includes("L")) c.push({
    id: "left",
    type: S,
    x: 0,
    y: d / 2,
    dir: 270,
    accepts: [S]
  });
  return c;
}
var MODULE_DEFS = [{
  id: "left",
  label: "Left",
  tr: {
    pl: "Moduł lewy",
    de: "Modul links"
  },
  w: 105,
  d: 98,
  base: 269500,
  connectors: conns("LT", 105, 98).map(function (c) {
    return c.id === "top" ? _objectSpread(_objectSpread({}, c), {}, {
      x: 49
    }) : c;
  })
}, {
  id: "middle",
  label: "Middle",
  tr: {
    pl: "Moduł środkowy",
    de: "Mittelmodul"
  },
  w: 98,
  d: 98,
  base: 211200,
  connectors: conns("LRT", 98, 98)
}, {
  id: "right",
  label: "Right",
  tr: {
    pl: "Moduł prawy",
    de: "Modul rechts"
  },
  w: 105,
  d: 98,
  base: 269500,
  connectors: conns("RT", 105, 98).map(function (c) {
    return c.id === "top" ? _objectSpread(_objectSpread({}, c), {}, {
      x: 56
    }) : c;
  })
}, {
  id: "corner",
  label: "Corner",
  tr: {
    pl: "Moduł narożny",
    de: "Eckmodul"
  },
  w: 98,
  d: 98,
  base: 398500,
  connectors: conns("RT", 98, 98)
}, {
  id: "pouf",
  label: "Pouf",
  tr: {
    pl: "Puf",
    de: "Hocker"
  },
  w: 98,
  d: 67,
  base: 155900,
  connectors: [{
    id: "top",
    type: S,
    x: 49,
    y: 0,
    dir: 0,
    accepts: [S]
  }, {
    id: "bottom",
    type: S,
    x: 49,
    y: 67,
    dir: 180,
    accepts: [S]
  }]
}, {
  id: "chaise-l",
  label: "Chaise L",
  tr: {
    pl: "Szezlong lewy",
    de: "Longchair links"
  },
  w: 155,
  d: 98,
  base: 409500,
  connectors: conns("LR", 155, 98)
}, {
  id: "chaise-r",
  label: "Chaise R",
  tr: {
    pl: "Szezlong prawy",
    de: "Longchair rechts"
  },
  w: 155,
  d: 98,
  base: 409500,
  connectors: conns("LR", 155, 98)
}, {
  id: "long-l",
  label: "Long L",
  tr: {
    pl: "Moduł głęboki lewy",
    de: "Tiefes Modul links"
  },
  w: 98,
  d: 140,
  base: 409500,
  connectors: [{
    id: "left",
    type: S,
    x: 0,
    y: 91,
    dir: 270,
    accepts: [S]
  }, {
    id: "top",
    type: S,
    x: 49,
    y: 0,
    dir: 0,
    accepts: [S],
    secondary: true
  }]
}, {
  id: "long-r",
  label: "Long R",
  tr: {
    pl: "Moduł głęboki prawy",
    de: "Tiefes Modul rechts"
  },
  w: 98,
  d: 140,
  base: 409500,
  connectors: [{
    id: "right",
    type: S,
    x: 98,
    y: 91,
    dir: 90,
    accepts: [S]
  }, {
    id: "top",
    type: S,
    x: 49,
    y: 0,
    dir: 0,
    accepts: [S],
    secondary: true
  }]
}];
var COMPAT = {
  STANDARD: ["STANDARD"]
};
var BAKE_ORDER = ["long-r", "long-l", "right", "left", "chaise-r", "chaise-l", "middle", "corner", "pouf"];
var MODULE_TO_GLB = {
  "left": "models/umi-left.glb",
  "middle": "models/umi-mid.glb",
  "right": "models/umi-right.glb",
  "corner": "models/umi-corner.glb",
  "pouf": "models/umi-pouf.glb",
  "chaise-l": "models/umi-otoman-2-l.glb",
  "chaise-r": "models/umi-otoman-2-r.glb",
  "long-l": "models/umi-otoman-1-l.glb",
  "long-r": "models/umi-otoman-1-r.glb"
};
var MODULE_GLB_Y_ROT = {
  "pouf": Math.PI / 2,
  "left": Math.PI / 2,
  "right": Math.PI / 2,
  "middle": Math.PI / 2,
  "chaise-l": Math.PI / 2,
  "chaise-r": Math.PI / 2,
  "long-l": Math.PI / 2,
  "long-r": Math.PI / 2
};
var MODELS_VERSION = "v15-uv-boki";
function thumbDBOpen() {
  return new Promise(function (res, rej) {
    var rq = indexedDB.open("feum-thumb-cache", 1);
    rq.onupgradeneeded = function () {
      return rq.result.createObjectStore("thumbs");
    };
    rq.onsuccess = function () {
      return res(rq.result);
    };
    rq.onerror = function () {
      return rej(rq.error);
    };
  });
}
function thumbCacheGet(_x) {
  return _thumbCacheGet.apply(this, arguments);
}
function _thumbCacheGet() {
  _thumbCacheGet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(key) {
    var db, _t8;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          _context5.p = 0;
          _context5.n = 1;
          return thumbDBOpen();
        case 1:
          db = _context5.v;
          _context5.n = 2;
          return new Promise(function (res) {
            var rq = db.transaction("thumbs").objectStore("thumbs").get(key);
            rq.onsuccess = function () {
              return res(rq.result || null);
            };
            rq.onerror = function () {
              return res(null);
            };
          });
        case 2:
          return _context5.a(2, _context5.v);
        case 3:
          _context5.p = 3;
          _t8 = _context5.v;
          return _context5.a(2, null);
      }
    }, _callee3, null, [[0, 3]]);
  }));
  return _thumbCacheGet.apply(this, arguments);
}
function thumbCachePut(_x2, _x3) {
  return _thumbCachePut.apply(this, arguments);
}
function _thumbCachePut() {
  _thumbCachePut = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(key, dataUrl) {
    var db, _t9;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.p = _context6.n) {
        case 0:
          _context6.p = 0;
          _context6.n = 1;
          return thumbDBOpen();
        case 1:
          db = _context6.v;
          db.transaction("thumbs", "readwrite").objectStore("thumbs").put(dataUrl, key);
          _context6.n = 3;
          break;
        case 2:
          _context6.p = 2;
          _t9 = _context6.v;
        case 3:
          return _context6.a(2);
      }
    }, _callee4, null, [[0, 2]]);
  }));
  return _thumbCachePut.apply(this, arguments);
}
var MODULE_START_ROT = {
  "left": 180,
  "middle": 180,
  "right": 180,
  "corner": 90,
  "chaise-l": 180,
  "chaise-r": 180,
  "long-l": 180,
  "long-r": 180
};
var MODULE_ICON_ROT = _objectSpread({}, MODULE_START_ROT);
var I18N = {
  en: {
    chooseHeadline: "Choose a collection and create your sofa",
    chooseSub: "On your own terms.",
    soon: "Coming soon",
    umiDesc: "Modular sofa \xB7 9 modules \xB7 10 fabrics",
    nokuDesc: "New collection \u2014 coming soon",
    configSubtitle: "modular sofa configurator",
    demoBadge: "DEMO \xB7 test version",
    collections: "Collections",
    modelWord: "Model",
    reset: "Reset",
    modules: "Modules",
    modulesSub: "Choose modules to create your layout.",
    fabricSub: "Choose your fabric and colour.",
    addonsCta: "Complete your set",
    addonsCtaSub: "Add the finishing touches with matching accessories.",
    addonsPillowTitle: "Cushions",
    addonsPillowSub: "Choose cushions to match your sofa.",
    addonsBlanketTitle: "Throw",
    addonsBlanketSub: "Choose a throw to match your sofa.",
    addonsSize: "Size",
    addonsColor: "Colour",
    addonsFrom: "from",
    addonsRemove: "Remove",
    addonsAdd: "Add to set",
    addonsChosen: "Added to your set",
    addonsCount: "added",
    dims: "Dimensions",
    view3d: "3D view",
    backToEdit: "Back to editing",
    see3d: "See it in 3D",
    resizePanel: "Drag to resize the panel",
    view2d: "2D view",
    inspirations: "Inspiration",
    presetsTitle: "Start with a ready-made layout",
    presetsSub: "Choose a layout and make it your own.",
    fromScratch: "Start from scratch",
    seatsWord: "seats",
    fromPrice: "from",
    helpChoose: "Help me choose",
    wizPersons: "How many people?",
    wizMaxW: "Maximum width",
    wizMaxD: "Maximum depth",
    wizShow: "Show matching layouts",
    wizMatches: "Matching layouts",
    wizShowAll: "Show all layouts",
    wizIntroTitle: "Let\u2019s find the right sofa for you.",
    wizIntroSub: "Tell us how many seats you need and how much space you have. We\u2019ll suggest layouts to suit.",
    wizPersonsHint: "leave room for guests, too",
    wizMaxWHint: "available width for your sofa \xB7 cm",
    wizMaxDHint: "from the back of the sofa to its furthest point at the front \xB7 cm",
    wizFits: "fits",
    wizExceeds: "over by",
    orderSamples: "Order fabric samples",
    saveVariant: "Save variant",
    compare: "Compare",
    compareTitle: "Compare variants",
    loadVariant: "Load",
    deleteVariant: "Delete",
    compareEmpty: "Save a variant to start comparing.",
    variantWord: "Variant",
    setSavings: "Set price \u2014 you save",
    freeShip: "Free delivery",
    returns100: "100-day returns",
    fabric: "Fabric",
    summary: "Summary",
    addModulesToStart: "Add modules to start",
    selectedTag: "selected",
    total: "Total",
    estimated: "Estimated",
    leadTime: "Lead time",
    leadTimeUnavailable: "Not available",
    regularPrice: "Regular price",
    youSave: "You save",
    separatePrice: "Modules bought separately",
    setPriceLabel: "Set price",
    setPriceLabelMulti: "Set prices applied",
    setPriceNote: "Any modules that make up one of our sets are charged at the set price. This is applied automatically in the cart and isn\u2019t a limited-time offer.",
    shipsIn: "Ships in",
    readyTitle: "Your sofa. Just the way you like it.",
    readySub: "Review your configuration, then add it to your cart.",
    addToCart: "Add to cart",
    copyList: "Copy shopping list",
    opensFeum: "Opens your cart on feum.eu",
    copyConfig: "Copy configuration",
    copied: "Copied!",
    downloadPdf: "Download PDF",
    pdfLibsFailed: "Could not prepare the PDF. Check your connection and try again.",
    pdfTitle: "Your configuration",
    pdfPrice: "Price",
    pdfScan: "Scan the QR code to open your cart",
    pdfNote: "Prices are estimates. Check the final price on feum.eu.",
    empty3d: "Add modules in 2D to view your sofa in 3D",
    emptyTitle: "Create your sofa",
    emptyHint1: "Pick a module from the panel",
    emptyHint2: "Drag modules to change the layout. They connect automatically.",
    rotate: "\u21BB Rotate 90\xB0",
    remove: "\u2715 Remove"
  },
  pl: {
    chooseHeadline: "Wybierz kolekcj\u0119 i stw\xF3rz swoj\u0105 sof\u0119",
    chooseSub: "Tak, jak lubisz.",
    soon: "Wkr\xF3tce",
    umiDesc: "Sofa modu\u0142owa \xB7 9 modu\u0142\xF3w \xB7 10 tkanin",
    nokuDesc: "Nowa kolekcja \u2014 wkr\xF3tce",
    configSubtitle: "konfigurator sofy modu\u0142owej",
    demoBadge: "DEMO \xB7 wersja testowa",
    collections: "Kolekcje",
    modelWord: "Model",
    reset: "Resetuj",
    modules: "Modu\u0142y",
    modulesSub: "Wybierz modu\u0142y i u\u0142\xF3\u017C swoj\u0105 sof\u0119.",
    fabricSub: "Wybierz tkanin\u0119 i kolor.",
    addonsCta: "Uzupe\u0142nij sw\xF3j zestaw",
    addonsCtaSub: "Dobierz dodatki do swojej sofy.",
    addonsPillowTitle: "Poduszki",
    addonsPillowSub: "Dobierz poduszki do swojej sofy.",
    addonsBlanketTitle: "Koc",
    addonsBlanketSub: "Dobierz koc do swojej sofy.",
    addonsSize: "Rozmiar",
    addonsColor: "Kolor",
    addonsFrom: "od",
    addonsRemove: "Usu\u0144",
    addonsAdd: "Dodaj do zestawu",
    addonsChosen: "Dodano do zestawu",
    addonsCount: "w zestawie",
    dims: "Wymiary",
    view3d: "Widok 3D",
    backToEdit: "Wr\xF3\u0107 do edycji",
    see3d: "Zobacz w 3D",
    resizePanel: "Przeci\u0105gnij, aby zmieni\u0107 szeroko\u015B\u0107 panelu",
    view2d: "Widok 2D",
    inspirations: "Inspiracje",
    presetsTitle: "Zacznij od gotowego uk\u0142adu",
    presetsSub: "Wybierz uk\u0142ad i dopasuj go do siebie.",
    fromScratch: "Zacznij od zera",
    seatsWord: "os.",
    fromPrice: "od",
    helpChoose: "Pom\xF3\u017C mi wybra\u0107",
    wizPersons: "Dla ilu os\xF3b?",
    wizMaxW: "Maksymalna szeroko\u015B\u0107",
    wizMaxD: "Maksymalna g\u0142\u0119boko\u015B\u0107",
    wizShow: "Poka\u017C pasuj\u0105ce uk\u0142ady",
    wizMatches: "Pasuj\u0105ce uk\u0142ady",
    wizShowAll: "Poka\u017C wszystkie uk\u0142ady",
    wizIntroTitle: "Znajd\u017A sof\u0119 dla siebie.",
    wizIntroSub: "Podaj liczb\u0119 miejsc i dost\u0119pn\u0105 przestrze\u0144. Poka\u017Cemy Ci pasuj\u0105ce uk\u0142ady.",
    wizPersonsHint: "pami\u0119taj te\u017C o go\u015Bciach",
    wizMaxWHint: "szeroko\u015B\u0107 dost\u0119pnego miejsca \xB7 cm",
    wizMaxDHint: "od ty\u0142u sofy do jej najbardziej wysuni\u0119tego punktu z przodu \xB7 cm",
    wizFits: "mie\u015Bci si\u0119",
    wizExceeds: "przekracza o",
    orderSamples: "Zam\xF3w pr\xF3bki tkanin",
    saveVariant: "Zapisz wariant",
    compare: "Por\xF3wnaj",
    compareTitle: "Por\xF3wnaj warianty",
    loadVariant: "Wczytaj",
    deleteVariant: "Usu\u0144",
    compareEmpty: "Zapisz wariant, aby rozpocz\u0105\u0107 por\xF3wnanie.",
    variantWord: "Wariant",
    setSavings: "Cena zestawu \u2014 oszcz\u0119dzasz",
    freeShip: "Darmowa dostawa",
    returns100: "100 dni na zwrot",
    fabric: "Tkanina",
    summary: "Podsumowanie",
    addModulesToStart: "Dodaj modu\u0142y, aby zacz\u0105\u0107",
    selectedTag: "wybrano",
    total: "Razem",
    estimated: "Szacunkowo",
    leadTime: "Czas realizacji",
    leadTimeUnavailable: "Brak informacji",
    regularPrice: "Cena regularna",
    youSave: "Oszcz\u0119dzasz",
    separatePrice: "Modu\u0142y kupione osobno",
    setPriceLabel: "Cena zestawu",
    setPriceLabelMulti: "Uwzgl\u0119dniono ceny zestaw\xF3w",
    setPriceNote: "Je\u015Bli modu\u0142y w Twoim uk\u0142adzie tworz\u0105 kt\xF3ry\u015B z naszych zestaw\xF3w, obejmuje je cena zestawowa. Naliczamy j\u0105 automatycznie w koszyku. To nie jest promocja czasowa.",
    shipsIn: "Wysy\u0142ka w ci\u0105gu",
    readyTitle: "Twoja sofa. Tak, jak lubisz.",
    readySub: "Sprawd\u017A konfiguracj\u0119 i dodaj j\u0105 do koszyka.",
    addToCart: "Dodaj do koszyka",
    copyList: "Skopiuj list\u0119 zakup\xF3w",
    opensFeum: "Otwiera koszyk na feum.eu",
    copyConfig: "Skopiuj konfiguracj\u0119",
    copied: "Skopiowano!",
    downloadPdf: "Pobierz PDF",
    pdfLibsFailed: "Nie udało się przygotować PDF. Sprawdź połączenie i spróbuj ponownie.",
    pdfTitle: "Twoja konfiguracja",
    pdfPrice: "Cena",
    pdfScan: "Zeskanuj kod QR, aby otworzy\u0107 koszyk",
    pdfNote: "Ceny s\u0105 orientacyjne. Ostateczn\u0105 cen\u0119 sprawdzisz na feum.eu.",
    empty3d: "Dodaj modu\u0142y w widoku 2D, aby zobaczy\u0107 sof\u0119 w 3D",
    emptyTitle: "U\u0142\xF3\u017C swoj\u0105 sof\u0119",
    emptyHint1: "Wybierz modu\u0142 z listy",
    emptyHint2: "Przeci\u0105gaj modu\u0142y, aby zmienia\u0107 uk\u0142ad. Po\u0142\u0105cz\u0105 si\u0119 automatycznie.",
    rotate: "\u21BB Obr\xF3\u0107 o 90\xB0",
    remove: "\u2715 Usu\u0144"
  },
  de: {
    chooseHeadline: "W\xE4hle eine Kollektion und gestalte dein Sofa",
    chooseSub: "So, wie du es magst.",
    soon: "Bald verf\xFCgbar",
    umiDesc: "Modulares Sofa \xB7 9 Module \xB7 10 Stoffe",
    nokuDesc: "Neue Kollektion \u2014 bald verf\xFCgbar",
    configSubtitle: "Sofa-Konfigurator",
    demoBadge: "DEMO \xB7 Testversion",
    collections: "Kollektionen",
    modelWord: "Modell",
    reset: "Zur\xFCcksetzen",
    modules: "Module",
    modulesSub: "W\xE4hle die Module f\xFCr dein Sofa.",
    fabricSub: "W\xE4hle Stoff und Farbe.",
    addonsCta: "Erg\xE4nze dein Set",
    addonsCtaSub: "Finde passende Accessoires f\xFCr dein Sofa.",
    addonsPillowTitle: "Kissen",
    addonsPillowSub: "W\xE4hle passende Kissen f\xFCr dein Sofa.",
    addonsBlanketTitle: "Wohndecke",
    addonsBlanketSub: "W\xE4hle eine passende Wohndecke f\xFCr dein Sofa.",
    addonsSize: "Gr\xF6\xDFe",
    addonsColor: "Farbe",
    addonsFrom: "ab",
    addonsRemove: "Entfernen",
    addonsAdd: "Zum Set hinzuf\xFCgen",
    addonsChosen: "Zum Set hinzugef\xFCgt",
    addonsCount: "hinzugef\xFCgt",
    dims: "Abmessungen",
    view3d: "3D-Ansicht",
    backToEdit: "Weiter bearbeiten",
    see3d: "In 3D ansehen",
    resizePanel: "Breite der Seitenleiste durch Ziehen \xE4ndern",
    view2d: "2D-Ansicht",
    inspirations: "Inspiration",
    presetsTitle: "Starte mit einer fertigen Kombination",
    presetsSub: "W\xE4hle eine Kombination und passe sie an deine W\xFCnsche an.",
    fromScratch: "Selbst zusammenstellen",
    seatsWord: "Sitzpl\xE4tze",
    fromPrice: "ab",
    helpChoose: "Hilf mir bei der Wahl",
    wizPersons: "F\xFCr wie viele Personen?",
    wizMaxW: "Maximale Breite",
    wizMaxD: "Maximale Tiefe",
    wizShow: "Passende Kombinationen anzeigen",
    wizMatches: "Passende Kombinationen",
    wizShowAll: "Alle Kombinationen anzeigen",
    wizIntroTitle: "Finde das passende Sofa f\xFCr dich.",
    wizIntroSub: "Gib an, wie viele Sitzpl\xE4tze du brauchst und wie viel Platz du hast. Wir zeigen dir passende Kombinationen.",
    wizPersonsHint: "denk auch an deine G\xE4ste",
    wizMaxWHint: "verf\xFCgbare Breite f\xFCr dein Sofa \xB7 cm",
    wizMaxDHint: "von der R\xFCckseite des Sofas bis zum vordersten Punkt \xB7 cm",
    wizFits: "passt",
    wizExceeds: "Zu gro\xDF:",
    orderSamples: "Stoffmuster bestellen",
    saveVariant: "Variante speichern",
    compare: "Vergleichen",
    compareTitle: "Varianten vergleichen",
    loadVariant: "Laden",
    deleteVariant: "L\xF6schen",
    compareEmpty: "Speichere eine Variante, um sie zu vergleichen.",
    variantWord: "Variante",
    setSavings: "Setpreis \u2014 du sparst",
    freeShip: "Kostenloser Versand",
    returns100: "100 Tage R\xFCckgaberecht",
    fabric: "Stoff",
    summary: "Zusammenfassung",
    addModulesToStart: "F\xFCge Module hinzu, um zu starten",
    selectedTag: "ausgew\xE4hlt",
    total: "Gesamt",
    estimated: "Gesch\xE4tzt",
    leadTime: "Lieferzeit",
    leadTimeUnavailable: "Keine Angabe",
    regularPrice: "Regul\xE4rer Preis",
    youSave: "Du sparst",
    separatePrice: "Module zum Einzelpreis",
    setPriceLabel: "Setpreis",
    setPriceLabelMulti: "Setpreise ber\xFCcksichtigt",
    setPriceNote: "F\xFCr Module, die zusammen einem unserer Sets entsprechen, gilt der Setpreis. Er wird im Warenkorb automatisch berechnet und ist kein zeitlich begrenztes Angebot.",
    shipsIn: "Versand in",
    readyTitle: "Dein Sofa. So, wie du es magst.",
    readySub: "Pr\xFCfe deine Konfiguration und lege sie in den Warenkorb.",
    addToCart: "In den Warenkorb",
    copyList: "Einkaufsliste kopieren",
    opensFeum: "\xD6ffnet deinen Warenkorb auf feum.eu",
    copyConfig: "Konfiguration kopieren",
    copied: "Kopiert!",
    downloadPdf: "PDF herunterladen",
    pdfLibsFailed: "Das PDF konnte nicht erstellt werden. Prüfe deine Verbindung und versuche es erneut.",
    pdfTitle: "Deine Konfiguration",
    pdfPrice: "Preis",
    pdfScan: "Scanne den QR-Code, um deinen Warenkorb zu \xF6ffnen",
    pdfNote: "Die Preise sind unverbindlich. Den endg\xFCltigen Preis findest du auf feum.eu.",
    empty3d: "F\xFCge Module in der 2D-Ansicht hinzu, um dein Sofa in 3D anzusehen",
    emptyTitle: "Stell dein Sofa zusammen",
    emptyHint1: "W\xE4hle ein Modul aus der Liste",
    emptyHint2: "Verschiebe die Module, um die Anordnung zu \xE4ndern. Sie verbinden sich automatisch.",
    rotate: "\u21BB 90\xB0 drehen",
    remove: "\u2715 Entfernen"
  }
};
var REPEATS_PER_M = 2.0;
function projAxis(nx, ny, nz) {
  nx = Math.abs(nx);
  ny = Math.abs(ny);
  nz = Math.abs(nz);
  if (ny >= nx && ny >= nz) return 0;
  return nx >= nz ? 1 : 2;
}
function ensureFabricGeometry(geometry, needUV) {
  if (!geometry.attributes.normal) geometry.computeVertexNormals();
  if (!needUV || geometry.attributes.uv) return;
  var pos = geometry.attributes.position;
  var nrm = geometry.attributes.normal;
  var idx = geometry.index;
  var project = function project(i, ax, out) {
    if (ax === 0) {
      out[0] = pos.getX(i);
      out[1] = pos.getZ(i);
    } else if (ax === 1) {
      out[0] = pos.getY(i);
      out[1] = pos.getZ(i);
    } else {
      out[0] = pos.getY(i);
      out[1] = pos.getX(i);
    }
    out[0] *= REPEATS_PER_M;
    out[1] *= REPEATS_PER_M;
  };
  var faceAxis = function faceAxis(a, b, c) {
    var x = pos.getX(a),
      y = pos.getY(a),
      z = pos.getZ(a);
    var ux = pos.getX(b) - x,
      uy = pos.getY(b) - y,
      uz = pos.getZ(b) - z;
    var vx = pos.getX(c) - x,
      vy = pos.getY(c) - y,
      vz = pos.getZ(c) - z;
    return projAxis(uy * vz - uz * vy, uz * vx - ux * vz, ux * vy - uy * vx);
  };
  var vAxis = new Uint8Array(pos.count);
  for (var i = 0; i < pos.count; i++) vAxis[i] = projAxis(nrm.getX(i), nrm.getY(i), nrm.getZ(i));
  var uv = new Float32Array(pos.count * 2);
  var tmp = [0, 0];
  for (var _i = 0; _i < pos.count; _i++) {
    project(_i, vAxis[_i], tmp);
    uv[_i * 2] = tmp[0];
    uv[_i * 2 + 1] = tmp[1];
  }
  if (!idx) {
    for (var _i2 = 0; _i2 + 2 < pos.count; _i2 += 3) {
      if (vAxis[_i2] === vAxis[_i2 + 1] && vAxis[_i2 + 1] === vAxis[_i2 + 2]) continue;
      var ax = faceAxis(_i2, _i2 + 1, _i2 + 2);
      for (var k = 0; k < 3; k++) {
        project(_i2 + k, ax, tmp);
        uv[(_i2 + k) * 2] = tmp[0];
        uv[(_i2 + k) * 2 + 1] = tmp[1];
      }
    }
    geometry.setAttribute("uv", new THREE.BufferAttribute(uv, 2));
    return;
  }
  var index = Array.from(idx.array);
  var exPos = [],
    exNrm = [],
    exUV = [];
  var next = pos.count;
  for (var _i3 = 0; _i3 + 2 < index.length; _i3 += 3) {
    var tri = [index[_i3], index[_i3 + 1], index[_i3 + 2]];
    if (vAxis[tri[0]] === vAxis[tri[1]] && vAxis[tri[1]] === vAxis[tri[2]]) continue;
    var _ax = faceAxis(tri[0], tri[1], tri[2]);
    for (var _k = 0; _k < 3; _k++) {
      var s = tri[_k];
      exPos.push(pos.getX(s), pos.getY(s), pos.getZ(s));
      exNrm.push(nrm.getX(s), nrm.getY(s), nrm.getZ(s));
      project(s, _ax, tmp);
      exUV.push(tmp[0], tmp[1]);
      index[_i3 + _k] = next++;
    }
  }
  if (!exPos.length) {
    geometry.setAttribute("uv", new THREE.BufferAttribute(uv, 2));
    return;
  }
  var total = pos.count + exPos.length / 3;
  var P = new Float32Array(total * 3),
    N = new Float32Array(total * 3),
    U = new Float32Array(total * 2);
  P.set(pos.array.subarray(0, pos.count * 3));
  P.set(exPos, pos.count * 3);
  N.set(nrm.array.subarray(0, pos.count * 3));
  N.set(exNrm, pos.count * 3);
  U.set(uv);
  U.set(exUV, pos.count * 2);
  geometry.setAttribute("position", new THREE.BufferAttribute(P, 3));
  geometry.setAttribute("normal", new THREE.BufferAttribute(N, 3));
  geometry.setAttribute("uv", new THREE.BufferAttribute(U, 2));
  geometry.setIndex(new THREE.BufferAttribute(new Uint32Array(index), 1));
}
var swatchCache = new Map();
function downscaleSwatch(url, size) {
  if (swatchCache.has(url)) return Promise.resolve(swatchCache.get(url));
  return new Promise(function (resolve) {
    var img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = function () {
      try {
        var w = img.width,
          h = img.height;
        var c = document.createElement("canvas");
        c.width = w;
        c.height = h;
        c.getContext("2d").drawImage(img, 0, 0);
        while (w / 2 > size) {
          w = Math.max(1, Math.floor(w / 2));
          h = Math.max(1, Math.floor(h / 2));
          var nx = document.createElement("canvas");
          nx.width = w;
          nx.height = h;
          var g = nx.getContext("2d");
          g.imageSmoothingQuality = "high";
          g.drawImage(c, 0, 0, w, h);
          c = nx;
        }
        var out = document.createElement("canvas");
        out.width = size;
        out.height = size;
        var g2 = out.getContext("2d");
        g2.imageSmoothingQuality = "high";
        g2.drawImage(c, 0, 0, size, size);
        var data = out.toDataURL("image/png");
        swatchCache.set(url, data);
        resolve(data);
      } catch (e) {
        resolve(null);
      }
    };
    img.onerror = function () {
      return resolve(null);
    };
    img.src = url;
  });
}
function FabricSwatch(_ref) {
  var url = _ref.url,
    hex = _ref.hex,
    size = _ref.size,
    active = _ref.active;
  var _useState = useState(function () {
      return swatchCache.get(url) || null;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    src = _useState2[0],
    setSrc = _useState2[1];
  useEffect(function () {
    if (!url) return undefined;
    var alive = true;
    downscaleSwatch(url, Math.round(size * 2)).then(function (d) {
      if (alive && d) setSrc(d);
    });
    return function () {
      alive = false;
    };
  }, [url, size]);
  var bg = src ? "center/cover url(".concat(src, ")") : hex;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: size,
      height: size,
      borderRadius: "50%",
      background: bg,
      border: active ? "2px solid #000" : "2px solid transparent",
      boxShadow: active ? "0 0 0 2px #fff, 0 0 0 4px #000" : "0 1px 3px rgba(0,0,0,0.12)",
      transition: "box-shadow 0.15s"
    }
  });
}
function ViewSwitch(_ref2) {
  var mode = _ref2.mode,
    onChange = _ref2.onChange,
    isMobile = _ref2.isMobile;
  var pad = isMobile ? 3 : 5;
  var W = isMobile ? 36 : 50;
  var knob = W - pad * 2;
  var travel = knob;
  var H = pad * 2 + knob * 2;
  var fs = isMobile ? 11 : 13;
  var on = mode === "3d";
  var dragRef = useRef(null);
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    y = _useState4[0],
    setY = _useState4[1]; // live offset while dragging

  var OVER = isMobile ? 3 : 4;
  var rubber = function rubber(raw) {
    if (raw >= 0 && raw <= travel) return raw;
    var x = raw < 0 ? -raw : raw - travel;
    var r = OVER * (1 - 1 / (x * 0.55 / OVER + 1));
    return raw < 0 ? -r : travel + r;
  };
  var begin = function begin(clientY, ts) {
    dragRef.current = {
      sy: clientY,
      ly: clientY,
      lt: ts,
      v: 0,
      moved: false,
      base: on ? travel : 0,
      y: on ? travel : 0
    };
    setY(on ? travel : 0);
  };
  var moveTo = function moveTo(clientY, ts) {
    var d = dragRef.current;
    if (!d) return;
    var delta = clientY - d.sy;
    if (!d.moved && Math.abs(delta) < 3) return;
    d.moved = true;
    d.y = rubber(d.base + delta);
    var dt = ts - d.lt;
    if (dt > 0) d.v = (clientY - d.ly) / dt; // px per ms, signed
    d.ly = clientY;
    d.lt = ts;
    setY(d.y);
  };
  var finish = function finish() {
    var d = dragRef.current;
    if (!d) return;
    dragRef.current = null;
    setY(null);
    var next = !d.moved ? !on : Math.abs(d.v) > 0.4 ? d.v > 0 : d.y > travel / 2;
    if (next !== on) onChange(next ? "3d" : "2d");
  };
  var onTouchStart = function onTouchStart(e) {
    e.stopPropagation();
    var t = e.touches[0];
    if (t) begin(t.clientY, e.timeStamp);
  };
  var onTouchMove = function onTouchMove(e) {
    if (!dragRef.current) return;
    e.stopPropagation();
    if (e.cancelable) e.preventDefault();
    var t = e.touches[0];
    if (t) moveTo(t.clientY, e.timeStamp);
  };
  var onTouchEnd = function onTouchEnd(e) {
    if (!dragRef.current) return;
    e.stopPropagation();
    finish();
  };
  var onPointerDown = function onPointerDown(e) {
    if (e.pointerType === "touch") return;
    e.stopPropagation();
    try {
      e.currentTarget.setPointerCapture(e.pointerId);
    } catch (err) {}
    begin(e.clientY, e.timeStamp);
  };
  var onPointerMove = function onPointerMove(e) {
    if (!dragRef.current || e.pointerType === "touch") return;
    e.stopPropagation();
    moveTo(e.clientY, e.timeStamp);
  };
  var onPointerUp = function onPointerUp(e) {
    if (!dragRef.current) return;
    if (e && e.pointerType === "touch") return;
    if (e && e.stopPropagation) e.stopPropagation();
    finish();
  };
  var onKeyDown = function onKeyDown(e) {
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault();
      onChange(on ? "2d" : "3d");
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      if (!on) onChange("3d");
    }
    if (e.key === "ArrowUp") {
      e.preventDefault();
      if (on) onChange("2d");
    }
  };
  var ty = y == null ? on ? travel : 0 : y;
  var glide = y == null ? "transform .45s cubic-bezier(.3,1.2,.4,1)" : "none";
  var labels = function labels(color) {
    return /*#__PURE__*/React.createElement("div", {
      "aria-hidden": "true",
      style: {
        position: "absolute",
        left: 0,
        top: 0,
        width: W,
        height: H,
        color: color,
        fontSize: fs,
        fontWeight: 500,
        lineHeight: 1,
        letterSpacing: "0.02em",
        pointerEvents: "none"
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        position: "absolute",
        left: 0,
        right: 0,
        textAlign: "center",
        top: pad + knob / 2 - fs / 2
      }
    }, "2D"), /*#__PURE__*/React.createElement("span", {
      style: {
        position: "absolute",
        left: 0,
        right: 0,
        textAlign: "center",
        top: pad + knob + knob / 2 - fs / 2
      }
    }, "3D"));
  };
  return /*#__PURE__*/React.createElement("div", {
    role: "switch",
    "aria-checked": on,
    "aria-label": "2D / 3D",
    tabIndex: 0,
    onPointerDown: onPointerDown,
    onPointerMove: onPointerMove,
    onPointerUp: onPointerUp,
    onPointerCancel: onPointerUp,
    onLostPointerCapture: onPointerUp,
    onTouchStart: onTouchStart,
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd,
    onTouchCancel: onTouchEnd,
    onKeyDown: onKeyDown,
    style: {
      position: "relative",
      width: W,
      height: H,
      borderRadius: H / 2,
      background: "rgba(255,255,255,0.94)",
      boxSizing: "border-box",
      boxShadow: "0 0 0 0.5px #E0E0E0",
      cursor: y == null ? "grab" : "grabbing",
      touchAction: "none",
      userSelect: "none",
      WebkitUserSelect: "none",
      WebkitTapHighlightColor: "transparent",
      outline: "none"
    }
  }, labels("#000"), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: pad,
      top: pad,
      width: knob,
      height: knob,
      borderRadius: "50%",
      background: BRAND,
      overflow: "hidden",
      transform: "translateY(".concat(ty, "px)"),
      transition: glide
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: -pad,
      top: -pad,
      transform: "translateY(".concat(-ty, "px)"),
      transition: glide
    }
  }, labels("#fff"))));
}
function applyFabricMaterials(root, fabricObj, fabHexFallback, carrier) {
  var loader = carrier.texLoader || (carrier.texLoader = new THREE.TextureLoader());
  var cache = carrier.texCache || (carrier.texCache = {});
  var pending = [];
  var rep = (fabricObj === null || fabricObj === void 0 ? void 0 : fabricObj.repeat) || 1.4;
  var loadMap = function loadMap(url) {
    var entry = cache[url];
    if (!entry) {
      entry = {
        tex: null,
        done: false,
        promise: null
      };
      entry.promise = new Promise(function (res) {
        entry.tex = loader.load(assetUrl(url), function () {
          entry.done = true;
          res();
        }, undefined, function () {
          entry.done = true;
          if (cache[url] === entry) delete cache[url];
          res();
        });
      });
      entry.tex.wrapS = entry.tex.wrapT = THREE.RepeatWrapping;
      entry.tex.repeat.set(rep, rep);
      if (fabricObj !== null && fabricObj !== void 0 && fabricObj.anisotropic && carrier.renderer && carrier.renderer.capabilities) {
        entry.tex.anisotropy = carrier.renderer.capabilities.getMaxAnisotropy();
      }
      cache[url] = entry;
    }
    if (!entry.done) pending.push(entry.promise);
    return entry.tex;
  };
  root.traverse(function (obj) {
    if (!obj.isMesh) return;
    var nm = (obj.name || "").toLowerCase();
    if (nm.includes("plastic") || nm.includes("cylinder")) {
      ensureFabricGeometry(obj.geometry, false);
      obj.material = new THREE.MeshStandardMaterial({
        color: 0x1a1a1a,
        roughness: 0.6,
        side: THREE.DoubleSide
      });
      return;
    }
    if (nm.includes("wszywka") || nm.includes("label") || nm.includes("tag")) {
      obj.visible = false;
      return;
    }
    ensureFabricGeometry(obj.geometry, true);
    var opts = {
      color: 0xffffff,
      roughness: 0.85,
      metalness: 0,
      side: THREE.DoubleSide
    };
    if (fabricObj !== null && fabricObj !== void 0 && fabricObj.texture) {
      opts.map = loadMap(fabricObj.texture);
      if (fabricObj.normalMap) opts.normalMap = loadMap(fabricObj.normalMap);
      if (fabricObj.roughnessMap) {
        opts.roughnessMap = loadMap(fabricObj.roughnessMap);
        opts.roughness = 1;
      }
      if (fabricObj.metalnessMap) {
        opts.metalnessMap = loadMap(fabricObj.metalnessMap);
        opts.metalness = 1;
      }
    } else {
      opts.color = new THREE.Color(fabHexFallback || "#D4C4A8");
    }
    obj.material = new THREE.MeshStandardMaterial(opts);
  });
  return Promise.all(pending);
}
var ICON_BOX_W = 66,
  ICON_BOX_H = 48;
var ICON_SCALE = ICON_BOX_W / Math.max.apply(null, MODULE_DEFS.map(function (m) {
  return m.w;
}));
var MODULE_TO_SHOPIFY = {
  "left": "Left",
  "middle": "Middle",
  "right": "Right",
  "corner": "Corner",
  "pouf": "Pouf",
  "chaise-l": "Chaise Left",
  "chaise-r": "Chaise Right",
  "long-l": "Long Left",
  "long-r": "Long Right"
};
var VARIANT_IDS = {
  "miami-beige": {
    "Left": "44647345356969",
    "Middle": "44647345455273",
    "Right": "44647345553577",
    "Corner": "46723640000681",
    "Pouf": "44647345651881",
    "Chaise Left": "45434918830249",
    "Chaise Right": "45434918863017",
    "Long Left": "45434918895785",
    "Long Right": "45434918928553"
  },
  "stone-black": {
    "Left": "44652967723177",
    "Middle": "44652967854249",
    "Right": "44652967985321",
    "Corner": "46723724869801",
    "Pouf": "44652968116393",
    "Chaise Left": "45433825296553",
    "Chaise Right": "45433825329321",
    "Long Left": "45433825362089",
    "Long Right": "45433825394857"
  },
  "orange-fall": {
    "Left": "44652964610217",
    "Middle": "44652964741289",
    "Right": "44652964872361",
    "Corner": "46723641540777",
    "Pouf": "44652965003433",
    "Chaise Left": "45434896154793",
    "Chaise Right": "45434896187561",
    "Long Left": "45434896220329",
    "Long Right": "45434896253097"
  },
  "light-green": {
    "Left": "44652965822633",
    "Middle": "44652965953705",
    "Right": "44652966084777",
    "Corner": "46723642228905",
    "Pouf": "44652966215849",
    "Chaise Left": "45434881736873",
    "Chaise Right": "45434881769641",
    "Long Left": "45434881802409",
    "Long Right": "45434881835177"
  },
  "maroon-red": {
    "Left": "45182561550505",
    "Middle": "45182561583273",
    "Right": "45182561616041",
    "Corner": "46723726704809",
    "Pouf": "45182561648809",
    "Chaise Left": "45573070225577",
    "Chaise Right": "45573070291113",
    "Long Left": "45573070192809",
    "Long Right": "45573070258345"
  },
  "mocha-brown": {
    "Left": "45782535012521",
    "Middle": "45782535045289",
    "Right": "45782535078057",
    "Corner": "46723729588393",
    "Pouf": "45782535110825",
    "Chaise Left": "45782535176361",
    "Chaise Right": "45782535209129",
    "Long Left": "45782535143593",
    "Long Right": "45782535241897"
  },
  "colourwash-marzipan": {
    "Left": "46979749380265",
    "Middle": "46979749413033",
    "Right": "46979749445801",
    "Corner": "46979749642409",
    "Pouf": "46979749478569",
    "Chaise Left": "46979749544105",
    "Chaise Right": "46979749576873",
    "Long Left": "46979749511337",
    "Long Right": "46979749609641"
  },
  "colourwash-earth": {
    "Left": "46979785261225",
    "Middle": "46979785293993",
    "Right": "46979785326761",
    "Corner": "46979785523369",
    "Pouf": "46979785359529",
    "Chaise Left": "46979785425065",
    "Chaise Right": "46979785457833",
    "Long Left": "46979785392297",
    "Long Right": "46979785490601"
  },
  "colourwash-hedge": {
    "Left": "46979803906217",
    "Middle": "46979803938985",
    "Right": "46979803971753",
    "Corner": "46979804168361",
    "Pouf": "46979804004521",
    "Chaise Left": "46979804070057",
    "Chaise Right": "46979804102825",
    "Long Left": "46979804037289",
    "Long Right": "46979804135593"
  },
  "colourwash-terra": {
    "Left": "46979813998761",
    "Middle": "46979814031529",
    "Right": "46979814064297",
    "Corner": "46979814260905",
    "Pouf": "46979814097065",
    "Chaise Left": "46979814162601",
    "Chaise Right": "46979814195369",
    "Long Left": "46979814129833",
    "Long Right": "46979814228137"
  }
};
var STORE_URL = "https://feum.eu";
function getLeadTime(fabricId) {
  var raw = typeof window !== "undefined" && window.FEUM_LEAD_TIMES ? window.FEUM_LEAD_TIMES[fabricId] : null;
  var text = flattenRichText(raw);
  return text || null;
}
function shopifyPriceCents(fabricId, moduleId) {
  if (typeof window === "undefined" || !window.FEUM_PRICES) return null;
  var perFabric = window.FEUM_PRICES[fabricId];
  if (!perFabric) return null;
  var cents = perFabric[MODULE_TO_SHOPIFY[moduleId]];
  return typeof cents === "number" && cents > 0 ? cents : null;
}
function shopCurrency() {
  return typeof window !== "undefined" && window.FEUM_CURRENCY || "EUR";
}
var BASE_CURRENCY = "PLN";
var REQUIRE_LIVE_PRICES = false;
function setPricesUsable(fabricId) {
  return priceCurrency(fabricId) === BASE_CURRENCY;
}
function liveModulePricesComplete(fabricId) {
  if (typeof window === "undefined" || !window.FEUM_PRICES) return false;
  var pf = window.FEUM_PRICES[fabricId];
  if (!pf) return false;
  return Object.values(MODULE_TO_SHOPIFY).every(function (k) {
    return typeof pf[k] === "number" && pf[k] > 0;
  });
}
function priceCurrency(fabricId) {
  var shop = shopCurrency();
  if (shop === BASE_CURRENCY) return shop;
  return liveModulePricesComplete(fabricId) ? shop : BASE_CURRENCY;
}
function feedPricesUsable(fabricId) {
  return priceCurrency(fabricId) === shopCurrency();
}
function priceDiag() {
  var d = typeof window !== "undefined" && window.FEUM_PRICE_DIAG || null;
  if (!d) return {
    present: false,
    locale: "?",
    currency: "?",
    missing: []
  };
  var miss = (d.missing || []).filter(Boolean);
  return {
    present: true,
    locale: d.locale || "?",
    currency: d.currency || "?",
    missing: miss
  };
}
function livePricesAvailable(fabricId) {
  if (typeof window === "undefined" || !window.FEUM_PRICES) return false;
  var pf = window.FEUM_PRICES[fabricId];
  if (!pf) return false;
  for (var k in pf) if (typeof pf[k] === "number" && pf[k] > 0) return true;
  return false;
}
function flattenRichText(node) {
  if (node == null) return "";
  if (typeof node === "string") return node.trim();
  if (typeof node === "number" || typeof node === "boolean") return String(node);
  if (Array.isArray(node)) {
    var _iterator = _createForOfIteratorHelper(node),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        var found = flattenRichText(item);
        if (found) return found;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return "";
  }
  if (_typeof(node) === "object") {
    if (typeof node.value === "string") return node.value.trim();
    if (node.children) return flattenRichText(node.children);
    for (var _i4 = 0, _Object$entries = Object.entries(node); _i4 < _Object$entries.length; _i4++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i4], 2),
        key = _Object$entries$_i[0],
        val = _Object$entries$_i[1];
      if (key === "type" || key === "__typename") continue;
      var _found = flattenRichText(val);
      if (_found) return _found;
    }
  }
  return "";
}
var SET_VARIANTS_STATIC = {
  "2-seater": {
    "miami-beige": {
      "id": 44650318299305,
      "price": 549500
    },
    "stone-black": {
      "id": 44652329042089,
      "price": 549500
    },
    "orange-fall": {
      "id": 44652344213673,
      "price": 549500
    },
    "light-green": {
      "id": 44652346474665,
      "price": 549500
    },
    "maroon-red": {
      "id": 45182155456681,
      "price": 549500
    },
    "mocha-brown": {
      "id": 45782533570729,
      "price": 549500
    },
    "colourwash-marzipan": {
      "id": 46979607363753,
      "price": 657800
    },
    "colourwash-earth": {
      "id": 46979615064233,
      "price": 657800
    },
    "colourwash-hedge": {
      "id": 46979618504873,
      "price": 657800
    },
    "colourwash-terra": {
      "id": 46979618603177,
      "price": 657800
    }
  },
  "3-seater": {
    "miami-beige": {
      "id": 44652198166697,
      "price": 749500
    },
    "stone-black": {
      "id": 44670437228713,
      "price": 749500
    },
    "orange-fall": {
      "id": 44670437294249,
      "price": 749500
    },
    "light-green": {
      "id": 44670437097641,
      "price": 749500
    },
    "maroon-red": {
      "id": 45182193336489,
      "price": 749500
    },
    "mocha-brown": {
      "id": 45782529147049,
      "price": 749500
    },
    "colourwash-marzipan": {
      "id": 46979635773609,
      "price": 877000
    },
    "colourwash-earth": {
      "id": 46979643605161,
      "price": 877000
    },
    "colourwash-hedge": {
      "id": 46979636494505,
      "price": 877000
    },
    "colourwash-terra": {
      "id": 46979644981417,
      "price": 877000
    }
  },
  "3-seater-corner": {
    "miami-beige": {
      "id": 44712029356201,
      "price": 864500
    },
    "stone-black": {
      "id": 44712036794537,
      "price": 864500
    },
    "orange-fall": {
      "id": 44712037482665,
      "price": 864500
    },
    "light-green": {
      "id": 44712032370857,
      "price": 864500
    },
    "maroon-red": {
      "id": 45182195597481,
      "price": 864500
    },
    "mocha-brown": {
      "id": 45782532620457,
      "price": 864500
    },
    "colourwash-marzipan": {
      "id": 46979650977961,
      "price": 1042200
    },
    "colourwash-earth": {
      "id": 46979661004969,
      "price": 1042200
    },
    "colourwash-hedge": {
      "id": 46979662479529,
      "price": 1042200
    },
    "colourwash-terra": {
      "id": 46979664511145,
      "price": 1042200
    }
  },
  "4-seater-corner": {
    "miami-beige": {
      "id": 46781071556777,
      "price": 986500
    },
    "stone-black": {
      "id": 46781072539817,
      "price": 986500
    },
    "orange-fall": {
      "id": 46781074505897,
      "price": 986500
    },
    "light-green": {
      "id": 46781077225641,
      "price": 986500
    },
    "maroon-red": {
      "id": 46781087154345,
      "price": 986500
    },
    "mocha-brown": {
      "id": 46733059424425,
      "price": 986500
    },
    "colourwash-marzipan": {
      "id": 46979668115625,
      "price": 1180500
    },
    "colourwash-earth": {
      "id": 46979668541609,
      "price": 1180500
    },
    "colourwash-hedge": {
      "id": 46979688890537,
      "price": 1180500
    },
    "colourwash-terra": {
      "id": 46979699015849,
      "price": 1180500
    }
  },
  "ottoman-corner-left": {
    "miami-beige": {
      "id": 45179626881193,
      "price": 781500
    },
    "stone-black": {
      "id": 45024851886249,
      "price": 781500
    },
    "orange-fall": {
      "id": 45179627995305,
      "price": 781500
    },
    "light-green": {
      "id": 45024854999209,
      "price": 781500
    },
    "maroon-red": {
      "id": 45024853295273,
      "price": 781500
    },
    "mocha-brown": {
      "id": 45782489170089,
      "price": 781500
    },
    "colourwash-marzipan": {
      "id": 46962727616681,
      "price": 937800
    },
    "colourwash-earth": {
      "id": 46978323808425,
      "price": 937800
    },
    "colourwash-hedge": {
      "id": 46978323906729,
      "price": 937800
    },
    "colourwash-terra": {
      "id": 46978323939497,
      "price": 937800
    }
  },
  "ottoman-corner-right": {
    "miami-beige": {
      "id": 45024775995561,
      "price": 781500
    },
    "stone-black": {
      "id": 45179627339945,
      "price": 781500
    },
    "orange-fall": {
      "id": 45024854311081,
      "price": 781500
    },
    "light-green": {
      "id": 45179627667625,
      "price": 781500
    },
    "maroon-red": {
      "id": 45179627471017,
      "price": 781500
    },
    "mocha-brown": {
      "id": 45782521938089,
      "price": 781500
    },
    "colourwash-marzipan": {
      "id": 46978332393641,
      "price": 937800
    },
    "colourwash-earth": {
      "id": 46978332917929,
      "price": 937800
    },
    "colourwash-hedge": {
      "id": 46978333049001,
      "price": 937800
    },
    "colourwash-terra": {
      "id": 46978334884009,
      "price": 937800
    }
  }
};
function setsFeedPresent() {
  if (Object.keys(SET_VARIANTS_STATIC).length > 0) return true;
  return typeof window !== "undefined" && window.FEUM_SETS && Object.keys(window.FEUM_SETS).length > 0;
}
function setVariant(setId, fabricId) {
  var st = SET_VARIANTS_STATIC[setId];
  var sv = st && st[fabricId];
  var live = typeof window !== "undefined" && window.FEUM_SETS && window.FEUM_SETS[setId];
  var lv = live && live[fabricId];
  if (sv && sv.id) {
    if (feedPricesUsable(fabricId)) {
      if (lv && typeof lv.price === "number" && lv.price > 0) return {
        id: sv.id,
        price: lv.price
      };
      var feed = typeof window !== "undefined" && window.FEUM_SET_PRICES;
      var tier = feed && feed[fabricTier(fabricId)];
      var _live = tier && tier[setId];
      if (typeof _live === "number" && _live > 0) return {
        id: sv.id,
        price: _live
      };
    }
    return setPricesUsable(fabricId) ? sv : {
      id: sv.id,
      price: null
    };
  }
  return lv && lv.id ? lv : null;
}
function fabricTier(fabricId) {
  return String(fabricId || "").indexOf("colourwash") === 0 ? "colourwash" : "standard";
}
function setLivePrice(setId, fabricId) {
  var feed = typeof window !== "undefined" && window.FEUM_SET_PRICES;
  var tier = feed && feed[fabricTier(fabricId)];
  var p = tier && tier[setId];
  if (feedPricesUsable(fabricId) && typeof p === "number" && p > 0) return p;
  var v = setVariant(setId, fabricId);
  return v && typeof v.price === "number" && v.price > 0 ? v.price : null;
}
function buildCartPermalink(mods, fabricId, addons) {
  var _FABRICS$find;
  var map = VARIANT_IDS[fabricId];
  if (!map) return null;
  var counts = {};
  var moduleCounts = {};
  var _iterator2 = _createForOfIteratorHelper(mods),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _m = _step2.value;
      moduleCounts[_m.mid] = (moduleCounts[_m.mid] || 0) + 1;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var fabMult = ((_FABRICS$find = FABRICS.find(function (f) {
    return f.id === fabricId;
  })) === null || _FABRICS$find === void 0 ? void 0 : _FABRICS$find.mult) || 1;
  var pricing = setAwareTotal(moduleCounts, function (mid) {
    var _shopifyPriceCents, _MODULE_DEFS$find;
    return (_shopifyPriceCents = shopifyPriceCents(fabricId, mid)) !== null && _shopifyPriceCents !== void 0 ? _shopifyPriceCents : Math.round((((_MODULE_DEFS$find = MODULE_DEFS.find(function (d) {
      return d.id === mid;
    })) === null || _MODULE_DEFS$find === void 0 ? void 0 : _MODULE_DEFS$find.base) || 0) * fabMult);
  }, fabricId);
  var setsUsable = pricing.sets.length > 0 && pricing.sets.every(function (st) {
    return setVariant(st.id, fabricId);
  });
  if (setsUsable) {
    var _iterator3 = _createForOfIteratorHelper(pricing.sets),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var st = _step3.value;
        var _vid = setVariant(st.id, fabricId).id;
        counts[_vid] = (counts[_vid] || 0) + 1;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    for (var _i5 = 0, _Object$entries2 = Object.entries(pricing.leftover); _i5 < _Object$entries2.length; _i5++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i5], 2),
        mid = _Object$entries2$_i[0],
        n = _Object$entries2$_i[1];
      var vid = MODULE_TO_SHOPIFY[mid] && map[MODULE_TO_SHOPIFY[mid]];
      if (vid) counts[vid] = (counts[vid] || 0) + n;
    }
  } else {
    var _iterator4 = _createForOfIteratorHelper(mods),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var m = _step4.value;
        var sn = MODULE_TO_SHOPIFY[m.mid];
        var _vid2 = sn && map[sn];
        if (_vid2) counts[_vid2] = (counts[_vid2] || 0) + 1;
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
  var _iterator5 = _createForOfIteratorHelper(addons || []),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var a = _step5.value;
      var _vid3 = addonVariantId(a);
      if (_vid3 && a.qty > 0) counts[_vid3] = (counts[_vid3] || 0) + a.qty;
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  if (!Object.keys(counts).length) return null;
  return "".concat(STORE_URL, "/cart/").concat(Object.entries(counts).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      id = _ref4[0],
      q = _ref4[1];
    return "".concat(id, ":").concat(q);
  }).join(","), "?return_to=/cart");
}
function buildShoppingList(mods, fabricLabel, addonsLines, nazwaModulu) {
  var counts = {};
  var _iterator6 = _createForOfIteratorHelper(mods),
    _step6;
  try {
    var _loop = function _loop() {
      var m = _step6.value;
      var d = MODULE_DEFS.find(function (dd) {
        return dd.id === m.mid;
      });
      if (d) {
        var n = nazwaModulu ? nazwaModulu(d) : d.label;
        counts[n] = (counts[n] || 0) + 1;
      }
    };
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  var lines = Object.entries(counts).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      n = _ref6[0],
      q = _ref6[1];
    return "".concat(q, "\xD7 ").concat(n);
  });
  if (addonsLines && addonsLines.length) lines.push.apply(lines, _toConsumableArray(addonsLines));
  return "Umi Configuration (".concat(fabricLabel, "):\n").concat(lines.join("\n"));
}
var MAX_MODULES = 16;
var BRAND = "#825150";
var SIDEBAR_MIN = 330,
  SIDEBAR_MAX = 760;
var CM2PX = 1.2;
var BAKE_PAD = 1.02;
var RENDER_OVERLAP_CM = 0.96;
var OVERLAP_3D_CM = 1.7;
var LONG_ARM_CM = 5.7;
function snugScale(px) {
  return px > 0 ? BAKE_PAD * (px + 2 * RENDER_OVERLAP_CM * CM2PX) / px : BAKE_PAD;
}
var SNAP_T = 28;
var SNAP_TSQ = SNAP_T * SNAP_T;
function rotPt(px, py, cx, cy, a) {
  a = (a % 360 + 360) % 360;
  var dx = px - cx,
    dy = py - cy;
  if (a === 0) return [cx + dx, cy + dy];
  if (a === 90) return [cx - dy, cy + dx];
  if (a === 180) return [cx - dx, cy - dy];
  return [cx + dy, cy - dx];
}
function worldConns(p, def, conns) {
  var sw = p.rot === 90 || p.rot === 270;
  var rw = (sw ? def.d : def.w) * CM2PX; // rotated width in px
  var rh = (sw ? def.w : def.d) * CM2PX; // rotated height in px
  var ucx = def.w * CM2PX / 2; // unrotated center x
  var ucy = def.d * CM2PX / 2; // unrotated center y

  var wcx = p.x + rw / 2;
  var wcy = p.y + rh / 2;
  var occ = new Set();
  conns.forEach(function (c) {
    occ.add("".concat(c.a.iid, ":").concat(c.a.cid));
    occ.add("".concat(c.b.iid, ":").concat(c.b.cid));
  });
  return def.connectors.map(function (c) {
    var _rotPt = rotPt(c.x * CM2PX, c.y * CM2PX, ucx, ucy, p.rot),
      _rotPt2 = _slicedToArray(_rotPt, 2),
      rx = _rotPt2[0],
      ry = _rotPt2[1];
    var wx = wcx + (rx - ucx);
    var wy = wcy + (ry - ucy);
    return {
      cid: c.id,
      iid: p.iid,
      wx: wx,
      wy: wy,
      wdir: (c.dir + p.rot) % 360,
      dir: c.dir,
      type: c.type,
      accepts: c.accepts,
      secondary: !!c.secondary,
      occupied: occ.has("".concat(p.iid, ":").concat(c.id))
    };
  });
}
function isCompat(a, b) {
  var _COMPAT$a$type, _COMPAT$b$type;
  if (a.occupied || b.occupied) return false;
  if (!((_COMPAT$a$type = COMPAT[a.type]) !== null && _COMPAT$a$type !== void 0 && _COMPAT$a$type.includes(b.type)) || !((_COMPAT$b$type = COMPAT[b.type]) !== null && _COMPAT$b$type !== void 0 && _COMPAT$b$type.includes(a.type))) return false;
  return Math.abs(a.wdir - b.wdir) === 180;
}
function modBBox(m, def) {
  var sw = m.rot === 90 || m.rot === 270;
  var w = (sw ? def.d : def.w) * CM2PX,
    h = (sw ? def.w : def.d) * CM2PX;
  return {
    x1: m.x,
    y1: m.y,
    x2: m.x + w,
    y2: m.y + h
  };
}
function bboxHit(a, b) {
  return a.x1 < b.x2 - 2 && a.x2 > b.x1 + 2 && a.y1 < b.y2 - 2 && a.y2 > b.y1 + 2;
}
function colCheck(test, tDef, others, skipIid) {
  var tb = modBBox(test, tDef);
  var _iterator7 = _createForOfIteratorHelper(others),
    _step7;
  try {
    var _loop2 = function _loop2() {
        var o = _step7.value;
        if (o.iid === test.iid || o.iid === skipIid) return 0; // continue
        var od = MODULE_DEFS.find(function (d) {
          return d.id === o.mid;
        });
        if (od && bboxHit(tb, modBBox(o, od))) return {
          v: true
        };
      },
      _ret;
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      _ret = _loop2();
      if (_ret === 0) continue;
      if (_ret) return _ret.v;
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
  return false;
}
function findSnap(dragged, dDef, placed, conns) {
  var dwc = worldConns(dragged, dDef, conns);
  var best = null;
  var _iterator8 = _createForOfIteratorHelper(placed),
    _step8;
  try {
    var _loop3 = function _loop3() {
        var pm = _step8.value;
        if (pm.iid === dragged.iid) return 0; // continue
        var pd = MODULE_DEFS.find(function (d) {
          return d.id === pm.mid;
        });
        if (!pd) return 0; // continue
        var _iterator9 = _createForOfIteratorHelper(worldConns(pm, pd, conns)),
          _step9;
        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var pc = _step9.value;
            var _iterator0 = _createForOfIteratorHelper(dwc),
              _step0;
            try {
              var _loop4 = function _loop4() {
                  var dc = _step0.value;
                  if (!isCompat(pc, dc)) return 0; // continue
                  var dx = pc.wx - dc.wx,
                    dy = pc.wy - dc.wy,
                    dSq = dx * dx + dy * dy;
                  if (dSq > SNAP_TSQ || best && dSq >= best.dSq) return 0; // continue
                  var cDef = dDef.connectors.find(function (c) {
                    return c.id === dc.cid;
                  });
                  if (!cDef) return 0; // continue
                  var sw = dragged.rot === 90 || dragged.rot === 270;
                  var rw = (sw ? dDef.d : dDef.w) * CM2PX;
                  var rh = (sw ? dDef.w : dDef.d) * CM2PX;
                  var ucx = dDef.w * CM2PX / 2,
                    ucy = dDef.d * CM2PX / 2;
                  var _rotPt3 = rotPt(cDef.x * CM2PX, cDef.y * CM2PX, ucx, ucy, dragged.rot),
                    _rotPt4 = _slicedToArray(_rotPt3, 2),
                    rx = _rotPt4[0],
                    ry = _rotPt4[1];
                  var offX = rw / 2 + (rx - ucx);
                  var offY = rh / 2 + (ry - ucy);
                  var sx = pc.wx - offX,
                    sy = pc.wy - offY;
                  if (colCheck(_objectSpread(_objectSpread({}, dragged), {}, {
                    x: sx,
                    y: sy
                  }), dDef, placed, pm.iid)) return 0; // continue
                  best = {
                    tc: pc,
                    dc: dc,
                    sx: sx,
                    sy: sy,
                    rot: dragged.rot,
                    dSq: dSq
                  };
                },
                _ret3;
              for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
                _ret3 = _loop4();
                if (_ret3 === 0) continue;
              }
            } catch (err) {
              _iterator0.e(err);
            } finally {
              _iterator0.f();
            }
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      },
      _ret2;
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      _ret2 = _loop3();
      if (_ret2 === 0) continue;
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
  return best;
}
function findPlacement(moduleId, modules, canvasW, canvasH, zoom, pan, connections) {
  var def = MODULE_DEFS.find(function (d) {
    return d.id === moduleId;
  });
  if (!def) return {
    x: 100,
    y: 100
  };
  var startRot = MODULE_START_ROT[moduleId] || 0;
  var mw = def.w * CM2PX,
    mh = def.d * CM2PX;
  if (modules.length === 0) {
    return {
      x: (canvasW / 2 - pan.x) / zoom - mw / 2,
      y: (canvasH / 2 - pan.y) / zoom - mh / 2,
      rot: startRot
    };
  }
  var conns = def.connectors;
  var cons = connections || [];
  var isSide = function isSide(d) {
    return d === 90 || d === 270;
  };
  var rotCandidates = [startRot, (startRot + 90) % 360, (startRot + 180) % 360, (startRot + 270) % 360];
  var tiers = [function (ec, c, rot, existingRot) {
    return !ec.secondary && !c.secondary && isSide(ec.dir) && isSide(c.dir) && rot === existingRot;
  }, function (ec, c) {
    return !ec.secondary && !c.secondary && !isSide(ec.dir);
  }, function (ec, c) {
    return !ec.secondary && !c.secondary;
  }, function (ec, c) {
    return !c.secondary;
  }, function () {
    return true;
  }];
  for (var _i6 = 0, _tiers = tiers; _i6 < _tiers.length; _i6++) {
    var tierOk = _tiers[_i6];
    var _iterator1 = _createForOfIteratorHelper(rotCandidates),
      _step1;
    try {
      for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
        var rot = _step1.value;
        var _iterator10 = _createForOfIteratorHelper(_toConsumableArray(modules).reverse()),
          _step10;
        try {
          var _loop5 = function _loop5() {
              var existing = _step10.value;
              var eDef = MODULE_DEFS.find(function (d) {
                return d.id === existing.mid;
              });
              if (!eDef) return 0; // continue
              var existingConns = worldConns(existing, eDef, cons);
              var _iterator11 = _createForOfIteratorHelper(existingConns),
                _step11;
              try {
                for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                  var ec = _step11.value;
                  if (ec.occupied) continue;
                  if (moduleId === "pouf" && (existing.mid === "long-l" || existing.mid === "long-r") && isSide(ec.dir)) continue;
                  var _iterator12 = _createForOfIteratorHelper(conns),
                    _step12;
                  try {
                    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                      var _COMPAT$ec$type, _COMPAT$c$type;
                      var c = _step12.value;
                      if (!tierOk(ec, c, rot, existing.rot)) continue;
                      var sw = rot === 90 || rot === 270;
                      var rw = (sw ? def.d : def.w) * CM2PX,
                        rh = (sw ? def.w : def.d) * CM2PX;
                      var ucx = def.w * CM2PX / 2,
                        ucy = def.d * CM2PX / 2;
                      var _rotPt5 = rotPt(c.x * CM2PX, c.y * CM2PX, ucx, ucy, rot),
                        _rotPt6 = _slicedToArray(_rotPt5, 2),
                        rx = _rotPt6[0],
                        ry = _rotPt6[1];
                      var offX = rw / 2 + (rx - ucx),
                        offY = rh / 2 + (ry - ucy);
                      var wdir = (c.dir + rot) % 360;
                      if (!((_COMPAT$ec$type = COMPAT[ec.type]) !== null && _COMPAT$ec$type !== void 0 && _COMPAT$ec$type.includes(c.type)) || !((_COMPAT$c$type = COMPAT[c.type]) !== null && _COMPAT$c$type !== void 0 && _COMPAT$c$type.includes(ec.type))) continue;
                      if (Math.abs(ec.wdir - wdir) !== 180) continue;
                      var _cx = ec.wx - offX,
                        _cy = ec.wy - offY;
                      var testMod = {
                        iid: "_test",
                        mid: moduleId,
                        x: _cx,
                        y: _cy,
                        rot: rot
                      };
                      if (!colCheck(testMod, def, modules, existing.iid)) return {
                        v: {
                          x: _cx,
                          y: _cy,
                          rot: rot
                        }
                      };
                    }
                  } catch (err) {
                    _iterator12.e(err);
                  } finally {
                    _iterator12.f();
                  }
                }
              } catch (err) {
                _iterator11.e(err);
              } finally {
                _iterator11.f();
              }
            },
            _ret4;
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            _ret4 = _loop5();
            if (_ret4 === 0) continue;
            if (_ret4) return _ret4.v;
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }
    } catch (err) {
      _iterator1.e(err);
    } finally {
      _iterator1.f();
    }
  }
  var offsets = [{
    dx: 1,
    dy: 0
  }, {
    dx: 0,
    dy: 1
  }, {
    dx: -1,
    dy: 0
  }, {
    dx: 0,
    dy: -1
  }];
  var _iterator13 = _createForOfIteratorHelper(_toConsumableArray(modules).reverse()),
    _step13;
  try {
    var _loop6 = function _loop6() {
        var existing = _step13.value;
        var eDef = MODULE_DEFS.find(function (d) {
          return d.id === existing.mid;
        });
        if (!eDef) return 0; // continue
        var esw = existing.rot === 90 || existing.rot === 270;
        var ew = (esw ? eDef.d : eDef.w) * CM2PX;
        var eh = (esw ? eDef.w : eDef.d) * CM2PX;
        for (var _i7 = 0, _offsets = offsets; _i7 < _offsets.length; _i7++) {
          var off = _offsets[_i7];
          var tx = existing.x + off.dx * ew;
          var ty = existing.y + off.dy * eh;
          var testMod = {
            iid: "_test",
            mid: moduleId,
            x: tx,
            y: ty,
            rot: startRot
          };
          if (!colCheck(testMod, def, modules)) return {
            v: {
              x: tx,
              y: ty,
              rot: startRot
            }
          };
        }
      },
      _ret5;
    for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
      _ret5 = _loop6();
      if (_ret5 === 0) continue;
      if (_ret5) return _ret5.v;
    }
  } catch (err) {
    _iterator13.e(err);
  } finally {
    _iterator13.f();
  }
  var cx = (canvasW / 2 - pan.x) / zoom - mw / 2;
  var cy = (canvasH / 2 - pan.y) / zoom - mh / 2;
  return {
    x: cx + modules.length * 20,
    y: cy + modules.length * 10,
    rot: startRot
  };
}
function track(event, params) {
  try {
    if (typeof window.gtag === "function") window.gtag("event", event, params || {});else if (Array.isArray(window.dataLayer)) window.dataLayer.push(_objectSpread({
      event: event
    }, params || {}));
  } catch (e) {}
}
var FABRIC_SAMPLES_URL = "https://feum.eu/products/feum-probki-tkanin-standard-01-set";
var ASSET_BASE = typeof window !== "undefined" && window.FEUM_ASSET_BASE || "";
function assetUrl(path) {
  if (!ASSET_BASE) return path;
  return ASSET_BASE + path.replace(/^(models|textures)\//, "").replace(/\//g, "-");
}
var _dracoLoader = null;
function makeGltfLoader() {
  var loader = new THREE.GLTFLoader();
  if (typeof THREE.DRACOLoader === "function") {
    if (!_dracoLoader) {
      _dracoLoader = new THREE.DRACOLoader();
      _dracoLoader.setDecoderPath("https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/libs/draco/gltf/");
    }
    loader.setDRACOLoader(_dracoLoader);
  }
  return loader;
}
function modelUrl(path) {
  var file = path.replace(/^models\//, "");
  var fromShopify = typeof window !== "undefined" && window.FEUM_MODEL_URLS && window.FEUM_MODEL_URLS[file];
  if (fromShopify) return fromShopify;
  return assetUrl(path) + (ASSET_BASE ? "" : "?v=" + MODELS_VERSION);
}
var FEUM_LOGO_URL = assetUrl("feum-logo.svg") + "?v=2";
var SWATCH_PX = 96;
function addonPackshot(variantId, fallbackPath) {
  var zeSklepu = typeof window !== "undefined" && window.FEUM_ADDON_IMAGES && variantId && window.FEUM_ADDON_IMAGES[variantId];
  return zeSklepu || assetUrl(fallbackPath || "");
}
function addonImgError(fallbackPath) {
  return function (e) {
    var lokalny = assetUrl(fallbackPath || "");
    if (fallbackPath && e.target.src !== lokalny) {
      e.target.src = lokalny;
      return;
    }
    e.target.style.visibility = "hidden";
  };
}
function addonImgOk(e) {
  if (e.target.style.visibility) e.target.style.visibility = "";
}
function swatchUrl(path) {
  var url = assetUrl(path);
  if (!ASSET_BASE) return url;
  return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + SWATCH_PX + "&height=" + SWATCH_PX + "&crop=center";
}
function BakePlaceholder(_ref7) {
  var w = _ref7.w,
    h = _ref7.h,
    _ref7$logoScale = _ref7.logoScale,
    logoScale = _ref7$logoScale === void 0 ? 0.45 : _ref7$logoScale,
    _ref7$counterRot = _ref7.counterRot,
    counterRot = _ref7$counterRot === void 0 ? 0 : _ref7$counterRot;
  var lw = Math.max(22, Math.min(w * logoScale, 90));
  var spin = (counterRot % 360 + 360) % 360;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: w,
      height: h,
      boxSizing: "border-box",
      border: "1px dashed #CCCCCC",
      borderRadius: 6,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "rgba(255,255,255,0.4)"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: FEUM_LOGO_URL,
    alt: "",
    style: {
      width: lw,
      display: "block",
      opacity: 0.18,
      transform: spin ? "rotate(".concat(-spin, "deg)") : "none"
    }
  }));
}
function MiniLayout(_ref8) {
  var mods = _ref8.mods,
    _ref8$w = _ref8.w,
    w = _ref8$w === void 0 ? 160 : _ref8$w,
    _ref8$h = _ref8.h,
    h = _ref8$h === void 0 ? 100 : _ref8$h,
    _ref8$fill = _ref8.fill,
    fill = _ref8$fill === void 0 ? "#D8CBB8" : _ref8$fill;
  if (!mods || !mods.length) return null;
  var mnX = 1e9,
    mxX = -1e9,
    mnY = 1e9,
    mxY = -1e9;
  var rs = mods.map(function (m) {
    var d = MODULE_DEFS.find(function (dd) {
      return dd.id === m.mid;
    });
    var sw = m.rot === 90 || m.rot === 270;
    var rw = (sw ? d.d : d.w) * CM2PX,
      rh = (sw ? d.w : d.d) * CM2PX;
    mnX = Math.min(mnX, m.x);
    mxX = Math.max(mxX, m.x + rw);
    mnY = Math.min(mnY, m.y);
    mxY = Math.max(mxY, m.y + rh);
    return {
      x: m.x,
      y: m.y,
      w: rw,
      h: rh
    };
  });
  var k = Math.min(w / (mxX - mnX), h / (mxY - mnY)) * 0.9;
  var ox = (w - (mxX - mnX) * k) / 2,
    oy = (h - (mxY - mnY) * k) / 2;
  return /*#__PURE__*/React.createElement("svg", {
    width: w,
    height: h
  }, rs.map(function (r, i) {
    return /*#__PURE__*/React.createElement("rect", {
      key: i,
      x: ox + (r.x - mnX) * k,
      y: oy + (r.y - mnY) * k,
      width: r.w * k,
      height: r.h * k,
      rx: 3,
      fill: fill,
      stroke: "rgba(0,0,0,0.18)",
      strokeWidth: "1"
    });
  }));
}
var MODULE_SETS = [{
  id: "2-seater",
  label: "2-seater",
  price: 549500,
  mods: {
    "left": 1,
    "right": 1
  }
}, {
  id: "3-seater",
  label: "3-seater",
  price: 749500,
  mods: {
    "left": 1,
    "middle": 1,
    "right": 1
  }
}, {
  id: "3-seater-corner",
  label: "3-seater corner",
  price: 864500,
  mods: {
    "left": 1,
    "right": 1,
    "middle": 1,
    "pouf": 1
  }
}, {
  id: "4-seater-corner",
  label: "4-seater corner",
  price: 986500,
  mods: {
    "middle": 2,
    "corner": 2
  }
}, {
  id: "ottoman-corner-left",
  label: "Ottoman corner left",
  price: 781500,
  mods: {
    "long-l": 1,
    "chaise-l": 1
  }
}, {
  id: "ottoman-corner-right",
  label: "Ottoman corner right",
  price: 781500,
  mods: {
    "long-r": 1,
    "chaise-r": 1
  }
}];
function setAwareTotal(counts, unit, fabricId) {
  var listUnit = function listUnit(mid) {
    var _MODULE_DEFS$find2;
    return ((_MODULE_DEFS$find2 = MODULE_DEFS.find(function (d) {
      return d.id === mid;
    })) === null || _MODULE_DEFS$find2 === void 0 ? void 0 : _MODULE_DEFS$find2.base) || 0;
  };
  if (!unit) unit = listUnit;
  var base = 0;
  Object.entries(counts).forEach(function (_ref9) {
    var _ref0 = _slicedToArray(_ref9, 2),
      mid = _ref0[0],
      n = _ref0[1];
    base += unit(mid) * n;
  });
  var setPriceOf = function setPriceOf(st) {
    var live = fabricId ? setLivePrice(st.id, fabricId) : null;
    if (live != null) return live;
    var listMembers = 0,
      liveMembers = 0;
    Object.entries(st.mods).forEach(function (_ref1) {
      var _ref10 = _slicedToArray(_ref1, 2),
        mid = _ref10[0],
        n = _ref10[1];
      listMembers += listUnit(mid) * n;
      liveMembers += unit(mid) * n;
    });
    var ratio = listMembers > 0 ? st.price / listMembers : 1;
    return Math.round(liveMembers * ratio);
  };
  var memo = new Map();
  var _solve = function solve(rest) {
    var key = Object.keys(rest).sort().map(function (k) {
      return k + rest[k];
    }).join("|");
    var hit = memo.get(key);
    if (hit) return hit;
    var loose = 0;
    Object.entries(rest).forEach(function (_ref11) {
      var _ref12 = _slicedToArray(_ref11, 2),
        mid = _ref12[0],
        n = _ref12[1];
      loose += unit(mid) * n;
    });
    var best = {
      total: loose,
      sets: []
    };
    var _iterator14 = _createForOfIteratorHelper(MODULE_SETS),
      _step14;
    try {
      var _loop7 = function _loop7() {
          var st = _step14.value;
          if (fabricId && setsFeedPresent() && !setVariant(st.id, fabricId)) return 0; // continue
          if (!fabricId || setLivePrice(st.id, fabricId) == null) return 0; // continue
          var fits = true;
          for (var _i8 = 0, _Object$entries3 = Object.entries(st.mods); _i8 < _Object$entries3.length; _i8++) {
            var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i8], 2),
              mid = _Object$entries3$_i[0],
              n = _Object$entries3$_i[1];
            if ((rest[mid] || 0) < n) {
              fits = false;
              break;
            }
          }
          if (!fits) return 0; // continue
          var after = _objectSpread({}, rest);
          Object.entries(st.mods).forEach(function (_ref13) {
            var _ref14 = _slicedToArray(_ref13, 2),
              mid = _ref14[0],
              n = _ref14[1];
            after[mid] -= n;
            if (after[mid] <= 0) delete after[mid];
          });
          var sub = _solve(after);
          var total = setPriceOf(st) + sub.total;
          if (total < best.total) best = {
            total: total,
            sets: [st].concat(sub.sets)
          };
        },
        _ret6;
      for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
        _ret6 = _loop7();
        if (_ret6 === 0) continue;
      }
    } catch (err) {
      _iterator14.e(err);
    } finally {
      _iterator14.f();
    }
    memo.set(key, best);
    return best;
  };
  var clean = {};
  Object.entries(counts).forEach(function (_ref15) {
    var _ref16 = _slicedToArray(_ref15, 2),
      mid = _ref16[0],
      n = _ref16[1];
    if (n > 0) clean[mid] = n;
  });
  var found = _solve(clean);
  var leftover = _objectSpread({}, clean);
  found.sets.forEach(function (st) {
    return Object.entries(st.mods).forEach(function (_ref17) {
      var _ref18 = _slicedToArray(_ref17, 2),
        mid = _ref18[0],
        n = _ref18[1];
      leftover[mid] -= n;
      if (leftover[mid] <= 0) delete leftover[mid];
    });
  });
  return {
    total: found.total,
    savings: base - found.total,
    sets: found.sets,
    leftover: leftover,
    set: found.sets[0] || null // kept: the summary line names a single set
  };
}
var SEAT_VALUES = {
  "left": 1,
  "middle": 1,
  "right": 1,
  "corner": 1,
  "pouf": 0.5,
  "chaise-l": 1.5,
  "chaise-r": 1.5,
  "long-l": 1.5,
  "long-r": 1.5
};
function buildPresetModules(recipe) {
  var mods = [];
  recipe.forEach(function (step, i) {
    var pos = findPlacement(step.mid, mods, 1200, 800, 1, {
      x: 0,
      y: 0
    }, []);
    if (!pos) return;
    mods.push({
      iid: "p" + i,
      mid: step.mid,
      x: pos.x,
      y: pos.y,
      rot: step.rot !== undefined ? step.rot : pos.rot !== undefined ? pos.rot : MODULE_START_ROT[step.mid] || 0
    });
  });
  var mnX = 1e9,
    mnY = 1e9;
  mods.forEach(function (m) {
    mnX = Math.min(mnX, m.x);
    mnY = Math.min(mnY, m.y);
  });
  return mods.map(function (m) {
    return _objectSpread(_objectSpread({}, m), {}, {
      x: m.x - mnX,
      y: m.y - mnY
    });
  });
}
var PRESETS = [{
  id: "twin-corner",
  names: {
    en: "Twin corner",
    pl: "Podwójny narożnik",
    de: "Doppelecke"
  },
  recipe: [{
    mid: "corner"
  }, {
    mid: "corner"
  }]
}, {
  id: "duo-ott-r",
  names: {
    en: "Duo with ottoman R",
    pl: "Duet z leżanką P",
    de: "Duo mit Ottomane R"
  },
  recipe: [{
    mid: "left"
  }, {
    mid: "long-r"
  }]
}, {
  id: "duo-ott-l",
  names: {
    en: "Duo with ottoman L",
    pl: "Duet z leżanką L",
    de: "Duo mit Ottomane L"
  },
  recipe: [{
    mid: "right"
  }, {
    mid: "long-l"
  }]
}, {
  id: "corner-chaise-r",
  names: {
    en: "Corner with chaise R",
    pl: "Narożnik z szezlongiem P",
    de: "Ecke mit Chaiselongue R"
  },
  recipe: [{
    mid: "corner"
  }, {
    mid: "right"
  }, {
    mid: "chaise-r"
  }]
}, {
  id: "corner-chaise-l",
  names: {
    en: "Corner with chaise L",
    pl: "Narożnik z szezlongiem L",
    de: "Ecke mit Chaiselongue L"
  },
  recipe: [{
    mid: "left"
  }, {
    mid: "corner"
  }, {
    mid: "chaise-l"
  }]
}, {
  id: "chaise-duo-l",
  names: {
    en: "Compact chaise L",
    pl: "Szezlong kompakt L",
    de: "Kompakt-Chaiselongue L"
  },
  recipe: [{
    mid: "chaise-l"
  }, {
    mid: "left"
  }]
}, {
  id: "chaise-duo-r",
  names: {
    en: "Compact chaise R",
    pl: "Szezlong kompakt P",
    de: "Kompakt-Chaiselongue R"
  },
  recipe: [{
    mid: "chaise-r"
  }, {
    mid: "right"
  }]
}, {
  id: "trio-ott-r",
  names: {
    en: "Three with ottoman R",
    pl: "Trójka z leżanką P",
    de: "Dreier mit Ottomane R"
  },
  recipe: [{
    mid: "left"
  }, {
    mid: "middle"
  }, {
    mid: "long-r"
  }]
}, {
  id: "trio-ott-l",
  names: {
    en: "Three with ottoman L",
    pl: "Trójka z leżanką L",
    de: "Dreier mit Ottomane L"
  },
  recipe: [{
    mid: "right"
  }, {
    mid: "middle"
  }, {
    mid: "long-l"
  }]
}, {
  id: "horseshoe",
  names: {
    en: "Horseshoe",
    pl: "Podkowa",
    de: "Hufeisen"
  },
  recipe: [{
    mid: "corner"
  }, {
    mid: "corner"
  }, {
    mid: "middle"
  }]
}, {
  id: "duo-pouf",
  names: {
    en: "Duo with pouf",
    pl: "Duet z pufą",
    de: "Duo mit Pouf"
  },
  recipe: [{
    mid: "left"
  }, {
    mid: "right"
  }, {
    mid: "pouf"
  }]
}, {
  id: "classic-corner",
  names: {
    en: "Classic corner",
    pl: "Narożnik klasyczny",
    de: "Klassische Ecke"
  },
  recipe: [{
    mid: "left"
  }, {
    mid: "corner"
  }, {
    mid: "middle"
  }]
}];
var PRESETS_BUILT = PRESETS.map(function (p) {
  var mods = buildPresetModules(p.recipe);
  var mxX = -1e9,
    mxY = -1e9;
  mods.forEach(function (m) {
    var d = MODULE_DEFS.find(function (dd) {
      return dd.id === m.mid;
    });
    var sw = m.rot === 90 || m.rot === 270;
    mxX = Math.max(mxX, m.x + (sw ? d.d : d.w) * CM2PX);
    mxY = Math.max(mxY, m.y + (sw ? d.w : d.d) * CM2PX);
  });
  var seats = p.recipe.reduce(function (sum, st) {
    return sum + (SEAT_VALUES[st.mid] || 1);
  }, 0);
  var rcounts = {};
  p.recipe.forEach(function (st) {
    rcounts[st.mid] = (rcounts[st.mid] || 0) + 1;
  });
  var priceBase = setAwareTotal(rcounts).total;
  return _objectSpread(_objectSpread({}, p), {}, {
    mods: mods,
    dims: {
      w: Math.round(mxX / CM2PX),
      d: Math.round(mxY / CM2PX)
    },
    seats: seats,
    priceBase: priceBase
  });
});
var _uid = 1;
var uid = function uid() {
  return "m".concat(_uid++);
};
var ConfiguratorErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function ConfiguratorErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ConfiguratorErrorBoundary);
    _this = _callSuper(this, ConfiguratorErrorBoundary, [props]);
    _this.state = {
      error: null
    };
    return _this;
  }
  _inherits(ConfiguratorErrorBoundary, _React$Component);
  return _createClass(ConfiguratorErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      console.error("Configurator crashed:", error, info);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.error) return this.props.children;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          fontFamily: "'League Spartan',system-ui,sans-serif",
          padding: 24,
          color: "#1A1A1A"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 16,
          fontWeight: 500,
          marginBottom: 8
        }
      }, "Konfigurator nie m\xF3g\u0142 si\u0119 za\u0142adowa\u0107."), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 13,
          color: "#6B6B6B",
          marginBottom: 16
        }
      }, "Od\u015Bwie\u017C stron\u0119. Je\u015Bli problem si\u0119 powtarza, prze\u015Blij nam poni\u017Cszy komunikat."), /*#__PURE__*/React.createElement("pre", {
        style: {
          fontSize: 11,
          color: "#8A5A3B",
          background: "#FAF7F3",
          border: "0.5px solid #E8DFD5",
          borderRadius: 8,
          padding: 12,
          whiteSpace: "pre-wrap",
          overflowX: "auto"
        }
      }, String(this.state.error && (this.state.error.stack || this.state.error.message || this.state.error))));
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      return {
        error: error
      };
    }
  }]);
}(React.Component);
function CollectionPreview(_ref19) {
  var c = _ref19.c,
    h = _ref19.h,
    bare = _ref19.bare;
  var W = 308,
    D = 98,
    R = 5,
    back = 17,
    gap = 1.5;
  var parts = c.id === "umi" ? [{
    x: 0,
    w: 105,
    arm: "l"
  }, {
    x: 105,
    w: 98
  }, {
    x: 203,
    w: 105,
    arm: "r"
  }] : null;
  var ink = c.available ? "#1A1A1A" : "#B4B0AA";
  var skin = c.available ? "#D8CBB8" : "#EDEBE7";
  if (c.photo) return /*#__PURE__*/React.createElement("span", {
    style: {
      height: h,
      width: "100%",
      borderRadius: bare ? 0 : 8,
      background: bare ? "transparent" : c.available ? "#F1EEE9" : "#F4F3F1",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: bare ? 0 : "3px 5px",
      boxSizing: "border-box",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: collectionPhotoUrl(c),
    alt: "",
    draggable: false,
    onError: function onError(e) {
      var local = assetUrl(c.photo);
      if (c.photo && e.target.src !== local) {
        e.target.src = local;
        return;
      }
      e.target.style.display = "none";
    },
    style: {
      maxWidth: "100%",
      maxHeight: "100%",
      width: "auto",
      height: "auto",
      objectFit: "contain",
      display: "block",
      opacity: c.available ? 1 : 0.45,
      filter: c.available ? "none" : "grayscale(0.6)"
    }
  }));
  if (!parts) return /*#__PURE__*/React.createElement("span", {
    style: {
      display: "block",
      height: h,
      borderRadius: 8,
      background: "#F1F0EE",
      border: "1px dashed #DCD8D2"
    }
  });
  return /*#__PURE__*/React.createElement("span", {
    style: {
      height: h,
      borderRadius: 8,
      background: c.available ? "#F1EEE9" : "#F4F3F1",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0 6px"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "-2 -2 ".concat(W + 4, " ").concat(D + 4),
    style: {
      width: "100%",
      height: "82%"
    },
    preserveAspectRatio: "xMidYMid meet"
  }, parts.map(function (p, i) {
    return /*#__PURE__*/React.createElement("g", {
      key: i
    }, /*#__PURE__*/React.createElement("rect", {
      x: p.x + gap,
      y: gap,
      width: p.w - gap * 2,
      height: D - gap * 2,
      rx: R,
      fill: skin,
      stroke: ink,
      strokeWidth: "1.6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: p.x + gap,
      y: gap,
      width: p.w - gap * 2,
      height: back,
      rx: R * 0.6,
      fill: ink,
      opacity: "0.55"
    }), p.arm === "l" && /*#__PURE__*/React.createElement("rect", {
      x: p.x + gap,
      y: gap,
      width: 12,
      height: D - gap * 2,
      rx: R * 0.6,
      fill: ink,
      opacity: "0.55"
    }), p.arm === "r" && /*#__PURE__*/React.createElement("rect", {
      x: p.x + p.w - gap - 12,
      y: gap,
      width: 12,
      height: D - gap * 2,
      rx: R * 0.6,
      fill: ink,
      opacity: "0.55"
    }));
  })));
}
function ConfiguratorApp() {
  var _COLLECTIONS$find;
  var _useState5 = useState(function () {
      return (COLLECTIONS.find(function (c) {
        return c.available;
      }) || COLLECTIONS[0]).id;
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    collection = _useState6[0],
    setCollection = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    collOpen = _useState8[0],
    setCollOpen = _useState8[1];
  var _useState9 = useState("miami-beige"),
    _useState0 = _slicedToArray(_useState9, 2),
    fabric = _useState0[0],
    setFabric = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    modules = _useState10[0],
    setModules = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    pillowOpen = _useState12[0],
    setPillowOpen = _useState12[1];
  var _useState13 = useState(PILLOW_SIZES[0].id),
    _useState14 = _slicedToArray(_useState13, 2),
    pillowSize = _useState14[0],
    setPillowSize = _useState14[1];
  var _useState15 = useState(PILLOW_COLORS[0].id),
    _useState16 = _slicedToArray(_useState15, 2),
    pillowColor = _useState16[0],
    setPillowColor = _useState16[1];
  var _useState17 = useState(1),
    _useState18 = _slicedToArray(_useState17, 2),
    pillowAddQty = _useState18[0],
    setPillowAddQty = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    blanketOpen = _useState20[0],
    setBlanketOpen = _useState20[1];
  var _useState21 = useState(BLANKET_COLORS[0].id),
    _useState22 = _slicedToArray(_useState21, 2),
    blanketColor = _useState22[0],
    setBlanketColor = _useState22[1];
  var _useState23 = useState(1),
    _useState24 = _slicedToArray(_useState23, 2),
    blanketAddQty = _useState24[0],
    setBlanketAddQty = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    addons = _useState26[0],
    setAddons = _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    connections = _useState28[0],
    setConnections = _useState28[1];
  var _useState29 = useState(null),
    _useState30 = _slicedToArray(_useState29, 2),
    selected = _useState30[0],
    setSelected = _useState30[1];
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    showDims = _useState32[0],
    setShowDims = _useState32[1]; // dimension lines in the 2D view

  var _useState33 = useState(function () {
      try {
        var v = parseInt(localStorage.getItem("feum_sidebar_w"), 10);
        if (v >= SIDEBAR_MIN && v <= SIDEBAR_MAX) return v;
      } catch (e) {}
      return 390;
    }),
    _useState34 = _slicedToArray(_useState33, 2),
    sidebarW = _useState34[0],
    setSidebarW = _useState34[1];
  var sidebarDragRef = useRef(null);
  var sidebarElRef = useRef(null);
  var sidebarWRef = useRef(null);
  var _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    presetScreen = _useState36[0],
    setPresetScreen = _useState36[1]; // ready-made sets gallery

  var SHOW_WIZARD = false;
  var _useState37 = useState(false),
    _useState38 = _slicedToArray(_useState37, 2),
    wizOpen = _useState38[0],
    setWizOpen = _useState38[1];
  var _useState39 = useState(3),
    _useState40 = _slicedToArray(_useState39, 2),
    wizPersons = _useState40[0],
    setWizPersons = _useState40[1];
  var _useState41 = useState(""),
    _useState42 = _slicedToArray(_useState41, 2),
    wizMaxW = _useState42[0],
    setWizMaxW = _useState42[1];
  var _useState43 = useState(""),
    _useState44 = _slicedToArray(_useState43, 2),
    wizMaxD = _useState44[0],
    setWizMaxD = _useState44[1];
  var _useState45 = useState(null),
    _useState46 = _slicedToArray(_useState45, 2),
    wizResults = _useState46[0],
    setWizResults = _useState46[1]; // null = show all presets
  var _useState47 = useState(false),
    _useState48 = _slicedToArray(_useState47, 2),
    showCompare = _useState48[0],
    setShowCompare = _useState48[1];
  var wheelRef = useRef(null);
  useEffect(function () {
    var el = canvasRef.current;
    if (!el) return;
    var h = function h(e) {
      e.preventDefault();
      if (wheelRef.current) wheelRef.current(e);
    };
    el.addEventListener("wheel", h, {
      passive: false
    });
    var EDGE = 24;
    var edgeGuard = function edgeGuard(e) {
      var t = e.touches && e.touches[0];
      if (!t) return;
      var w = window.innerWidth;
      if (t.clientX <= EDGE || t.clientX >= w - EDGE) e.preventDefault();
    };
    el.addEventListener("touchstart", edgeGuard, {
      passive: false
    });
    return function () {
      el.removeEventListener("wheel", h);
      el.removeEventListener("touchstart", edgeGuard);
    };
  }, [collection, presetScreen, isMobile]);
  useEffect(function () {
    if (typeof document === "undefined" || document.getElementById("umi-hover-css")) return;
    var s = document.createElement("style");
    s.id = "umi-hover-css";
    s.textContent = [".umi-mod-card { transition: border-color .15s ease !important; }", ".umi-mod-card:hover:not(:disabled) { border-color: #000 !important; }", ".umi-app input, .umi-app textarea { -webkit-user-select: text; user-select: text; }"].join("\n");
    document.head.appendChild(s);
  }, []);
  var _useState49 = useState(function () {
      try {
        return JSON.parse(localStorage.getItem("feum-umi-variants") || "[]");
      } catch (e) {
        return [];
      }
    }),
    _useState50 = _slicedToArray(_useState49, 2),
    variants = _useState50[0],
    setVariants = _useState50[1];
  useEffect(function () {
    try {
      localStorage.setItem("feum-umi-variants", JSON.stringify(variants));
    } catch (e) {}
  }, [variants]);
  var _useState51 = useState(function () {
      var site = (typeof window !== "undefined" && window.FEUM_LOCALE || "").slice(0, 2).toLowerCase();
      if (["pl", "de", "en"].includes(site)) return site;
      var n = (typeof navigator !== "undefined" && navigator.language || "en").slice(0, 2).toLowerCase();
      return ["pl", "de", "en"].includes(n) ? n : "en";
    }),
    _useState52 = _slicedToArray(_useState51, 1),
    lang = _useState52[0];
  var t = function t(k) {
    return I18N[lang] && I18N[lang][k] || I18N.en[k] || k;
  };
  var colorLabel = function colorLabel(c) {
    return c && c.tr && c.tr[lang] || c && c.label || "";
  };
  var moduleLabel = function moduleLabel(d) {
    return d && d.tr && d.tr[lang] || d && d.label || "";
  };
  var _useState53 = useState(null),
    _useState54 = _slicedToArray(_useState53, 2),
    ghost = _useState54[0],
    setGhost = _useState54[1];
  var snapRef = useRef(null);
  var _useState55 = useState(1.0),
    _useState56 = _slicedToArray(_useState55, 2),
    zoom = _useState56[0],
    setZoom = _useState56[1];
  var _useState57 = useState({
      x: 0,
      y: 0
    }),
    _useState58 = _slicedToArray(_useState57, 2),
    pan = _useState58[0],
    setPan = _useState58[1];
  var _useState59 = useState(false),
    _useState60 = _slicedToArray(_useState59, 2),
    isMobile = _useState60[0],
    setIsMobile = _useState60[1];
  var _useState61 = useState(false),
    _useState62 = _slicedToArray(_useState61, 2),
    isLandscape = _useState62[0],
    setIsLandscape = _useState62[1];
  var _useState63 = useState("modules"),
    _useState64 = _slicedToArray(_useState63, 2),
    mobileTab = _useState64[0],
    setMobileTab = _useState64[1];
  var panelScrollRef = useRef(null);
  var sectionRefs = useRef({});
  var spyLockRef = useRef(0);
  var _useState65 = useState("2d"),
    _useState66 = _slicedToArray(_useState65, 2),
    viewMode = _useState66[0],
    setViewMode = _useState66[1]; // "2d" | "3d"

  var canvasRef = useRef(null);
  var pendingCenterRef = useRef(false);
  var zoomBase = isMobile ? 0.55 : 1;
  var pinchRef = useRef(null);
  var threeContainerRef = useRef(null);
  var threeRef = useRef({
    scene: null,
    camera: null,
    renderer: null,
    disposed: true
  });
  var orbRef = useRef({
    theta: 0.8,
    phi: 1.0,
    dist: 4.2,
    dragging: false,
    lx: 0,
    ly: 0,
    auto: true
  });
  var stateRef = useRef({
    modules: [],
    connections: [],
    zoom: 1,
    pan: {
      x: 0,
      y: 0
    }
  });
  useEffect(function () {
    if (!pendingCenterRef.current || presetScreen) return;
    var el = canvasRef.current;
    if (!el || !el.offsetWidth || !el.offsetHeight || !modules.length) return;
    var mnX = 1e9,
      mxX = -1e9,
      mnY = 1e9,
      mxY = -1e9;
    modules.forEach(function (m) {
      var d = MODULE_DEFS.find(function (dd) {
        return dd.id === m.mid;
      });
      if (!d) return;
      var sw = m.rot === 90 || m.rot === 270;
      mnX = Math.min(mnX, m.x);
      mxX = Math.max(mxX, m.x + (sw ? d.d : d.w) * CM2PX);
      mnY = Math.min(mnY, m.y);
      mxY = Math.max(mxY, m.y + (sw ? d.w : d.d) * CM2PX);
    });
    if (mxX <= mnX) return;
    var dx = Math.max(20, (el.offsetWidth - (mxX - mnX)) / 2) - mnX;
    var dy = Math.max(20, (el.offsetHeight - (mxY - mnY)) / 2) - mnY;
    pendingCenterRef.current = false;
    if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
    setModules(function (ms) {
      return ms.map(function (m) {
        return _objectSpread(_objectSpread({}, m), {}, {
          x: m.x + dx,
          y: m.y + dy
        });
      });
    });
  }, [modules, presetScreen, isMobile]);
  useEffect(function () {
    stateRef.current.modules = modules;
  }, [modules]);
  useEffect(function () {
    stateRef.current.connections = connections;
  }, [connections]);
  useEffect(function () {
    stateRef.current.zoom = zoom;
  }, [zoom]);
  useEffect(function () {
    stateRef.current.pan = pan;
  }, [pan]);
  useEffect(function () {
    var check = function check() {
      var w = window.innerWidth,
        h = window.innerHeight;
      setIsMobile(w < 768 || h < 560);
      setIsLandscape(w > h && h < 560);
    };
    check();
    window.addEventListener("resize", check);
    window.addEventListener("orientationchange", check);
    return function () {
      window.removeEventListener("resize", check);
      window.removeEventListener("orientationchange", check);
    };
  }, []);
  useEffect(function () {
    setZoom(isMobile ? 0.55 : 1);
    setPan({
      x: 0,
      y: 0
    });
  }, [isMobile]);
  var fabricObj = FABRICS.find(function (f) {
    return f.id === fabric;
  });
  var fabHex = (fabricObj === null || fabricObj === void 0 ? void 0 : fabricObj.hex) || "#D4C4A8";
  var fabTexture = (fabricObj === null || fabricObj === void 0 ? void 0 : fabricObj.texture) || null;
  var leadTime = getLeadTime(fabric);
  var _useState67 = useState({}),
    _useState68 = _slicedToArray(_useState67, 2),
    thumbCache = _useState68[0],
    setThumbCache = _useState68[1];
  var thumbCacheRef = useRef({});
  var thumbRendererRef = useRef(null);
  var thumbBakingRef = useRef(new Set());
  var bakeRoundRef = useRef(0);
  var _useState69 = useState(0),
    _useState70 = _slicedToArray(_useState69, 2),
    bakeRound = _useState70[0],
    setBakeRound = _useState70[1];
  var bakeFabricRef = useRef(null);
  var getThumbRenderer = useCallback(function () {
    if (thumbRendererRef.current) return thumbRendererRef.current;
    var renderer = new THREE.WebGLRenderer({
      alpha: true,
      antialias: true,
      preserveDrawingBuffer: true
    });
    renderer.setSize(320, 320);
    renderer.setClearColor(0x000000, 0);
    var scene = new THREE.Scene();
    scene.add(new THREE.AmbientLight(0xffffff, 0.85));
    var dl = new THREE.DirectionalLight(0xffffff, 0.5);
    dl.position.set(2, 6, 3);
    scene.add(dl);
    var camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0.01, 100);
    var loader = makeGltfLoader();
    var t = {
      renderer: renderer,
      scene: scene,
      camera: camera,
      loader: loader,
      gltfCache: {},
      texLoader: null
    };
    thumbRendererRef.current = t;
    return t;
  }, []);
  var disposeBakeMaterials = function disposeBakeMaterials(root) {
    root.traverse(function (o) {
      if (!o.isMesh || !o.material) return;
      var mats = Array.isArray(o.material) ? o.material : [o.material];
      mats.forEach(function (m) {
        try {
          m.dispose();
        } catch (e) {}
      });
    });
  };
  var bakeModuleThumb = useCallback(function (defId, fabObj) {
    return new Promise(function (resolve) {
      var def = MODULE_DEFS.find(function (d) {
        return d.id === defId;
      });
      var glbPath = MODULE_TO_GLB[defId];
      if (!def || !glbPath) {
        resolve(null);
        return;
      }
      var t = getThumbRenderer();
      var finishRender = function finishRender(root) {
        applyFabricMaterials(root, fabObj, fabObj === null || fabObj === void 0 ? void 0 : fabObj.hex, t).then(function () {
          try {
            root.rotation.y = MODULE_GLB_Y_ROT[defId] || 0;
            t.scene.add(root);
            root.updateMatrixWorld(true);
            var box = new THREE.Box3().setFromObject(root);
            var size = box.getSize(new THREE.Vector3());
            var center = box.getCenter(new THREE.Vector3());
            var halfX = size.x / 2 * BAKE_PAD || 1;
            var halfZ = size.z / 2 * BAKE_PAD || 1;
            t.camera.left = -halfX;
            t.camera.right = halfX;
            t.camera.top = halfZ;
            t.camera.bottom = -halfZ;
            t.camera.near = 0.01;
            t.camera.far = size.y + 20;
            t.camera.position.set(center.x, box.max.y + 10, center.z);
            t.camera.up.set(0, 0, -1);
            t.camera.lookAt(center.x, 0, center.z);
            t.camera.updateProjectionMatrix();
            t.renderer.render(t.scene, t.camera);
            var url = t.renderer.domElement.toDataURL("image/png");
            t.scene.remove(root);
            disposeBakeMaterials(root);
            resolve(url);
          } catch (e) {
            console.error("Thumbnail bake failed for", defId, e);
            try {
              t.scene.remove(root);
              disposeBakeMaterials(root);
            } catch (e2) {}
            resolve(null);
          }
        });
      };
      if (t.gltfCache[glbPath]) {
        finishRender(t.gltfCache[glbPath].clone(true));
      } else {
        t.loader.load(modelUrl(glbPath), function (gltf) {
          t.gltfCache[glbPath] = gltf.scene;
          finishRender(gltf.scene.clone(true));
        }, undefined, function (err) {
          console.error("GLB load failed", glbPath, err);
          resolve(null);
        });
      }
    });
  }, [getThumbRenderer]);
  useEffect(function () {
    if (!fabricObj || !collection) return;
    if (bakeFabricRef.current !== fabricObj.id) {
      bakeFabricRef.current = fabricObj.id;
      bakeRoundRef.current = 0;
    }
    var cancelled = false;
    _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var wszystkie, naSofie, wPamieci, najpierw, kolejnosc, _iterator15, _step15, defId, key, persistKey, url, attempt, missing, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            wszystkie = BAKE_ORDER.filter(function (d) {
              return MODULE_TO_GLB[d];
            }).concat(Object.keys(MODULE_TO_GLB).filter(function (d) {
              return BAKE_ORDER.indexOf(d) === -1;
            }));
            naSofie = new Set((stateRef.current.modules || []).map(function (m) {
              return m.mid;
            }));
            wPamieci = thumbRendererRef.current && thumbRendererRef.current.gltfCache || {};
            najpierw = wszystkie.filter(function (d) {
              return naSofie.has(d) && wPamieci[MODULE_TO_GLB[d]];
            });
            kolejnosc = najpierw.concat(wszystkie.filter(function (d) {
              return najpierw.indexOf(d) === -1;
            }));
            _iterator15 = _createForOfIteratorHelper(kolejnosc);
            _context.p = 1;
            _iterator15.s();
          case 2:
            if ((_step15 = _iterator15.n()).done) {
              _context.n = 13;
              break;
            }
            defId = _step15.value;
            if (!cancelled) {
              _context.n = 3;
              break;
            }
            return _context.a(2);
          case 3:
            key = defId + "|" + fabricObj.id;
            if (!(thumbCacheRef.current[key] || thumbBakingRef.current.has(key))) {
              _context.n = 4;
              break;
            }
            return _context.a(3, 12);
          case 4:
            thumbBakingRef.current.add(key);
            persistKey = key + "|" + MODELS_VERSION;
            _context.n = 5;
            return thumbCacheGet(persistKey);
          case 5:
            url = _context.v;
            if (url) {
              _context.n = 11;
              break;
            }
            attempt = 0;
          case 6:
            if (!(attempt < 3 && !url && !cancelled)) {
              _context.n = 10;
              break;
            }
            if (!(attempt > 0)) {
              _context.n = 7;
              break;
            }
            _context.n = 7;
            return new Promise(function (r) {
              return setTimeout(r, 600);
            });
          case 7:
            _context.n = 8;
            return bakeModuleThumb(defId, fabricObj);
          case 8:
            url = _context.v;
          case 9:
            attempt++;
            _context.n = 6;
            break;
          case 10:
            if (url) thumbCachePut(persistKey, url);
            _context.n = 11;
            return new Promise(function (r) {
              return setTimeout(r, 40);
            });
          case 11:
            thumbBakingRef.current["delete"](key);
            if (url && !cancelled) {
              thumbCacheRef.current = _objectSpread(_objectSpread({}, thumbCacheRef.current), {}, _defineProperty({}, key, url));
              setThumbCache(thumbCacheRef.current);
            }
          case 12:
            _context.n = 2;
            break;
          case 13:
            _context.n = 15;
            break;
          case 14:
            _context.p = 14;
            _t = _context.v;
            _iterator15.e(_t);
          case 15:
            _context.p = 15;
            _iterator15.f();
            return _context.f(15);
          case 16:
            if (!cancelled) {
              missing = Object.keys(MODULE_TO_GLB).some(function (d) {
                return !thumbCacheRef.current[d + "|" + fabricObj.id] && !thumbBakingRef.current.has(d + "|" + fabricObj.id);
              });
              if (missing && bakeRoundRef.current < 4) {
                bakeRoundRef.current += 1;
                setTimeout(function () {
                  if (!cancelled) setBakeRound(bakeRoundRef.current);
                }, 1500);
              }
            }
          case 17:
            return _context.a(2);
        }
      }, _callee, null, [[1, 14, 15, 16]]);
    }))();
    return function () {
      cancelled = true;
    };
  }, [fabricObj, collection, bakeModuleThumb, bakeRound]);
  var moduleCounts = {};
  modules.forEach(function (m) {
    moduleCounts[m.mid] = (moduleCounts[m.mid] || 0) + 1;
  });
  var pricesLive = livePricesAvailable(fabric);
  var displayCurrency = priceCurrency(fabric);
  var feedUsable = displayCurrency === shopCurrency();
  var livePriceOf = function livePriceOf(mid) {
    return shopifyPriceCents(fabric, mid);
  };
  var unitPrice = function unitPrice(mid) {
    var _MODULE_DEFS$find3;
    var live = livePriceOf(mid);
    if (live != null && feedUsable) return live;
    if (REQUIRE_LIVE_PRICES) return 0;
    return Math.round((((_MODULE_DEFS$find3 = MODULE_DEFS.find(function (d) {
      return d.id === mid;
    })) === null || _MODULE_DEFS$find3 === void 0 ? void 0 : _MODULE_DEFS$find3.base) || 0) * ((fabricObj === null || fabricObj === void 0 ? void 0 : fabricObj.mult) || 1));
  };
  var presetCounts = function presetCounts(p) {
    var c = {};
    p.recipe.forEach(function (st) {
      c[st.mid] = (c[st.mid] || 0) + 1;
    });
    return c;
  };
  var setPricing = setAwareTotal(moduleCounts, unitPrice, fabric);
  var pillowColorObj = PILLOW_COLORS.find(function (c) {
    return c.id === pillowColor;
  });
  var pillowSizeObj = PILLOW_SIZES.find(function (s) {
    return s.id === pillowSize;
  });
  var blanketColorObj = BLANKET_COLORS.find(function (c) {
    return c.id === blanketColor;
  });
  var addonCentsFor = function addonCentsFor(variantId, listCents) {
    var live = feedUsable ? addonLivePrice(variantId) : null;
    if (live != null) return live;
    return displayCurrency === BASE_CURRENCY ? listCents : null;
  };
  var addonPrice = function addonPrice(a) {
    var _PILLOW_SIZES$find;
    return addonCentsFor(addonVariantId(a), a.kind === "pillow" ? ((_PILLOW_SIZES$find = PILLOW_SIZES.find(function (s) {
      return s.id === a.size;
    })) === null || _PILLOW_SIZES$find === void 0 ? void 0 : _PILLOW_SIZES$find.price) || 0 : BLANKET_PRICE);
  };
  var addonFromPrice = function addonFromPrice(kind) {
    var pairs = kind === "blanket" ? BLANKET_COLORS.map(function (c) {
      return [c.v, BLANKET_PRICE];
    }) : PILLOW_COLORS.flatMap(function (c) {
      return PILLOW_SIZES.map(function (sz) {
        return [c.v && c.v[sz.id], sz.price];
      });
    });
    var live = feedUsable ? pairs.map(function (_ref21) {
      var _ref22 = _slicedToArray(_ref21, 1),
        v = _ref22[0];
      return addonLivePrice(v);
    }).filter(function (x) {
      return x != null;
    }) : [];
    if (live.length) return Math.min.apply(Math, _toConsumableArray(live));
    return displayCurrency === BASE_CURRENCY ? Math.min.apply(Math, _toConsumableArray(pairs.map(function (_ref23) {
      var _ref24 = _slicedToArray(_ref23, 2),
        l = _ref24[1];
      return l;
    }))) : null;
  };
  var removeWord = function removeWord() {
    return t("remove").replace(/^[✕×]\s*/, "");
  };
  var addonLabel = function addonLabel(a) {
    var _PILLOW_SIZES$find2;
    return a.kind === "pillow" ? "".concat(t("addonsPillowTitle"), " (").concat([colorLabel(PILLOW_COLORS.find(function (c) {
      return c.id === a.color;
    })), (_PILLOW_SIZES$find2 = PILLOW_SIZES.find(function (s) {
      return s.id === a.size;
    })) === null || _PILLOW_SIZES$find2 === void 0 ? void 0 : _PILLOW_SIZES$find2.label].filter(Boolean).join(", "), ")") : "".concat(t("addonsBlanketTitle")).concat(colorLabel(BLANKET_COLORS.find(function (c) {
      return c.id === a.color;
    })) ? " (".concat(colorLabel(BLANKET_COLORS.find(function (c) {
      return c.id === a.color;
    })), ")") : "");
  };
  var addonThumb = function addonThumb(a) {
    var _PILLOW_COLORS$find;
    return a.kind === "pillow" ? addonPackshot((_PILLOW_COLORS$find = PILLOW_COLORS.find(function (c) {
      return c.id === a.color;
    })) === null || _PILLOW_COLORS$find === void 0 || (_PILLOW_COLORS$find = _PILLOW_COLORS$find.v) === null || _PILLOW_COLORS$find === void 0 ? void 0 : _PILLOW_COLORS$find[a.size], "textures/addons/pillow/packshot-".concat(a.size, "-").concat(a.color, ".jpg")) : function () {
      var bc = BLANKET_COLORS.find(function (c) {
        return c.id === a.color;
      });
      return addonPackshot(bc === null || bc === void 0 ? void 0 : bc.v, bc === null || bc === void 0 ? void 0 : bc.packshot);
    }();
  };
  var addAddon = function addAddon(entry) {
    var qty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var key = entry.kind === "pillow" ? "pillow|".concat(entry.size, "|").concat(entry.color) : "blanket|".concat(entry.color);
    setAddons(function (prev) {
      var i = prev.findIndex(function (a) {
        return a.key === key;
      });
      if (i === -1) return [].concat(_toConsumableArray(prev), [_objectSpread(_objectSpread({}, entry), {}, {
        key: key,
        qty: Math.min(9, qty)
      })]);
      var next = _toConsumableArray(prev);
      next[i] = _objectSpread(_objectSpread({}, next[i]), {}, {
        qty: Math.min(9, next[i].qty + qty)
      });
      return next;
    });
  };
  var setAddonQty = function setAddonQty(key, qty) {
    return setAddons(function (prev) {
      return qty <= 0 ? prev.filter(function (a) {
        return a.key !== key;
      }) : prev.map(function (a) {
        return a.key === key ? _objectSpread(_objectSpread({}, a), {}, {
          qty: Math.min(9, qty)
        }) : a;
      });
    });
  };
  var addonsCents = addons.reduce(function (sum, a) {
    return sum + a.qty * (addonPrice(a) || 0);
  }, 0);
  var totalCents = setPricing.total + addonsCents;
  var savingsCents = setPricing.savings;
  var sidebarCleanupRef = useRef(null);
  var recheckTotalRef = useRef(null);
  var _useState71 = useState(false),
    _useState72 = _slicedToArray(_useState71, 2),
    totalOnScreen = _useState72[0],
    setTotalOnScreen = _useState72[1];
  var attachSidebarScroll = useCallback(function (node) {
    if (sidebarCleanupRef.current) {
      sidebarCleanupRef.current();
      sidebarCleanupRef.current = null;
    }
    recheckTotalRef.current = null;
    if (!node) {
      setTotalOnScreen(false);
      return;
    }
    var check = function check() {
      var row = node.querySelector("[data-total-row]");
      if (!row) {
        setTotalOnScreen(false);
        return;
      }
      var r = row.getBoundingClientRect(),
        c = node.getBoundingClientRect();
      setTotalOnScreen(r.top >= c.top && r.bottom <= c.bottom);
    };
    node.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    sidebarCleanupRef.current = function () {
      node.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
    recheckTotalRef.current = check;
    check();
  }, []);
  useEffect(function () {
    if (recheckTotalRef.current) recheckTotalRef.current();
  });
  var addonsLines = addons.map(function (a) {
    return "".concat(a.qty, "\xD7 ").concat(addonLabel(a));
  });
  var hasItems = modules.length > 0 || addons.length > 0;
  var formatMoney = function formatMoney(c, cur) {
    return new Intl.NumberFormat(lang === "pl" ? "pl-PL" : lang === "de" ? "de-DE" : "en-GB", {
      style: "currency",
      currency: cur
    }).format(c / 100);
  };
  var formatPrice = function formatPrice(c) {
    return formatMoney(c, displayCurrency);
  };
  var formatPriceOrDash = function formatPriceOrDash(c) {
    return c == null ? "—" : formatPrice(c);
  };
  useEffect(function () {
    if (pricesLive && feedUsable) return;
    var fp = typeof window !== "undefined" ? window.FEUM_PRICES : null;
    var d = priceDiag();
    console.warn("FEUM prices: falling back to the " + BASE_CURRENCY + " list.", {
      fabric: fabric,
      shopCurrency: shopCurrency(),
      locale: d.locale,
      feedObject: fp ? "present" : "ABSENT",
      fabricsInFeed: fp ? Object.keys(fp) : [],
      entriesForThisFabric: fp && fp[fabric] ? Object.keys(fp[fabric]) : "NO KEY",
      unresolvedHandles: d.missing
    });
  }, [pricesLive, feedUsable, fabric]);
  var getModPx = function getModPx(def, rot) {
    var sw = rot === 90 || rot === 270;
    return {
      w: (sw ? def.d : def.w) * CM2PX,
      h: (sw ? def.w : def.d) * CM2PX
    };
  };
  var zoomToward = useCallback(function (factor) {
    var el = canvasRef.current;
    if (!el) return;
    var cx = el.offsetWidth / 2,
      cy = el.offsetHeight / 2;
    var canvasX = (cx - pan.x) / zoom,
      canvasY = (cy - pan.y) / zoom;
    var nz = Math.min(Math.max(zoom * factor, 0.05), 2.5);
    setPan({
      x: cx - canvasX * nz,
      y: cy - canvasY * nz
    });
    setZoom(nz);
  }, [zoom, pan]);
  var handleWheel = useCallback(function (e) {
    e.preventDefault();
    var el = canvasRef.current;
    if (!el) return;
    var r = el.getBoundingClientRect();
    var mx = e.clientX - r.left,
      my = e.clientY - r.top;
    var cx = (mx - pan.x) / zoom,
      cy = (my - pan.y) / zoom;
    var factor = e.deltaY > 0 ? 0.95 : 1.05;
    var nz = Math.min(Math.max(zoom * factor, 0.05), 2.5);
    setPan({
      x: mx - cx * nz,
      y: my - cy * nz
    });
    setZoom(nz);
  }, [zoom, pan]);
  var interactionRef = useRef({
    type: null,
    iid: null,
    offsetX: 0,
    offsetY: 0,
    startX: 0,
    startY: 0,
    startPanX: 0,
    startPanY: 0
  });
  var pointersRef = useRef(new Map());
  var screenToCanvasNow = function screenToCanvasNow(clientX, clientY) {
    var el = canvasRef.current;
    if (!el) return {
      x: 0,
      y: 0
    };
    var r = el.getBoundingClientRect();
    var _stateRef$current = stateRef.current,
      z = _stateRef$current.zoom,
      p = _stateRef$current.pan;
    return {
      x: (clientX - r.left - p.x) / z,
      y: (clientY - r.top - p.y) / z
    };
  };
  var hitTestNow = function hitTestNow(cx, cy) {
    var mods = stateRef.current.modules;
    var _loop8 = function _loop8() {
        var m = mods[i];
        var def = MODULE_DEFS.find(function (d) {
          return d.id === m.mid;
        });
        if (!def) return 0; // continue
        var sw = m.rot === 90 || m.rot === 270;
        var w = (sw ? def.d : def.w) * CM2PX,
          h = (sw ? def.w : def.d) * CM2PX;
        if (cx >= m.x && cx <= m.x + w && cy >= m.y && cy <= m.y + h) return {
          v: m
        };
      },
      _ret7;
    for (var i = mods.length - 1; i >= 0; i--) {
      _ret7 = _loop8();
      if (_ret7 === 0) continue;
      if (_ret7) return _ret7.v;
    }
    return null;
  };
  var onPointerDownCanvas = function onPointerDownCanvas(e) {
    if (e.button && e.button !== 0) return;
    clearTextSelection();
    pointersRef.current.set(e.pointerId, {
      x: e.clientX,
      y: e.clientY
    });
    if (pointersRef.current.size === 2) {
      interactionRef.current = {
        type: "pinch",
        iid: null,
        offsetX: 0,
        offsetY: 0,
        startX: 0,
        startY: 0,
        startPanX: 0,
        startPanY: 0
      };
      var pts = _toConsumableArray(pointersRef.current.values());
      var dx = pts[0].x - pts[1].x,
        dy = pts[0].y - pts[1].y;
      var midX = (pts[0].x + pts[1].x) / 2;
      var midY = (pts[0].y + pts[1].y) / 2;
      var el = canvasRef.current;
      var r = el ? el.getBoundingClientRect() : {
        left: 0,
        top: 0
      };
      var _stateRef$current2 = stateRef.current,
        z = _stateRef$current2.zoom,
        p = _stateRef$current2.pan;
      var cpx = (midX - r.left - p.x) / z;
      var cpy = (midY - r.top - p.y) / z;
      pinchRef.current = {
        dist: Math.sqrt(dx * dx + dy * dy),
        zoom: z,
        midX: midX - r.left,
        midY: midY - r.top,
        cpx: cpx,
        cpy: cpy,
        startPan: _objectSpread({}, p)
      };
      try {
        e.currentTarget.setPointerCapture(e.pointerId);
      } catch (err) {}
      return;
    }
    if (interactionRef.current.type === "pinch") {
      try {
        e.currentTarget.setPointerCapture(e.pointerId);
      } catch (err) {}
      return;
    }
    var cc = screenToCanvasNow(e.clientX, e.clientY);
    var hit = hitTestNow(cc.x, cc.y);
    if (hit) {
      interactionRef.current = {
        type: "drag",
        iid: hit.iid,
        offsetX: cc.x - hit.x,
        offsetY: cc.y - hit.y,
        startX: 0,
        startY: 0,
        startPanX: 0,
        startPanY: 0
      };
      setSelected(hit.iid);
      setConnections(function (prev) {
        return prev.filter(function (c) {
          return c.a.iid !== hit.iid && c.b.iid !== hit.iid;
        });
      });
    } else {
      var _p = stateRef.current.pan;
      interactionRef.current = {
        type: "pan",
        iid: null,
        offsetX: 0,
        offsetY: 0,
        startX: e.clientX,
        startY: e.clientY,
        startPanX: _p.x,
        startPanY: _p.y
      };
      setSelected(null);
    }
    try {
      e.currentTarget.setPointerCapture(e.pointerId);
    } catch (err) {}
  };
  var onPointerMoveCanvas = function onPointerMoveCanvas(e) {
    pointersRef.current.set(e.pointerId, {
      x: e.clientX,
      y: e.clientY
    });
    var inter = interactionRef.current;
    if (inter.type === "pinch" && pointersRef.current.size < 2) {
      pinchRef.current = null;
      var rest = _toConsumableArray(pointersRef.current.values())[0];
      var p = stateRef.current.pan;
      interactionRef.current = rest ? {
        type: "pan",
        iid: null,
        offsetX: 0,
        offsetY: 0,
        startX: rest.x,
        startY: rest.y,
        startPanX: p.x,
        startPanY: p.y
      } : {
        type: null,
        iid: null,
        offsetX: 0,
        offsetY: 0,
        startX: 0,
        startY: 0,
        startPanX: 0,
        startPanY: 0
      };
      return;
    }
    if (inter.type === "pinch" && pointersRef.current.size >= 2 && pinchRef.current) {
      var pts = _toConsumableArray(pointersRef.current.values());
      var dx = pts[0].x - pts[1].x,
        dy = pts[0].y - pts[1].y;
      var newDist = Math.sqrt(dx * dx + dy * dy);
      var nz = Math.min(Math.max(pinchRef.current.zoom * (newDist / pinchRef.current.dist), 0.05), 2.5);
      var np = {
        x: pinchRef.current.midX - pinchRef.current.cpx * nz,
        y: pinchRef.current.midY - pinchRef.current.cpy * nz
      };
      setZoom(nz);
      setPan(np);
      return;
    }
    if (!inter.type) return;
    if (inter.type === "drag" && inter.iid) {
      var cc = screenToCanvasNow(e.clientX, e.clientY);
      var nx = cc.x - inter.offsetX,
        ny = cc.y - inter.offsetY;
      setModules(function (prev) {
        return prev.map(function (m) {
          return m.iid === inter.iid ? _objectSpread(_objectSpread({}, m), {}, {
            x: nx,
            y: ny
          }) : m;
        });
      });
      var mods = stateRef.current.modules;
      var m = mods.find(function (mm) {
        return mm.iid === inter.iid;
      });
      if (m) {
        var updated = _objectSpread(_objectSpread({}, m), {}, {
          x: nx,
          y: ny
        });
        var def = MODULE_DEFS.find(function (d) {
          return d.id === updated.mid;
        });
        if (def) {
          var result = findSnap(updated, def, mods, stateRef.current.connections);
          snapRef.current = result;
          setGhost(result ? {
            x: result.sx,
            y: result.sy,
            mid: updated.mid,
            rot: result.rot,
            tc: result.tc,
            dc: result.dc
          } : null);
        }
      }
    }
    if (inter.type === "pan") {
      setPan({
        x: inter.startPanX + (e.clientX - inter.startX),
        y: inter.startPanY + (e.clientY - inter.startY)
      });
    }
  };
  var onPointerCancelCanvas = function onPointerCancelCanvas(e) {
    pointersRef.current["delete"](e.pointerId);
    if (pointersRef.current.size < 2) pinchRef.current = null;
    if (pointersRef.current.size === 0) {
      interactionRef.current = {
        type: null,
        iid: null,
        offsetX: 0,
        offsetY: 0,
        startX: 0,
        startY: 0,
        startPanX: 0,
        startPanY: 0
      };
      setGhost(null);
      snapRef.current = null;
    } else if (interactionRef.current.type === "pinch") {
      var rest = _toConsumableArray(pointersRef.current.values())[0];
      var p = stateRef.current.pan;
      interactionRef.current = {
        type: "pan",
        iid: null,
        offsetX: 0,
        offsetY: 0,
        startX: rest.x,
        startY: rest.y,
        startPanX: p.x,
        startPanY: p.y
      };
    }
    try {
      e.currentTarget.releasePointerCapture(e.pointerId);
    } catch (err) {}
  };
  var onPointerUpCanvas = function onPointerUpCanvas(e) {
    pointersRef.current["delete"](e.pointerId);
    var inter = interactionRef.current;
    if (inter.type === "pinch") {
      if (pointersRef.current.size < 2) {
        pinchRef.current = null;
        var rest = _toConsumableArray(pointersRef.current.values())[0];
        if (rest) {
          var p = stateRef.current.pan;
          interactionRef.current = {
            type: "pan",
            iid: null,
            offsetX: 0,
            offsetY: 0,
            startX: rest.x,
            startY: rest.y,
            startPanX: p.x,
            startPanY: p.y
          };
        } else {
          interactionRef.current = {
            type: null,
            iid: null,
            offsetX: 0,
            offsetY: 0,
            startX: 0,
            startY: 0,
            startPanX: 0,
            startPanY: 0
          };
        }
      }
      try {
        e.currentTarget.releasePointerCapture(e.pointerId);
      } catch (err) {}
      return;
    }
    if (inter.type === "drag" && inter.iid) {
      var mods = stateRef.current.modules;
      var m = mods.find(function (mm) {
        return mm.iid === inter.iid;
      });
      if (m) {
        var def = MODULE_DEFS.find(function (d) {
          return d.id === m.mid;
        });
        if (def) {
          var result = snapRef.current || findSnap(m, def, mods, stateRef.current.connections);
          if (result) {
            setModules(function (prev) {
              return prev.map(function (mm) {
                return mm.iid === inter.iid ? _objectSpread(_objectSpread({}, mm), {}, {
                  x: result.sx,
                  y: result.sy,
                  rot: result.rot
                }) : mm;
              });
            });
            setConnections(function (prev) {
              return [].concat(_toConsumableArray(prev), [{
                a: {
                  iid: result.tc.iid,
                  cid: result.tc.cid
                },
                b: {
                  iid: result.dc.iid,
                  cid: result.dc.cid
                }
              }]);
            });
          }
        }
      }
      setGhost(null);
      snapRef.current = null;
    }
    interactionRef.current = {
      type: null,
      iid: null,
      offsetX: 0,
      offsetY: 0,
      startX: 0,
      startY: 0,
      startPanX: 0,
      startPanY: 0
    };
    e.currentTarget.releasePointerCapture(e.pointerId);
  };
  var addModule = useCallback(function (moduleId) {
    if (modules.length >= MAX_MODULES) return;
    setViewMode("2d");
    var canvas = canvasRef.current;
    var cw = canvas ? canvas.offsetWidth : 600;
    var ch = canvas ? canvas.offsetHeight : 400;
    var pos = findPlacement(moduleId, modules, cw, ch, zoom, pan, connections);
    var iid = uid();
    setModules(function (prev) {
      var _pos$rot;
      return [].concat(_toConsumableArray(prev), [{
        iid: iid,
        mid: moduleId,
        x: pos.x,
        y: pos.y,
        rot: (_pos$rot = pos.rot) !== null && _pos$rot !== void 0 ? _pos$rot : MODULE_START_ROT[moduleId] || 0
      }]);
    });
    track("module_add", {
      module_id: moduleId
    });
    setSelected(iid);
  }, [modules, zoom, pan, connections]);
  var removeModule = useCallback(function (iid) {
    setViewMode("2d");
    setModules(function (prev) {
      return prev.filter(function (m) {
        return m.iid !== iid;
      });
    });
    setConnections(function (prev) {
      return prev.filter(function (c) {
        return c.a.iid !== iid && c.b.iid !== iid;
      });
    });
    if (selected === iid) setSelected(null);
  }, [selected]);
  var rotateModule = useCallback(function (iid) {
    setViewMode("2d");
    setConnections(function (prev) {
      return prev.filter(function (c) {
        return c.a.iid !== iid && c.b.iid !== iid;
      });
    });
    setModules(function (prev) {
      var m = prev.find(function (x) {
        return x.iid === iid;
      });
      var def = m && MODULE_DEFS.find(function (d) {
        return d.id === m.mid;
      });
      if (!m || !def) return prev;
      var rot = (m.rot + 90) % 360;
      var przed = getModPx(def, m.rot),
        po = getModPx(def, rot);
      var kand = _objectSpread(_objectSpread({}, m), {}, {
        rot: rot,
        x: m.x + (przed.w - po.w) / 2,
        y: m.y + (przed.h - po.h) / 2
      });
      var inni = prev.filter(function (x) {
        return x.iid !== iid;
      });
      for (var i = 0; i < 4 && colCheck(kand, def, inni); i++) {
        var tb = modBBox(kand, def);
        var dx = 0,
          dy = 0;
        var _iterator16 = _createForOfIteratorHelper(inni),
          _step16;
        try {
          var _loop9 = function _loop9() {
              var o = _step16.value;
              var od = MODULE_DEFS.find(function (d) {
                return d.id === o.mid;
              });
              if (!od) return 0; // continue
              var ob = modBBox(o, od);
              if (!bboxHit(tb, ob)) return 0; // continue
              var lewo = ob.x1 - tb.x2,
                prawo = ob.x2 - tb.x1;
              var gora = ob.y1 - tb.y2,
                dol = ob.y2 - tb.y1;
              var px = Math.abs(lewo) < Math.abs(prawo) ? lewo : prawo;
              var py = Math.abs(gora) < Math.abs(dol) ? gora : dol;
              if (Math.abs(px) <= Math.abs(py)) {
                if (Math.abs(px) > Math.abs(dx)) dx = px;
              } else {
                if (Math.abs(py) > Math.abs(dy)) dy = py;
              }
            },
            _ret8;
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            _ret8 = _loop9();
            if (_ret8 === 0) continue;
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }
        if (!dx && !dy) break;
        kand = _objectSpread(_objectSpread({}, kand), {}, {
          x: kand.x + dx,
          y: kand.y + dy
        });
      }
      return prev.map(function (x) {
        return x.iid === iid ? kand : x;
      });
    });
  }, []);
  var resetAll = useCallback(function () {
    setViewMode("2d");
    setModules([]);
    setConnections([]);
    setSelected(null);
    setZoom(isMobile ? 0.55 : 1.0);
    setPan({
      x: 0,
      y: 0
    });
    setAddons([]); // add-ons are part of the configuration, so reset clears them too
  }, [isMobile]);
  var darken = function darken(hex, amt) {
    var n = parseInt(hex.replace("#", ""), 16);
    return "rgb(".concat(Math.max(0, (n >> 16) - amt), ",").concat(Math.max(0, (n >> 8 & 0xff) - amt), ",").concat(Math.max(0, (n & 0xff) - amt), ")");
  };
  var lighter = function lighter(hex, amt) {
    var n = parseInt(hex.replace("#", ""), 16);
    return "rgb(".concat(Math.min(255, (n >> 16) + amt), ",").concat(Math.min(255, (n >> 8 & 0xff) + amt), ",").concat(Math.min(255, (n & 0xff) + amt), ")");
  };
  var ModuleShape = function ModuleShape(_ref25) {
    var def = _ref25.def,
      w = _ref25.w,
      h = _ref25.h,
      rot = _ref25.rot,
      isSel = _ref25.isSel;
    var W = def.w * CM2PX,
      H = def.d * CM2PX;
    var patId = "fabtex-" + ((fabricObj === null || fabricObj === void 0 ? void 0 : fabricObj.id) || "none");
    var fabDefs = fabTexture ? /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
      id: patId,
      patternUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: W,
      height: H
    }, /*#__PURE__*/React.createElement("image", {
      href: assetUrl(fabTexture),
      x: "0",
      y: "0",
      width: W,
      height: H,
      preserveAspectRatio: "xMidYMid slice"
    }))) : null;
    var base = fabTexture ? "url(#".concat(patId, ")") : fabHex;
    var dark = darken(fabHex, 28);
    var mid = darken(fabHex, 12);
    var light = lighter(fabHex, 12);
    var st = darken(fabHex, 40);
    var div = darken(fabHex, 18); // divider lines between cushions

    var armW = 7 * CM2PX; // armrest width ~7cm
    var backD = H * 0.32; // backrest depth ~32% of module depth
    var backR = backD * 0.48; // backrest corner radius (big, sausage-like)
    var seatR = 6; // seat cushion radius
    var frameR = 6; // outer frame radius
    var gap = 1.2; // gap between parts
    var legSize = 3; // leg square size
    var legInset = 4; // leg inset from edge

    var seatX = def.id === "left" || def.id === "long-l" ? armW + gap : gap;
    var seatY = def.id === "pouf" ? gap : backD + gap;
    var seatW = W - gap * 2 - (def.id === "left" || def.id === "long-l" || def.id === "right" || def.id === "long-r" ? armW : 0);
    var seatH = H - gap - (def.id === "pouf" ? gap : backD);
    var shapes = {
      "left": function () {
        var aW = armW + 1.5; // armrest visual width
        var aH = H * 0.48; // armrest height (upper portion only)
        var bD = backD; // backrest depth
        var bR = bD * 0.44; // backrest pill radius
        var aR = Math.min(aW, aH) * 0.3; // armrest radius
        var sGap = 1.2;
        var bX = aW + sGap,
          bW = W - aW - sGap * 2;
        var sx = aW + sGap,
          sy = bD + sGap;
        var sw = W - aW - sGap * 2,
          sh = H - bD - sGap * 2;
        return /*#__PURE__*/React.createElement("svg", {
          width: W,
          height: H,
          viewBox: "0 0 ".concat(W, " ").concat(H)
        }, fabDefs, /*#__PURE__*/React.createElement("path", {
          d: "M ".concat(aR + 1, " 0.5 L ").concat(W - frameR, " 0.5 Q ").concat(W - 0.5, " 0.5 ").concat(W - 0.5, " ").concat(frameR, " L ").concat(W - 0.5, " ").concat(H - frameR, " Q ").concat(W - 0.5, " ").concat(H - 0.5, " ").concat(W - frameR, " ").concat(H - 0.5, " L ").concat(frameR, " ").concat(H - 0.5, " Q 0.5 ").concat(H - 0.5, " 0.5 ").concat(H - frameR, " L 0.5 ").concat(aR + 1, " Q 0.5 0.5 ").concat(aR + 1, " 0.5 Z"),
          fill: base,
          stroke: st,
          strokeWidth: "0.5"
        }), /*#__PURE__*/React.createElement("rect", {
          x: bX,
          y: sGap + 0.5,
          width: bW,
          height: bD - sGap,
          rx: bR,
          fill: dark,
          opacity: "0.38"
        }), /*#__PURE__*/React.createElement("rect", {
          x: sGap + 0.5,
          y: sGap + 0.5,
          width: aW - sGap,
          height: aH,
          rx: aR,
          fill: mid,
          opacity: "0.38"
        }), /*#__PURE__*/React.createElement("rect", {
          x: sx,
          y: sy,
          width: sw,
          height: sh,
          rx: 5,
          fill: light,
          opacity: "0.22"
        }), /*#__PURE__*/React.createElement("rect", {
          x: legInset + aW,
          y: H - legInset - legSize,
          width: legSize,
          height: legSize,
          rx: 0.8,
          fill: st,
          opacity: "0.12"
        }), /*#__PURE__*/React.createElement("rect", {
          x: W - legInset - legSize,
          y: H - legInset - legSize,
          width: legSize,
          height: legSize,
          rx: 0.8,
          fill: st,
          opacity: "0.12"
        }));
      }(),
      "middle": /*#__PURE__*/React.createElement("svg", {
        width: W,
        height: H,
        viewBox: "0 0 ".concat(W, " ").concat(H)
      }, fabDefs, /*#__PURE__*/React.createElement("rect", {
        x: 0.5,
        y: 0.5,
        width: W - 1,
        height: H - 1,
        rx: frameR,
        fill: base,
        stroke: st,
        strokeWidth: "0.5"
      }), /*#__PURE__*/React.createElement("rect", {
        x: gap + 0.5,
        y: gap + 0.5,
        width: W - gap * 2 - 1,
        height: backD - gap,
        rx: backD * 0.44,
        fill: dark,
        opacity: "0.38"
      }), /*#__PURE__*/React.createElement("rect", {
        x: gap + 0.5,
        y: backD + gap,
        width: W - gap * 2 - 1,
        height: H - backD - gap * 2,
        rx: 5,
        fill: light,
        opacity: "0.22"
      }), /*#__PURE__*/React.createElement("rect", {
        x: legInset,
        y: H - legInset - legSize,
        width: legSize,
        height: legSize,
        rx: 0.8,
        fill: st,
        opacity: "0.12"
      }), /*#__PURE__*/React.createElement("rect", {
        x: W - legInset - legSize,
        y: H - legInset - legSize,
        width: legSize,
        height: legSize,
        rx: 0.8,
        fill: st,
        opacity: "0.12"
      })),
      "right": function () {
        var aW = armW + 1.5;
        var aH = H * 0.48;
        var bD = backD;
        var bR = bD * 0.44;
        var aR = Math.min(aW, aH) * 0.3;
        var sGap = 1.2;
        var bW = W - aW - sGap * 2;
        var sx = sGap,
          sy = bD + sGap;
        var sw = W - aW - sGap * 2,
          sh = H - bD - sGap * 2;
        return /*#__PURE__*/React.createElement("svg", {
          width: W,
          height: H,
          viewBox: "0 0 ".concat(W, " ").concat(H)
        }, fabDefs, /*#__PURE__*/React.createElement("path", {
          d: "M ".concat(frameR, " 0.5 L ").concat(W - aR - 1, " 0.5 Q ").concat(W - 0.5, " 0.5 ").concat(W - 0.5, " ").concat(aR + 1, " L ").concat(W - 0.5, " ").concat(H - frameR, " Q ").concat(W - 0.5, " ").concat(H - 0.5, " ").concat(W - frameR, " ").concat(H - 0.5, " L ").concat(frameR, " ").concat(H - 0.5, " Q 0.5 ").concat(H - 0.5, " 0.5 ").concat(H - frameR, " L 0.5 ").concat(frameR, " Q 0.5 0.5 ").concat(frameR, " 0.5 Z"),
          fill: base,
          stroke: st,
          strokeWidth: "0.5"
        }), /*#__PURE__*/React.createElement("rect", {
          x: sGap + 0.5,
          y: sGap + 0.5,
          width: bW,
          height: bD - sGap,
          rx: bR,
          fill: dark,
          opacity: "0.38"
        }), /*#__PURE__*/React.createElement("rect", {
          x: W - aW,
          y: sGap + 0.5,
          width: aW - sGap - 0.5,
          height: aH,
          rx: aR,
          fill: mid,
          opacity: "0.38"
        }), /*#__PURE__*/React.createElement("rect", {
          x: sx + 0.5,
          y: sy,
          width: sw,
          height: sh,
          rx: 5,
          fill: light,
          opacity: "0.22"
        }), /*#__PURE__*/React.createElement("rect", {
          x: legInset,
          y: H - legInset - legSize,
          width: legSize,
          height: legSize,
          rx: 0.8,
          fill: st,
          opacity: "0.12"
        }), /*#__PURE__*/React.createElement("rect", {
          x: W - aW - legInset - legSize,
          y: H - legInset - legSize,
          width: legSize,
          height: legSize,
          rx: 0.8,
          fill: st,
          opacity: "0.12"
        }));
      }(),
      "corner": function () {
        var sideW = backD;
        var csx = sideW + gap,
          csy = backD + gap;
        var csw = W - sideW - gap * 2,
          csh = H - backD - gap * 2;
        return /*#__PURE__*/React.createElement("svg", {
          width: W,
          height: H,
          viewBox: "0 0 ".concat(W, " ").concat(H)
        }, fabDefs, /*#__PURE__*/React.createElement("rect", {
          x: 0.5,
          y: 0.5,
          width: W - 1,
          height: H - 1,
          rx: frameR,
          fill: base,
          stroke: st,
          strokeWidth: "0.5"
        }), /*#__PURE__*/React.createElement("rect", {
          x: gap,
          y: gap,
          width: W - gap * 2,
          height: backD - gap,
          rx: backR,
          fill: dark,
          opacity: "0.4"
        }), /*#__PURE__*/React.createElement("rect", {
          x: gap,
          y: gap,
          width: sideW - gap,
          height: H - gap * 2,
          rx: backR,
          fill: dark,
          opacity: "0.4"
        }), /*#__PURE__*/React.createElement("rect", {
          x: csx,
          y: csy,
          width: csw,
          height: csh,
          rx: seatR,
          fill: light,
          opacity: "0.25"
        }), /*#__PURE__*/React.createElement("rect", {
          x: legInset,
          y: H - legInset - legSize,
          width: legSize,
          height: legSize,
          rx: 1,
          fill: st,
          opacity: "0.2"
        }), /*#__PURE__*/React.createElement("rect", {
          x: W - legInset - legSize,
          y: H - legInset - legSize,
          width: legSize,
          height: legSize,
          rx: 1,
          fill: st,
          opacity: "0.2"
        }));
      }(),
      "pouf": /*#__PURE__*/React.createElement("svg", {
        width: W,
        height: H,
        viewBox: "0 0 ".concat(W, " ").concat(H)
      }, fabDefs, /*#__PURE__*/React.createElement("rect", {
        x: 0.5,
        y: 0.5,
        width: W - 1,
        height: H - 1,
        rx: frameR,
        fill: base,
        stroke: st,
        strokeWidth: "0.5"
      }), /*#__PURE__*/React.createElement("rect", {
        x: gap + 1,
        y: gap + 1,
        width: W - gap * 2 - 2,
        height: H - gap * 2 - 2,
        rx: seatR,
        fill: light,
        opacity: "0.3"
      }), /*#__PURE__*/React.createElement("line", {
        x1: W / 2,
        y1: gap + 4,
        x2: W / 2,
        y2: H - gap - 4,
        stroke: div,
        strokeWidth: "0.5",
        opacity: "0.25"
      }), /*#__PURE__*/React.createElement("line", {
        x1: gap + 4,
        y1: H / 2,
        x2: W - gap - 4,
        y2: H / 2,
        stroke: div,
        strokeWidth: "0.5",
        opacity: "0.25"
      }), /*#__PURE__*/React.createElement("rect", {
        x: legInset,
        y: H - legInset - legSize,
        width: legSize,
        height: legSize,
        rx: 1,
        fill: st,
        opacity: "0.2"
      }), /*#__PURE__*/React.createElement("rect", {
        x: W - legInset - legSize,
        y: H - legInset - legSize,
        width: legSize,
        height: legSize,
        rx: 1,
        fill: st,
        opacity: "0.2"
      })),
      "chaise-l": function () {
        var bkW = W * 0.63;
        var sy = backD + gap,
          sh = H - backD - gap * 2;
        return /*#__PURE__*/React.createElement("svg", {
          width: W,
          height: H,
          viewBox: "0 0 ".concat(W, " ").concat(H)
        }, fabDefs, /*#__PURE__*/React.createElement("rect", {
          x: 0.5,
          y: 0.5,
          width: W - 1,
          height: H - 1,
          rx: frameR,
          fill: base,
          stroke: st,
          strokeWidth: "0.5"
        }), /*#__PURE__*/React.createElement("rect", {
          x: gap,
          y: gap,
          width: bkW,
          height: backD - gap,
          rx: backR,
          fill: dark,
          opacity: "0.4"
        }), /*#__PURE__*/React.createElement("rect", {
          x: gap,
          y: sy,
          width: bkW - gap,
          height: sh,
          rx: seatR,
          fill: light,
          opacity: "0.3"
        }), /*#__PURE__*/React.createElement("rect", {
          x: bkW + gap,
          y: sy,
          width: W - bkW - gap * 2,
          height: sh,
          rx: seatR,
          fill: light,
          opacity: "0.22"
        }), /*#__PURE__*/React.createElement("line", {
          x1: bkW,
          y1: sy + 3,
          x2: bkW,
          y2: sy + sh - 3,
          stroke: div,
          strokeWidth: "0.5",
          opacity: "0.3"
        }), /*#__PURE__*/React.createElement("rect", {
          x: legInset,
          y: H - legInset - legSize,
          width: legSize,
          height: legSize,
          rx: 1,
          fill: st,
          opacity: "0.2"
        }), /*#__PURE__*/React.createElement("rect", {
          x: W - legInset - legSize,
          y: H - legInset - legSize,
          width: legSize,
          height: legSize,
          rx: 1,
          fill: st,
          opacity: "0.2"
        }));
      }(),
      "chaise-r": function () {
        var bkW = W * 0.63;
        var bkX = W - bkW;
        var sy = backD + gap,
          sh = H - backD - gap * 2;
        return /*#__PURE__*/React.createElement("svg", {
          width: W,
          height: H,
          viewBox: "0 0 ".concat(W, " ").concat(H)
        }, fabDefs, /*#__PURE__*/React.createElement("rect", {
          x: 0.5,
          y: 0.5,
          width: W - 1,
          height: H - 1,
          rx: frameR,
          fill: base,
          stroke: st,
          strokeWidth: "0.5"
        }), /*#__PURE__*/React.createElement("rect", {
          x: bkX,
          y: gap,
          width: bkW - gap,
          height: backD - gap,
          rx: backR,
          fill: dark,
          opacity: "0.4"
        }), /*#__PURE__*/React.createElement("rect", {
          x: bkX + gap,
          y: sy,
          width: bkW - gap * 2,
          height: sh,
          rx: seatR,
          fill: light,
          opacity: "0.3"
        }), /*#__PURE__*/React.createElement("rect", {
          x: gap,
          y: sy,
          width: bkX - gap * 2,
          height: sh,
          rx: seatR,
          fill: light,
          opacity: "0.22"
        }), /*#__PURE__*/React.createElement("line", {
          x1: bkX,
          y1: sy + 3,
          x2: bkX,
          y2: sy + sh - 3,
          stroke: div,
          strokeWidth: "0.5",
          opacity: "0.3"
        }), /*#__PURE__*/React.createElement("rect", {
          x: legInset,
          y: H - legInset - legSize,
          width: legSize,
          height: legSize,
          rx: 1,
          fill: st,
          opacity: "0.2"
        }), /*#__PURE__*/React.createElement("rect", {
          x: W - legInset - legSize,
          y: H - legInset - legSize,
          width: legSize,
          height: legSize,
          rx: 1,
          fill: st,
          opacity: "0.2"
        }));
      }(),
      "long-l": function () {
        var armLen = H * 0.50;
        var sy = backD + gap;
        var topH = armLen - backD - gap;
        var botY = armLen + gap;
        var botH = H - armLen - gap * 2;
        return /*#__PURE__*/React.createElement("svg", {
          width: W,
          height: H,
          viewBox: "0 0 ".concat(W, " ").concat(H)
        }, fabDefs, /*#__PURE__*/React.createElement("rect", {
          x: 0.5,
          y: 0.5,
          width: W - 1,
          height: H - 1,
          rx: frameR,
          fill: base,
          stroke: st,
          strokeWidth: "0.5"
        }), /*#__PURE__*/React.createElement("rect", {
          x: gap,
          y: gap,
          width: W - gap * 2,
          height: backD - gap,
          rx: backR,
          fill: dark,
          opacity: "0.4"
        }), /*#__PURE__*/React.createElement("rect", {
          x: gap,
          y: gap,
          width: armW - gap,
          height: armLen,
          rx: backR,
          fill: mid,
          opacity: "0.45"
        }), /*#__PURE__*/React.createElement("rect", {
          x: armW + gap,
          y: sy,
          width: W - armW - gap * 2,
          height: topH,
          rx: seatR,
          fill: light,
          opacity: "0.3"
        }), /*#__PURE__*/React.createElement("rect", {
          x: gap,
          y: botY,
          width: W - gap * 2,
          height: botH,
          rx: seatR,
          fill: light,
          opacity: "0.22"
        }), /*#__PURE__*/React.createElement("line", {
          x1: gap + 4,
          y1: armLen,
          x2: W - gap - 4,
          y2: armLen,
          stroke: div,
          strokeWidth: "0.5",
          opacity: "0.25"
        }), /*#__PURE__*/React.createElement("rect", {
          x: legInset,
          y: H - legInset - legSize,
          width: legSize,
          height: legSize,
          rx: 1,
          fill: st,
          opacity: "0.2"
        }), /*#__PURE__*/React.createElement("rect", {
          x: W - legInset - legSize,
          y: H - legInset - legSize,
          width: legSize,
          height: legSize,
          rx: 1,
          fill: st,
          opacity: "0.2"
        }));
      }(),
      "long-r": function () {
        var armLen = H * 0.50;
        var sy = backD + gap;
        var topH = armLen - backD - gap;
        var botY = armLen + gap;
        var botH = H - armLen - gap * 2;
        return /*#__PURE__*/React.createElement("svg", {
          width: W,
          height: H,
          viewBox: "0 0 ".concat(W, " ").concat(H)
        }, fabDefs, /*#__PURE__*/React.createElement("rect", {
          x: 0.5,
          y: 0.5,
          width: W - 1,
          height: H - 1,
          rx: frameR,
          fill: base,
          stroke: st,
          strokeWidth: "0.5"
        }), /*#__PURE__*/React.createElement("rect", {
          x: gap,
          y: gap,
          width: W - gap * 2,
          height: backD - gap,
          rx: backR,
          fill: dark,
          opacity: "0.4"
        }), /*#__PURE__*/React.createElement("rect", {
          x: W - armW,
          y: gap,
          width: armW - gap,
          height: armLen,
          rx: backR,
          fill: mid,
          opacity: "0.45"
        }), /*#__PURE__*/React.createElement("rect", {
          x: gap,
          y: sy,
          width: W - armW - gap * 2,
          height: topH,
          rx: seatR,
          fill: light,
          opacity: "0.3"
        }), /*#__PURE__*/React.createElement("rect", {
          x: gap,
          y: botY,
          width: W - gap * 2,
          height: botH,
          rx: seatR,
          fill: light,
          opacity: "0.22"
        }), /*#__PURE__*/React.createElement("line", {
          x1: gap + 4,
          y1: armLen,
          x2: W - gap - 4,
          y2: armLen,
          stroke: div,
          strokeWidth: "0.5",
          opacity: "0.25"
        }), /*#__PURE__*/React.createElement("rect", {
          x: legInset,
          y: H - legInset - legSize,
          width: legSize,
          height: legSize,
          rx: 1,
          fill: st,
          opacity: "0.2"
        }), /*#__PURE__*/React.createElement("rect", {
          x: W - legInset - legSize,
          y: H - legInset - legSize,
          width: legSize,
          height: legSize,
          rx: 1,
          fill: st,
          opacity: "0.2"
        }));
      }()
    };
    var glbKey = MODULE_TO_GLB[def.id] ? def.id + "|" + ((fabricObj === null || fabricObj === void 0 ? void 0 : fabricObj.id) || "") : null;
    var thumbUrl = glbKey ? thumbCache[glbKey] : null;
    var armExtra = def.id === "long-l" || def.id === "long-r" ? LONG_ARM_CM * CM2PX : 0;
    var dispW = W + armExtra;
    var bias = armExtra * (def.id === "long-l" ? 0.5 : def.id === "long-r" ? -0.5 : 0);
    var dispLeft = (w - dispW) / 2 + bias;
    var dispOrigin = armExtra ? "".concat(w / 2 - dispLeft, "px ").concat(H / 2, "px") : "center";
    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: "absolute",
        width: dispW,
        height: H,
        left: dispLeft,
        top: (h - H) / 2,
        transform: "rotate(".concat(rot, "deg) scale(").concat(snugScale(dispW), ", ").concat(snugScale(H), ")"),
        transformOrigin: dispOrigin,
        pointerEvents: "none",
        borderRadius: 5,
        overflow: "hidden",
        outline: isSel ? "2px solid #000" : "none",
        outlineOffset: isSel ? 1 : 0,
        boxShadow: isSel ? "0 0 0 4px rgba(26,26,26,0.08)" : "none",
        transition: "box-shadow 0.15s, outline 0.15s"
      }
    }, thumbUrl ? /*#__PURE__*/React.createElement("img", {
      src: thumbUrl,
      alt: "",
      style: {
        width: "100%",
        height: "100%",
        objectFit: "fill",
        display: "block"
      },
      draggable: false
    }) : glbKey ? /*#__PURE__*/React.createElement(BakePlaceholder, {
      w: dispW,
      h: H,
      logoScale: 0.4,
      counterRot: rot
    }) : shapes[def.id] || shapes["middle"]);
  };
  var ModuleOnCanvas = function ModuleOnCanvas(_ref26) {
    var m = _ref26.m;
    var def = MODULE_DEFS.find(function (d) {
      return d.id === m.mid;
    });
    if (!def) return null;
    var _getModPx = getModPx(def, m.rot),
      w = _getModPx.w,
      h = _getModPx.h;
    var isSel = selected === m.iid;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: "absolute",
        left: m.x,
        top: m.y,
        width: w,
        height: h,
        cursor: "grab",
        userSelect: "none",
        WebkitUserSelect: "none",
        zIndex: isSel ? 50 : 1
      }
    }, /*#__PURE__*/React.createElement(ModuleShape, {
      def: def,
      w: w,
      h: h,
      rot: m.rot,
      isSel: isSel
    }));
  };
  var FloatingRotateBtn = function FloatingRotateBtn() {
    if (!selected) return null;
    var m = modules.find(function (mm) {
      return mm.iid === selected;
    });
    if (!m) return null;
    var def = MODULE_DEFS.find(function (d) {
      return d.id === m.mid;
    });
    if (!def) return null;
    var _getModPx2 = getModPx(def, m.rot),
      w = _getModPx2.w;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: "absolute",
        left: m.x + w / 2,
        top: m.y,
        zIndex: 200,
        transform: "translate(-50%, -100%) scale(".concat(1 / zoom, ")"),
        transformOrigin: "50% 100%",
        paddingBottom: 10,
        display: "flex",
        gap: 4
      }
    }, /*#__PURE__*/React.createElement("button", {
      onPointerDown: function onPointerDown(e) {
        e.stopPropagation();
        rotateModule(selected);
      },
      style: sty.floatBtn
    }, "\u21BB 90\xB0"), /*#__PURE__*/React.createElement("button", {
      onPointerDown: function onPointerDown(e) {
        e.stopPropagation();
        removeModule(selected);
      },
      style: sty.floatBtn,
      "aria-label": t("remove")
    }, "\u2715"));
  };
  var GhostPreview = function GhostPreview() {
    if (!ghost) return null;
    var def = MODULE_DEFS.find(function (d) {
      return d.id === ghost.mid;
    });
    if (!def) return null;
    var _getModPx3 = getModPx(def, ghost.rot),
      w = _getModPx3.w,
      h = _getModPx3.h;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: "absolute",
        left: ghost.x,
        top: ghost.y,
        width: w,
        height: h,
        border: "2px dashed #4A9E6F",
        borderRadius: 5,
        background: "rgba(74,158,111,0.1)",
        pointerEvents: "none",
        zIndex: 50,
        boxShadow: "0 0 0 3px rgba(74,158,111,0.06)"
      }
    });
  };
  var loadPreset = function loadPreset(p) {
    setModules(p.mods.map(function (m) {
      return {
        mid: m.mid,
        x: m.x,
        y: m.y,
        rot: m.rot,
        iid: uid()
      };
    }));
    pendingCenterRef.current = true;
    setConnections([]);
    setSelected(null);
    setViewMode("3d");
    setZoom(zoomBase);
    setPan({
      x: 0,
      y: 0
    });
    setPresetScreen(false);
    setWizOpen(false);
    setWizResults(null);
    track("preset_select", {
      preset_id: p.id
    });
  };
  var runWizard = function runWizard() {
    var ps = +wizPersons || 0;
    var mw = wizMaxW ? +wizMaxW : Infinity;
    var md = wizMaxD ? +wizMaxD : Infinity;
    var fitVal = function fitVal(p) {
      return Math.min(Math.max(0, p.dims.w - mw) + Math.max(0, p.dims.d - md), Math.max(0, p.dims.d - mw) + Math.max(0, p.dims.w - md));
    };
    var bySeats = PRESETS_BUILT.filter(function (p) {
      return p.seats >= ps;
    });
    var pool = bySeats.length ? bySeats : PRESETS_BUILT;
    var scored = pool.map(function (p) {
      return _objectSpread(_objectSpread({}, p), {}, {
        exceed: Math.round(fitVal(p))
      });
    }).sort(function (a, b) {
      return a.exceed - b.exceed || a.priceBase - b.priceBase;
    });
    var fitting = scored.filter(function (p) {
      return p.exceed === 0;
    });
    setWizResults(fitting.length ? fitting : scored.slice(0, 3));
    track("wizard_used", {
      persons: ps,
      max_w: wizMaxW || "",
      max_d: wizMaxD || "",
      fits: fitting.length
    });
    setTimeout(function () {
      var grid = document.querySelector("[data-preset-grid]");
      if (!grid) return;
      var sc = grid.parentElement;
      while (sc && getComputedStyle(sc).overflowY !== "auto") sc = sc.parentElement;
      if (sc) {
        var top = grid.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - 8;
        if (sc.scrollTo) sc.scrollTo({
          top: Math.max(0, top),
          behavior: "smooth"
        });else sc.scrollTop = Math.max(0, top);
      }
      var pin = function pin() {
        if (window.scrollY) window.scrollTo(0, 0);
      };
      pin();
      setTimeout(pin, 180);
      setTimeout(pin, 420);
    }, 0);
  };
  var saveVariant = function saveVariant() {
    if (!modules.length || variants.length >= 3) return;
    var mnX = 1e9,
      mxX = -1e9,
      mnY = 1e9,
      mxY = -1e9;
    modules.forEach(function (m) {
      var d = MODULE_DEFS.find(function (dd) {
        return dd.id === m.mid;
      });
      if (!d) return;
      var sw = m.rot === 90 || m.rot === 270;
      var w = (sw ? d.d : d.w) * CM2PX,
        h = (sw ? d.w : d.d) * CM2PX;
      mnX = Math.min(mnX, m.x);
      mxX = Math.max(mxX, m.x + w);
      mnY = Math.min(mnY, m.y);
      mxY = Math.max(mxY, m.y + h);
    });
    setVariants(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        label: "ABC"[prev.length],
        fabric: fabric,
        totalCents: totalCents,
        currency: displayCurrency,
        dims: {
          w: Math.round((mxX - mnX) / CM2PX),
          d: Math.round((mxY - mnY) / CM2PX)
        },
        modules: modules.map(function (m) {
          return {
            mid: m.mid,
            x: m.x,
            y: m.y,
            rot: m.rot
          };
        }),
        addons: addons.map(function (a) {
          return _objectSpread({}, a);
        })
      }]);
    });
    track("compare_save", {
      modules: modules.length,
      total: totalCents
    });
  };
  var loadVariant = function loadVariant(v) {
    setModules(v.modules.map(function (m) {
      return _objectSpread(_objectSpread({}, m), {}, {
        iid: uid()
      });
    }));
    setConnections([]);
    setFabric(v.fabric);
    setSelected(null);
    setViewMode("2d");
    setAddons(Array.isArray(v.addons) ? v.addons.map(function (a) {
      return _objectSpread({}, a);
    }) : []);
    setShowCompare(false);
    track("compare_load");
  };
  var PresetLayout = function PresetLayout(_ref27) {
    var mods = _ref27.mods,
      _ref27$w = _ref27.w,
      w = _ref27$w === void 0 ? 170 : _ref27$w,
      _ref27$h = _ref27.h,
      h = _ref27$h === void 0 ? 96 : _ref27$h,
      fabricId = _ref27.fabricId,
      fill = _ref27.fill;
    var fid = fabricId || (fabricObj === null || fabricObj === void 0 ? void 0 : fabricObj.id) || "";
    var mnX = 1e9,
      mxX = -1e9,
      mnY = 1e9,
      mxY = -1e9;
    var items = mods.map(function (m) {
      var d = MODULE_DEFS.find(function (dd) {
        return dd.id === m.mid;
      });
      var sw = m.rot === 90 || m.rot === 270;
      var bw = (sw ? d.d : d.w) * CM2PX,
        bh = (sw ? d.w : d.d) * CM2PX;
      mnX = Math.min(mnX, m.x);
      mxX = Math.max(mxX, m.x + bw);
      mnY = Math.min(mnY, m.y);
      mxY = Math.max(mxY, m.y + bh);
      return {
        m: m,
        d: d,
        bw: bw,
        bh: bh
      };
    });
    var anyReady = items.some(function (it) {
      return MODULE_TO_GLB[it.m.mid] && thumbCache[it.m.mid + "|" + fid];
    });
    if (!anyReady) return /*#__PURE__*/React.createElement(MiniLayout, {
      mods: mods,
      w: w,
      h: h,
      fill: fill
    });
    var k = Math.min(w / (mxX - mnX), h / (mxY - mnY)) * 0.96;
    var cw = (mxX - mnX) * k,
      ch = (mxY - mnY) * k;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        width: w,
        height: h,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        position: "relative",
        width: cw,
        height: ch
      }
    }, items.map(function (it, i) {
      var W = it.d.w * CM2PX * k,
        H = it.d.d * CM2PX * k;
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        style: {
          position: "absolute",
          left: (it.m.x - mnX) * k,
          top: (it.m.y - mnY) * k,
          width: it.bw * k,
          height: it.bh * k
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: "absolute",
          width: W,
          height: H,
          left: (it.bw * k - W) / 2,
          top: (it.bh * k - H) / 2,
          transform: "rotate(".concat(it.m.rot || 0, "deg) scale(").concat(snugScale(W), ", ").concat(snugScale(H), ")")
        }
      }, thumbCache[it.m.mid + "|" + fid] ? /*#__PURE__*/React.createElement("img", {
        src: thumbCache[it.m.mid + "|" + fid],
        alt: "",
        draggable: false,
        style: {
          width: "100%",
          height: "100%",
          objectFit: "fill",
          display: "block"
        }
      }) : /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%",
          height: "100%",
          borderRadius: 3,
          background: fill || (fabricObj === null || fabricObj === void 0 ? void 0 : fabricObj.hex) || "#D8CBB8",
          border: "0.5px solid rgba(0,0,0,0.18)"
        }
      })));
    })));
  };
  var PresetCard = function PresetCard(_ref28) {
    var p = _ref28.p;
    return /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return loadPreset(p);
      },
      style: {
        background: "#fff",
        color: "#000",
        border: "0.5px solid #E0E0E0",
        borderRadius: 10,
        padding: 14,
        cursor: "pointer",
        fontFamily: "inherit",
        textAlign: "center",
        position: "relative"
      }
    }, p.exceed !== undefined && /*#__PURE__*/React.createElement("span", {
      style: {
        position: "absolute",
        top: 8,
        right: 8,
        zIndex: 2,
        fontSize: 10,
        fontWeight: 500,
        lineHeight: 1,
        padding: "5px 8px",
        borderRadius: 60,
        whiteSpace: "nowrap",
        color: p.exceed === 0 ? "#2F7D55" : "#A5322A",
        background: p.exceed === 0 ? "#EAF5EE" : "#FBEDEB",
        border: p.exceed === 0 ? "0.5px solid #CDE6D8" : "0.5px solid #F2D3CE"
      }
    }, p.exceed === 0 ? "\u2713 ".concat(t("wizFits")) : "".concat(t("wizExceeds"), " ").concat(p.exceed, " cm")), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "center",
        marginBottom: 8
      }
    }, /*#__PURE__*/React.createElement(PresetLayout, {
      mods: p.mods,
      w: 170,
      h: 96
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 11,
        color: "#6B6B6B",
        marginBottom: 4,
        marginTop: 4
      }
    }, p.seats, " ", t("seatsWord"), " ", "·", " ", p.dims.w, " ", "×", " ", p.dims.d, " cm ", "·", " ", p.mods.length, " mod."), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 13,
        fontWeight: 500,
        color: "#000"
      }
    }, t("fromPrice"), " ", formatPrice(setAwareTotal(presetCounts(p), unitPrice).total)));
  };
  var keepInViewOnFocus = function keepInViewOnFocus(e) {
    if (!isMobile) return;
    var el = e.currentTarget;
    var fix = function fix() {
      if (!el.isConnected) return;
      if (window.scrollY || window.pageYOffset) window.scrollTo(0, 0);
      var sc = el.parentElement;
      while (sc && getComputedStyle(sc).overflowY !== "auto") sc = sc.parentElement;
      if (sc) {
        var er = el.getBoundingClientRect(),
          sr = sc.getBoundingClientRect();
        sc.scrollTop += er.top - sr.top - (sr.height - er.height) / 2;
      } else if (el.scrollIntoView) {
        el.scrollIntoView({
          block: "center"
        });
      }
    };
    fix();
    var timers = [setTimeout(fix, 120), setTimeout(fix, 320), setTimeout(fix, 650)];
    var vv = typeof window !== "undefined" ? window.visualViewport : null;
    if (vv) vv.addEventListener("resize", fix);
    var _stop = function stop() {
      timers.forEach(clearTimeout);
      if (vv) vv.removeEventListener("resize", fix);
      el.removeEventListener("blur", _stop);
      setTimeout(function () {
        if (window.scrollY || window.pageYOffset) window.scrollTo(0, 0);
      }, 120);
    };
    el.addEventListener("blur", _stop);
  };
  var wizInputSty = {
    marginTop: 12,
    padding: "8px 2px",
    border: "none",
    borderBottom: "1px solid #000",
    fontFamily: "inherit",
    fontSize: 22,
    fontWeight: 500,
    width: 110,
    background: "transparent",
    textAlign: "center",
    outline: "none",
    color: "#000"
  };
  var wizardPanelJsx = /*#__PURE__*/React.createElement("div", {
    style: {
      background: "#fff",
      border: "0.5px solid #E0E0E0",
      borderRadius: 15,
      padding: "38px 32px 34px",
      maxWidth: 680,
      margin: "0 auto 28px",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 27,
      fontWeight: 500,
      marginBottom: 10,
      letterSpacing: "0.01em"
    }
  }, t("wizIntroTitle")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 14,
      color: "#6B6B6B",
      lineHeight: 1.65,
      maxWidth: 440,
      margin: "0 auto 30px"
    }
  }, t("wizIntroSub")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 40,
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "flex-start",
      marginBottom: 32
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 14,
      color: "#000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 500
    }
  }, t("wizPersons")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11,
      color: "#6B6B6B",
      marginTop: 3
    }
  }, t("wizPersonsHint")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 7,
      marginTop: 16,
      justifyContent: "center"
    }
  }, [2, 3, 4, 5, 6].map(function (n) {
    return /*#__PURE__*/React.createElement("button", {
      key: n,
      onClick: function onClick() {
        return setWizPersons(n);
      },
      style: {
        width: 42,
        height: 42,
        borderRadius: "50%",
        fontFamily: "inherit",
        fontSize: 14,
        fontWeight: 500,
        cursor: "pointer",
        background: wizPersons === n ? "#000" : "transparent",
        color: wizPersons === n ? "#fff" : "#000",
        border: wizPersons === n ? "1px solid #000" : "1px solid rgba(0,0,0,0.22)",
        transition: "background 0.12s, color 0.12s, border 0.12s"
      }
    }, n, n === 6 ? "+" : "");
  }))), /*#__PURE__*/React.createElement("label", {
    style: {
      fontSize: 14,
      color: "#000",
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 500
    }
  }, t("wizMaxW")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11,
      color: "#6B6B6B",
      marginTop: 3
    }
  }, t("wizMaxWHint")), /*#__PURE__*/React.createElement("input", {
    type: "number",
    min: "98",
    step: "1",
    value: wizMaxW,
    onChange: function onChange(e) {
      return setWizMaxW(e.target.value);
    },
    onFocus: keepInViewOnFocus,
    placeholder: "300",
    style: wizInputSty
  })), /*#__PURE__*/React.createElement("label", {
    style: {
      fontSize: 14,
      color: "#000",
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 500
    }
  }, t("wizMaxD")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11,
      color: "#6B6B6B",
      marginTop: 3
    }
  }, t("wizMaxDHint")), /*#__PURE__*/React.createElement("input", {
    type: "number",
    min: "67",
    step: "1",
    value: wizMaxD,
    onChange: function onChange(e) {
      return setWizMaxD(e.target.value);
    },
    onFocus: keepInViewOnFocus,
    placeholder: "200",
    style: wizInputSty
  }))), /*#__PURE__*/React.createElement("button", {
    onClick: runWizard,
    style: _objectSpread(_objectSpread({}, sty.cartBtn), {}, {
      width: "auto",
      padding: "13px 36px",
      fontSize: 14
    })
  }, t("wizShow")));
  var CompareModal = function CompareModal() {
    return /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        return setShowCompare(false);
      },
      style: {
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        zIndex: 900,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16
      }
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      style: {
        background: "#fff",
        borderRadius: 12,
        padding: 20,
        maxWidth: 780,
        width: "100%",
        maxHeight: "86vh",
        overflowY: "auto",
        fontFamily: "'League Spartan',system-ui,sans-serif"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 14
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 16,
        fontWeight: 500
      }
    }, t("compareTitle")), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return setShowCompare(false);
      },
      style: sty.topBtn
    }, "✕")), variants.length === 0 ? /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 13,
        color: "#6B6B6B"
      }
    }, t("compareEmpty")) : /*#__PURE__*/React.createElement("div", {
      style: {
        display: isMobile ? "flex" : "grid",
        flexDirection: "column",
        gridTemplateColumns: isMobile ? undefined : "repeat(".concat(variants.length, ", 1fr)"),
        gap: isMobile ? 10 : 12
      }
    }, variants.map(function (v, i) {
      var f = FABRICS.find(function (ff) {
        return ff.id === v.fabric;
      });
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        style: {
          border: "0.5px solid #E0E0E0",
          borderRadius: 8,
          padding: 12,
          textAlign: isMobile ? "left" : "center",
          display: isMobile ? "flex" : "block",
          gap: 12,
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flexShrink: 0
        }
      }, !isMobile && /*#__PURE__*/React.createElement("div", {
        style: {
          fontWeight: 500,
          marginBottom: 6,
          fontSize: 13
        }
      }, t("variantWord"), " ", v.label), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(PresetLayout, {
        mods: v.modules,
        w: isMobile ? 104 : 170,
        h: isMobile ? 66 : 100,
        fabricId: v.fabric,
        fill: (f === null || f === void 0 ? void 0 : f.hex) || "#D8CBB8"
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          minWidth: 0,
          flex: 1
        }
      }, isMobile && /*#__PURE__*/React.createElement("div", {
        style: {
          fontWeight: 500,
          marginBottom: 2,
          fontSize: 13
        }
      }, t("variantWord"), " ", v.label), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 11,
          color: "#6B6B6B",
          margin: isMobile ? "0 0 4px" : "6px 0",
          lineHeight: 1.4
        }
      }, v.dims.w, " ", "×", " ", v.dims.d, " cm ", "·", " ", v.modules.length, " mod. ", "·", " ", colorLabel(f)), v.addons && v.addons.length > 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 10,
          color: "#6B6B6B",
          marginBottom: 4,
          lineHeight: 1.4
        }
      }, v.addons.map(function (a) {
        return "".concat(a.qty, "\xD7 ").concat(addonLabel(a));
      }).join(" · ")), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 15,
          fontWeight: 500,
          marginBottom: 8
        }
      }, v.currency ? formatMoney(v.totalCents, v.currency) : "—"), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          gap: 6,
          justifyContent: isMobile ? "flex-start" : "center",
          flexWrap: "wrap"
        }
      }, /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          return loadVariant(v);
        },
        style: sty.topBtn
      }, t("loadVariant")), /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          return setVariants(function (prev) {
            return prev.filter(function (_, j) {
              return j !== i;
            }).map(function (vv, j) {
              return _objectSpread(_objectSpread({}, vv), {}, {
                label: "ABC"[j]
              });
            });
          });
        },
        style: sty.topBtn
      }, t("deleteVariant")))));
    }))));
  };
  var DimsOverlay = function DimsOverlay() {
    if (!showDims || modules.length === 0) return null;
    var mnX = 1e9,
      mxX = -1e9,
      mnY = 1e9,
      mxY = -1e9;
    var items = [];
    modules.forEach(function (m) {
      var d = MODULE_DEFS.find(function (dd) {
        return dd.id === m.mid;
      });
      if (!d) return;
      var sw = m.rot === 90 || m.rot === 270;
      var w = (sw ? d.d : d.w) * CM2PX,
        h = (sw ? d.w : d.d) * CM2PX;
      items.push({
        x1: m.x,
        x2: m.x + w,
        y1: m.y,
        y2: m.y + h
      });
      mnX = Math.min(mnX, m.x);
      mxX = Math.max(mxX, m.x + w);
      mnY = Math.min(mnY, m.y);
      mxY = Math.max(mxY, m.y + h);
    });
    var OFF = 30,
      TICK = 5,
      C = "#333";
    var cmTxt = function cmTxt(px) {
      return Math.round(px / CM2PX) + " cm";
    };
    var xSegs = {};
    items.forEach(function (it) {
      if (Math.abs(it.x1 - mnX) > 2 || Math.abs(it.x2 - mxX) > 2) xSegs[Math.round(it.x1) + "|" + Math.round(it.x2)] = it;
    });
    var ySegMap = {};
    items.forEach(function (it) {
      var k = Math.round(it.y1) + "|" + Math.round(it.y2);
      (ySegMap[k] = ySegMap[k] || {
        y1: it.y1,
        y2: it.y2,
        mods: []
      }).mods.push(it);
    });
    var vSegs = [];
    Object.values(ySegMap).forEach(function (seg) {
      var blockedLeft = function blockedLeft(mod) {
        return items.some(function (o) {
          return o !== mod && o.x2 <= mod.x1 + 2 && !(o.y2 <= seg.y1 + 2 || o.y1 >= seg.y2 - 2);
        });
      };
      var freeLeft = seg.mods.some(function (m) {
        return !blockedLeft(m);
      });
      var isTotal = Math.abs(seg.y1 - mnY) <= 2 && Math.abs(seg.y2 - mxY) <= 2;
      if (freeLeft) vSegs.push(_objectSpread(_objectSpread({}, seg), {}, {
        side: "left"
      }));else if (!isTotal) vSegs.push(_objectSpread(_objectSpread({}, seg), {}, {
        side: "right"
      }));
    });
    var rightBusy = vSegs.some(function (sg) {
      return sg.side === "right";
    });
    var vTotalShown = vSegs.some(function (sg) {
      return Math.abs(sg.y1 - mnY) <= 2 && Math.abs(sg.y2 - mxY) <= 2;
    });
    var H = function H(_ref29) {
      var x1 = _ref29.x1,
        x2 = _ref29.x2,
        y = _ref29.y,
        label = _ref29.label,
        above = _ref29.above;
      return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
        x1: x1,
        y1: y,
        x2: x2,
        y2: y,
        stroke: C,
        strokeWidth: "1"
      }), /*#__PURE__*/React.createElement("line", {
        x1: x1,
        y1: y - TICK,
        x2: x1,
        y2: y + TICK,
        stroke: C,
        strokeWidth: "1"
      }), /*#__PURE__*/React.createElement("line", {
        x1: x2,
        y1: y - TICK,
        x2: x2,
        y2: y + TICK,
        stroke: C,
        strokeWidth: "1"
      }), /*#__PURE__*/React.createElement("text", {
        x: (x1 + x2) / 2,
        y: above ? y - 6 : y + 15,
        textAnchor: "middle",
        fontSize: "11",
        fontFamily: "'League Spartan',system-ui,sans-serif",
        fill: C,
        style: {
          paintOrder: "stroke",
          stroke: "#F6F6F5",
          strokeWidth: 3
        }
      }, label));
    };
    var V = function V(_ref30) {
      var y1 = _ref30.y1,
        y2 = _ref30.y2,
        x = _ref30.x,
        label = _ref30.label,
        right = _ref30.right;
      return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
        x1: x,
        y1: y1,
        x2: x,
        y2: y2,
        stroke: C,
        strokeWidth: "1"
      }), /*#__PURE__*/React.createElement("line", {
        x1: x - TICK,
        y1: y1,
        x2: x + TICK,
        y2: y1,
        stroke: C,
        strokeWidth: "1"
      }), /*#__PURE__*/React.createElement("line", {
        x1: x - TICK,
        y1: y2,
        x2: x + TICK,
        y2: y2,
        stroke: C,
        strokeWidth: "1"
      }), /*#__PURE__*/React.createElement("text", {
        x: right ? x + 7 : x - 7,
        y: (y1 + y2) / 2,
        textAnchor: right ? "start" : "end",
        dominantBaseline: "middle",
        fontSize: "11",
        fontFamily: "'League Spartan',system-ui,sans-serif",
        fill: C,
        style: {
          paintOrder: "stroke",
          stroke: "#F6F6F5",
          strokeWidth: 3
        }
      }, label));
    };
    var LANE_H = 17,
      LANE_V = 34;
    var labelW = function labelW(txt) {
      return txt.length * 5.4 + 8;
    };
    var assignLanes = function assignLanes(segs, spanOf, needOf) {
      var lanes = [];
      return segs.map(function (sg) {
        var _spanOf = spanOf(sg),
          _spanOf2 = _slicedToArray(_spanOf, 2),
          a = _spanOf2[0],
          b = _spanOf2[1];
        var need = needOf(sg);
        var c = need <= b - a ? [a, b] : [(a + b) / 2 - need / 2, (a + b) / 2 + need / 2];
        var li = 0;
        while (lanes[li] && lanes[li].some(function (o) {
          return c[0] < o[1] && c[1] > o[0];
        })) li++;
        (lanes[li] = lanes[li] || []).push(c);
        return _objectSpread(_objectSpread({}, sg), {}, {
          lane: li
        });
      });
    };
    var hSegs = assignLanes(Object.values(xSegs).map(function (it) {
      return _objectSpread(_objectSpread({}, it), {}, {
        label: cmTxt(it.x2 - it.x1)
      });
    }), function (s) {
      return [s.x1, s.x2];
    }, function (s) {
      return labelW(s.label);
    });
    var vLaned = ["left", "right"].flatMap(function (side) {
      return assignLanes(vSegs.filter(function (sg) {
        return sg.side === side;
      }).map(function (sg) {
        return _objectSpread(_objectSpread({}, sg), {}, {
          label: cmTxt(sg.y2 - sg.y1)
        });
      }), function (s) {
        return [s.y1, s.y2];
      }, function () {
        return 15;
      });
    });
    var rightLanes = Math.max.apply(Math, [0].concat(_toConsumableArray(vLaned.filter(function (s) {
      return s.side === "right";
    }).map(function (s) {
      return s.lane + 1;
    }))));
    return /*#__PURE__*/React.createElement("svg", {
      style: {
        position: "absolute",
        left: 0,
        top: 0,
        width: 1,
        height: 1,
        overflow: "visible",
        pointerEvents: "none",
        zIndex: 40
      }
    }, hSegs.map(function (it, i) {
      return /*#__PURE__*/React.createElement(H, {
        key: "x" + i,
        x1: it.x1,
        x2: it.x2,
        y: mxY + OFF + it.lane * LANE_H,
        label: it.label
      });
    }), vLaned.map(function (sg, i) {
      return /*#__PURE__*/React.createElement(V, {
        key: "y" + i,
        y1: sg.y1,
        y2: sg.y2,
        x: sg.side === "left" ? mnX - OFF - sg.lane * LANE_V : mxX + OFF + sg.lane * LANE_V,
        right: sg.side === "right",
        label: sg.label
      });
    }), /*#__PURE__*/React.createElement(H, {
      x1: mnX,
      x2: mxX,
      y: mnY - OFF,
      label: cmTxt(mxX - mnX),
      above: true
    }), !vTotalShown && /*#__PURE__*/React.createElement(V, {
      y1: mnY,
      y2: mxY,
      x: mxX + OFF + Math.max(rightLanes, rightBusy ? 1 : 0) * LANE_V,
      right: true,
      label: cmTxt(mxY - mnY)
    }));
  };
  var zb = isMobile ? sty.zoomBtn : _objectSpread(_objectSpread({}, sty.zoomBtn), {}, {
    minWidth: 38,
    height: 38,
    fontSize: 17
  });
  var tapBtn = function tapBtn(fn) {
    return {
      onPointerDown: function onPointerDown(e) {
        e.stopPropagation();
        if (e.cancelable) e.preventDefault();
        fn();
      },
      onClick: function onClick(e) {
        e.preventDefault();
      }
    };
  };
  var PILL_W = isMobile ? 42 : 50;
  var RulerIcon = function RulerIcon(_ref31) {
    var active = _ref31.active;
    return /*#__PURE__*/React.createElement("svg", {
      width: "17",
      height: "17",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: active ? "#4A9E6F" : "#000",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "1.5",
      y: "7.5",
      width: "21",
      height: "9",
      rx: "1.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 7.5v3M10 7.5v4.5M14 7.5v3M18 7.5v4.5"
    }));
  };
  var zoomControls = function zoomControls() {
    return /*#__PURE__*/React.createElement("div", {
      onPointerDown: function onPointerDown(e) {
        return e.stopPropagation();
      },
      style: {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        right: isMobile ? 10 : 16,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 8,
        zIndex: 200
      }
    }, /*#__PURE__*/React.createElement(ViewSwitch, {
      mode: viewMode,
      isMobile: isMobile,
      onChange: function onChange(m) {
        if (m === "3d") track("view_3d");
        setViewMode(m);
      }
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        width: PILL_W,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: isMobile ? 3 : 5,
        background: "rgba(255,255,255,0.94)",
        borderRadius: 60,
        border: "0.5px solid #E0E0E0",
        padding: isMobile ? 4 : 6
      }
    }, viewMode === "2d" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", _extends({}, tapBtn(function () {
      return zoomToward(1.18);
    }), {
      style: zb,
      "aria-label": "+"
    }), "+"), /*#__PURE__*/React.createElement("button", _extends({}, tapBtn(function () {
      setZoom(zoomBase);
      setPan({
        x: 0,
        y: 0
      });
    }), {
      style: _objectSpread(_objectSpread({}, zb), {}, {
        fontSize: isMobile ? 9 : 11,
        minWidth: isMobile ? 28 : 38
      })
    }), Math.round(zoom / zoomBase * 100), "%"), /*#__PURE__*/React.createElement("button", _extends({}, tapBtn(function () {
      return zoomToward(0.78);
    }), {
      style: zb,
      "aria-label": "\u2212"
    }), "\u2212")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", _extends({}, tapBtn(function () {
      orbRef.current.dist = Math.max(1.8, orbRef.current.dist - 0.5);
    }), {
      style: zb,
      "aria-label": "+"
    }), "+"), /*#__PURE__*/React.createElement("button", _extends({}, tapBtn(function () {
      orbRef.current.dist = Math.min(20, orbRef.current.dist + 0.9);
    }), {
      style: zb,
      "aria-label": "\u2212"
    }), "\u2212"), /*#__PURE__*/React.createElement("button", _extends({}, tapBtn(function () {
      orbRef.current.auto = !orbRef.current.auto;
    }), {
      style: _objectSpread(_objectSpread({}, zb), {}, {
        fontSize: isMobile ? 10 : 13
      }),
      "aria-label": "auto-rotate"
    }), "\u21BB")), /*#__PURE__*/React.createElement("div", {
      style: {
        height: 1,
        alignSelf: "stretch",
        background: "#E0E0E0",
        margin: "2px 4px"
      }
    }), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        if (viewMode === "3d") {
          setViewMode("2d");
          setShowDims(true);
        } else setShowDims(function (v) {
          return !v;
        });
      },
      title: t("dims"),
      "aria-label": t("dims"),
      style: _objectSpread(_objectSpread({}, zb), {}, {
        display: "grid",
        placeItems: "center"
      })
    }, /*#__PURE__*/React.createElement(RulerIcon, {
      active: showDims && viewMode === "2d"
    }))));
  };
  var onSidebarResizeDown = function onSidebarResizeDown(e) {
    e.preventDefault();
    e.stopPropagation();
    sidebarDragRef.current = {
      x: e.clientX,
      w: sidebarW
    };
    try {
      e.currentTarget.setPointerCapture(e.pointerId);
    } catch (err) {}
  };
  var onSidebarResizeMove = function onSidebarResizeMove(e) {
    var d = sidebarDragRef.current;
    if (!d) return;
    var roomy = Math.min(SIDEBAR_MAX, Math.max(SIDEBAR_MIN, window.innerWidth - 380));
    var next = Math.min(roomy, Math.max(SIDEBAR_MIN, d.w - (e.clientX - d.x)));
    d.next = next;
    sidebarWRef.current = next;
    if (sidebarElRef.current) sidebarElRef.current.style.width = next + "px";
  };
  var onSidebarResizeUp = function onSidebarResizeUp() {
    var d = sidebarDragRef.current;
    if (!d) return;
    sidebarDragRef.current = null;
    var next = typeof d.next === "number" ? d.next : d.w;
    sidebarWRef.current = null;
    setSidebarW(next);
    try {
      localStorage.setItem("feum_sidebar_w", String(next));
    } catch (err) {}
  };
  var innerStyle = {
    position: "absolute",
    inset: 0,
    transform: "translate(".concat(pan.x, "px,").concat(pan.y, "px) scale(").concat(zoom, ")"),
    transformOrigin: "0 0"
  };
  var modelSelectorJsx = /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      display: "inline-flex"
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setCollOpen(function (v) {
        return !v;
      });
    },
    style: _objectSpread(_objectSpread({}, sty.paletteActionBtn), {}, {
      gap: 7,
      padding: "0 12px 0 9px",
      borderColor: collOpen ? "#000" : "#E0E0E0"
    })
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 32,
      height: 18,
      flexShrink: 0,
      display: "block"
    }
  }, /*#__PURE__*/React.createElement(CollectionPreview, {
    c: COLLECTIONS.find(function (c) {
      return c.id === collection;
    }) || COLLECTIONS[0],
    h: 18,
    bare: true
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 500
    }
  }, (_COLLECTIONS$find = COLLECTIONS.find(function (c) {
    return c.id === collection;
  })) === null || _COLLECTIONS$find === void 0 ? void 0 : _COLLECTIONS$find.label), /*#__PURE__*/React.createElement("svg", {
    width: "9",
    height: "6",
    viewBox: "0 0 9 6",
    style: {
      transform: collOpen ? "rotate(180deg)" : "none",
      transition: "transform .15s"
    },
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1l3.5 3.5L8 1",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), collOpen && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return setCollOpen(false);
    },
    style: {
      position: "fixed",
      inset: 0,
      zIndex: 800
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      top: "calc(100% + 8px)",
      left: 0,
      zIndex: 801,
      background: "#fff",
      border: "0.5px solid #E0E0E0",
      borderRadius: 12,
      boxShadow: "0 10px 28px rgba(0,0,0,0.14)",
      overflow: "hidden",
      width: 268,
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "block",
      padding: "10px 12px 4px",
      fontSize: 10,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      color: "#9A9A94"
    }
  }, t("modelWord")), COLLECTIONS.map(function (c) {
    return /*#__PURE__*/React.createElement("button", {
      key: c.id,
      disabled: !c.available,
      onClick: function onClick() {
        if (!c.available) return;
        setCollOpen(false);
        if (c.id !== collection) {
          setCollection(c.id);
          track("collection_select", {
            collection: c.id
          });
        }
      },
      style: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        width: "100%",
        textAlign: "left",
        padding: "8px 12px",
        background: c.id === collection ? "#F6F5F3" : "#fff",
        border: "none",
        fontFamily: "inherit",
        cursor: c.available ? "pointer" : "not-allowed"
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        width: 52,
        height: 30,
        flexShrink: 0,
        display: "block"
      }
    }, /*#__PURE__*/React.createElement(CollectionPreview, {
      c: c,
      h: 30
    })), /*#__PURE__*/React.createElement("span", {
      style: {
        minWidth: 0,
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: 6
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 14,
        fontWeight: 500,
        color: c.available ? "#000" : "#8A8681"
      }
    }, c.label), !c.available && /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 9,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        color: "#6B6B6B",
        background: "#F1F0EE",
        padding: "2px 6px",
        borderRadius: 3
      }
    }, t("soon"))), /*#__PURE__*/React.createElement("span", {
      style: {
        display: "block",
        fontSize: 11,
        color: "#6B6B6B",
        lineHeight: 1.35,
        marginTop: 2
      }
    }, t(c.descKey))));
  }))));
  var paletteActions = /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: 6,
      marginBottom: 16
    }
  }, modelSelectorJsx, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setPresetScreen(true);
      setWizOpen(false);
      setWizResults(null);
    },
    style: sty.paletteActionBtn
  }, t("inspirations")), /*#__PURE__*/React.createElement("button", {
    onClick: resetAll,
    style: sty.paletteActionBtn
  }, t("reset")));
  var modulePalette = function modulePalette() {
    return /*#__PURE__*/React.createElement("div", null, paletteActions, /*#__PURE__*/React.createElement("div", {
      style: _objectSpread(_objectSpread({}, sty.label), {}, {
        marginBottom: 4
      })
    }, t("modules")), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 12,
        color: "#6B6B6B",
        lineHeight: 1.4,
        marginBottom: 16
      }
    }, t("modulesSub")), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr 1fr 1fr" : "1fr 1fr 1fr",
        gap: 10
      }
    }, MODULE_DEFS.map(function (d) {
      var dk = "rgba(0,0,0,0.15)",
        bk = "rgba(0,0,0,0.08)";
      var tw = d.w * ICON_SCALE,
        th = Math.min(d.d * ICON_SCALE, ICON_BOX_H);
      var aP = 7 * ICON_SCALE,
        bP = th * 0.18;
      var defaultThumb = /*#__PURE__*/React.createElement("svg", {
        width: tw,
        height: th
      }, /*#__PURE__*/React.createElement("rect", {
        width: tw,
        height: th,
        rx: 2,
        fill: fabHex,
        stroke: dk,
        strokeWidth: "0.7"
      }), /*#__PURE__*/React.createElement("rect", {
        x: 1,
        y: 1,
        width: tw - 2,
        height: bP,
        rx: 1,
        fill: bk
      }));
      var thumb = {
        "left": /*#__PURE__*/React.createElement("svg", {
          width: tw,
          height: th
        }, /*#__PURE__*/React.createElement("rect", {
          width: tw,
          height: th,
          rx: 2,
          fill: fabHex,
          stroke: dk,
          strokeWidth: "0.7"
        }), /*#__PURE__*/React.createElement("rect", {
          width: aP + 1,
          height: th,
          rx: 2,
          fill: dk
        }), /*#__PURE__*/React.createElement("rect", {
          x: aP + 2,
          y: 1,
          width: tw - aP - 3,
          height: bP,
          rx: 1,
          fill: bk
        })),
        "middle": defaultThumb,
        "right": /*#__PURE__*/React.createElement("svg", {
          width: tw,
          height: th
        }, /*#__PURE__*/React.createElement("rect", {
          width: tw,
          height: th,
          rx: 2,
          fill: fabHex,
          stroke: dk,
          strokeWidth: "0.7"
        }), /*#__PURE__*/React.createElement("rect", {
          x: tw - aP - 1,
          width: aP + 1,
          height: th,
          rx: 2,
          fill: dk
        }), /*#__PURE__*/React.createElement("rect", {
          x: 1,
          y: 1,
          width: tw - aP - 3,
          height: bP,
          rx: 1,
          fill: bk
        })),
        "corner": /*#__PURE__*/React.createElement("svg", {
          width: tw,
          height: th
        }, /*#__PURE__*/React.createElement("rect", {
          width: tw,
          height: th,
          rx: 2,
          fill: fabHex,
          stroke: dk,
          strokeWidth: "0.7"
        }), /*#__PURE__*/React.createElement("rect", {
          width: bP + 1,
          height: th,
          rx: 2,
          fill: dk
        }), /*#__PURE__*/React.createElement("rect", {
          width: tw,
          height: bP,
          rx: 2,
          fill: dk
        })),
        "pouf": /*#__PURE__*/React.createElement("svg", {
          width: tw,
          height: th
        }, /*#__PURE__*/React.createElement("rect", {
          width: tw,
          height: th,
          rx: 2,
          fill: fabHex,
          stroke: dk,
          strokeWidth: "0.7"
        }), /*#__PURE__*/React.createElement("rect", {
          x: 2,
          y: 2,
          width: tw - 4,
          height: th - 4,
          rx: 1,
          fill: bk
        })),
        "chaise-l": /*#__PURE__*/React.createElement("svg", {
          width: tw,
          height: th
        }, /*#__PURE__*/React.createElement("rect", {
          width: tw,
          height: th,
          rx: 2,
          fill: fabHex,
          stroke: dk,
          strokeWidth: "0.7"
        }), /*#__PURE__*/React.createElement("rect", {
          x: 1,
          y: 1,
          width: tw * 0.6,
          height: bP,
          rx: 1,
          fill: dk
        })),
        "chaise-r": /*#__PURE__*/React.createElement("svg", {
          width: tw,
          height: th
        }, /*#__PURE__*/React.createElement("rect", {
          width: tw,
          height: th,
          rx: 2,
          fill: fabHex,
          stroke: dk,
          strokeWidth: "0.7"
        }), /*#__PURE__*/React.createElement("rect", {
          x: tw * 0.4 - 1,
          y: 1,
          width: tw * 0.6,
          height: bP,
          rx: 1,
          fill: dk
        })),
        "long-l": /*#__PURE__*/React.createElement("svg", {
          width: tw,
          height: th
        }, /*#__PURE__*/React.createElement("rect", {
          width: tw,
          height: th,
          rx: 2,
          fill: fabHex,
          stroke: dk,
          strokeWidth: "0.7"
        }), /*#__PURE__*/React.createElement("rect", {
          width: aP + 1,
          height: th * 0.55,
          rx: 2,
          fill: dk
        }), /*#__PURE__*/React.createElement("rect", {
          x: 1,
          y: 1,
          width: tw - 2,
          height: bP,
          rx: 1,
          fill: bk
        })),
        "long-r": /*#__PURE__*/React.createElement("svg", {
          width: tw,
          height: th
        }, /*#__PURE__*/React.createElement("rect", {
          width: tw,
          height: th,
          rx: 2,
          fill: fabHex,
          stroke: dk,
          strokeWidth: "0.7"
        }), /*#__PURE__*/React.createElement("rect", {
          x: tw - aP - 1,
          width: aP + 1,
          height: th * 0.55,
          rx: 2,
          fill: dk
        }), /*#__PURE__*/React.createElement("rect", {
          x: 1,
          y: 1,
          width: tw - 2,
          height: bP,
          rx: 1,
          fill: bk
        }))
      };
      var bakedUrl = MODULE_TO_GLB[d.id] ? thumbCache[d.id + "|" + ((fabricObj === null || fabricObj === void 0 ? void 0 : fabricObj.id) || "")] : null;
      return /*#__PURE__*/React.createElement("button", {
        key: d.id,
        className: "umi-mod-card",
        onClick: function onClick() {
          return addModule(d.id);
        },
        disabled: modules.length >= MAX_MODULES,
        style: _objectSpread(_objectSpread({}, sty.card), {}, {
          opacity: modules.length >= MAX_MODULES ? 0.4 : 1,
          cursor: modules.length >= MAX_MODULES ? "not-allowed" : "pointer"
        })
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%",
          height: ICON_BOX_H,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 4
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          transform: MODULE_ICON_ROT[d.id] ? "rotate(".concat(MODULE_ICON_ROT[d.id], "deg)") : "none",
          display: "flex"
        }
      }, bakedUrl ? /*#__PURE__*/React.createElement("img", {
        src: bakedUrl,
        alt: "",
        draggable: false,
        style: {
          width: tw,
          height: th,
          objectFit: "fill",
          display: "block"
        }
      }) : MODULE_TO_GLB[d.id] ? /*#__PURE__*/React.createElement(BakePlaceholder, {
        w: tw,
        h: th,
        logoScale: 0.6,
        counterRot: MODULE_ICON_ROT[d.id] || 0
      }) : thumb[d.id] || defaultThumb)), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 10,
          lineHeight: "12px",
          minHeight: 12,
          color: "#000",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }, moduleLabel(d)), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 9,
          color: "#6B6B6B",
          marginTop: 1
        }
      }, d.w, "\xD7", d.d, "cm"));
    })));
  };
  var fabricSelector = function fabricSelector() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 10,
        marginBottom: 6
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: _objectSpread(_objectSpread({}, sty.label), {}, {
        marginBottom: 0
      })
    }, t("fabric")), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        track("samples_click");
        window.open(FABRIC_SAMPLES_URL, "_blank");
      },
      style: {
        flexShrink: 0,
        padding: "6px 14px",
        background: "transparent",
        color: "#000",
        border: "1px solid #E0E0E0",
        borderRadius: 60,
        fontFamily: "inherit",
        fontSize: 11,
        cursor: "pointer"
      }
    }, t("orderSamples"))), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 15,
        color: "#000",
        fontWeight: 500,
        letterSpacing: "-0.01em"
      }
    }, colorLabel(fabricObj)), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 12,
        color: "#6B6B6B",
        lineHeight: 1.4,
        marginTop: 2,
        marginBottom: 18
      }
    }, t("fabricSub")), FABRIC_COLLECTIONS.map(function (group) {
      return /*#__PURE__*/React.createElement("div", {
        key: group.id,
        style: {
          marginBottom: 20
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 10,
          color: "#6B6B6B",
          marginBottom: 10,
          textTransform: "uppercase",
          letterSpacing: "0.4px"
        }
      }, group.label), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          gap: 14,
          flexWrap: "wrap",
          justifyContent: "flex-start"
        }
      }, group.fabrics.map(function (f) {
        return /*#__PURE__*/React.createElement("button", {
          key: f.id,
          onClick: function onClick() {
            setFabric(f.id);
            track("fabric_select", {
              fabric_id: f.id
            });
          },
          "aria-label": colorLabel(f),
          title: colorLabel(f),
          style: {
            padding: 0,
            background: "none",
            border: "none",
            cursor: "pointer"
          }
        }, /*#__PURE__*/React.createElement(FabricSwatch, {
          url: f.texture ? swatchUrl(f.texture) : null,
          hex: f.hex,
          size: isMobile ? 34 : 40,
          active: fabric === f.id
        }));
      })));
    }));
  };
  var AddonCard = function AddonCard(_ref32) {
    var open = _ref32.open,
      setOpen = _ref32.setOpen,
      title = _ref32.title,
      sub = _ref32.sub,
      price = _ref32.price,
      count = _ref32.count,
      qty = _ref32.qty,
      setQty = _ref32.setQty,
      onAdd = _ref32.onAdd,
      addDisabled = _ref32.addDisabled,
      children = _ref32.children;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        border: "0.5px solid #E0E0E0",
        borderRadius: 12,
        marginBottom: 12,
        overflow: "hidden"
      }
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return setOpen(function (v) {
          return !v;
        });
      },
      style: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "12px 14px",
        background: "none",
        border: "none",
        cursor: "pointer",
        fontFamily: "inherit",
        textAlign: "left"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 13,
        fontWeight: 500,
        color: "#000"
      }
    }, title), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 11,
        color: "#6B6B6B",
        marginTop: 1
      }
    }, count > 0 ? "".concat(count, " ").concat(t("addonsCount")) : "".concat(t("addonsFrom"), " ").concat(formatPrice(price)))), /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 11,
        color: "#6B6B6B",
        transform: open ? "rotate(180deg)" : "none",
        transition: "transform 0.15s"
      }
    }, "⌄")), open && /*#__PURE__*/React.createElement("div", {
      style: {
        padding: "0 14px 14px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 11,
        color: "#6B6B6B",
        lineHeight: 1.4,
        marginBottom: 12
      }
    }, sub), children, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        marginTop: 14
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        border: "1px solid #E0E0E0",
        borderRadius: 60,
        padding: "3px 6px",
        flexShrink: 0
      }
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return setQty(function (q) {
          return Math.max(1, q - 1);
        });
      },
      style: _objectSpread(_objectSpread({}, sty.zoomBtn), {}, {
        border: "none",
        minWidth: 22,
        height: 22
      })
    }, "−"), /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 13,
        minWidth: 12,
        textAlign: "center"
      }
    }, qty), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return setQty(function (q) {
          return Math.min(9, q + 1);
        });
      },
      style: _objectSpread(_objectSpread({}, sty.zoomBtn), {}, {
        border: "none",
        minWidth: 22,
        height: 22
      })
    }, "+")), /*#__PURE__*/React.createElement("button", {
      onClick: onAdd,
      disabled: addDisabled,
      style: {
        flex: 1,
        padding: "10px 0",
        borderRadius: 60,
        border: "1px solid #000",
        background: "#000",
        color: "#fff",
        fontFamily: "inherit",
        fontSize: 12,
        fontWeight: 500,
        cursor: addDisabled ? "default" : "pointer",
        opacity: addDisabled ? 0.35 : 1
      }
    }, t("addonsAdd")))));
  };
  var addonsSection = function addonsSection() {
    var _pillowColorObj$v;
    var swSize = isMobile ? 22 : 24;
    var colorSwatch = function colorSwatch(obj, active, onClick) {
      return /*#__PURE__*/React.createElement("button", {
        key: obj.id,
        onClick: onClick,
        "aria-label": colorLabel(obj),
        title: colorLabel(obj),
        style: {
          padding: 0,
          background: "none",
          border: "none",
          cursor: "pointer"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: swSize,
          height: swSize,
          borderRadius: "50%",
          background: obj.swatch ? "center/cover url(".concat(swatchUrl(obj.swatch), ")") : obj.hex,
          border: active ? "1.5px solid #000" : "1.5px solid transparent",
          boxShadow: active ? "0 0 0 1.5px #fff, 0 0 0 3px #000" : "0 1px 2px rgba(0,0,0,0.12)",
          transition: "box-shadow 0.15s"
        }
      }));
    };
    var thumbW = 132,
      thumbH = Math.round(thumbW * 1.25);
    var previewStyle = {
      width: thumbW,
      height: thumbH,
      borderRadius: 10,
      objectFit: "cover",
      display: "block",
      flexShrink: 0,
      background: "#F0EEE9"
    };
    var pillowFrom = addonFromPrice("pillow"),
      blanketFrom = addonFromPrice("blanket");
    if (pillowFrom == null && blanketFrom == null) return null;
    var pillowPick = {
      kind: "pillow",
      size: pillowSize,
      color: pillowColor
    };
    var blanketPick = {
      kind: "blanket",
      color: blanketColor
    };
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: _objectSpread(_objectSpread({}, sty.label), {}, {
        marginBottom: 4
      })
    }, t("addonsCta")), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 12,
        color: "#6B6B6B",
        lineHeight: 1.4,
        marginBottom: 16
      }
    }, t("addonsCtaSub")), pillowFrom != null && /*#__PURE__*/React.createElement(AddonCard, {
      open: pillowOpen,
      setOpen: setPillowOpen,
      title: t("addonsPillowTitle"),
      sub: t("addonsPillowSub"),
      price: pillowFrom,
      count: addons.filter(function (a) {
        return a.kind === "pillow";
      }).reduce(function (n, a) {
        return n + a.qty;
      }, 0),
      qty: pillowAddQty,
      setQty: setPillowAddQty,
      addDisabled: addonPrice(pillowPick) == null,
      onAdd: function onAdd() {
        if (addonPrice(pillowPick) == null) return;
        addAddon(pillowPick, pillowAddQty);
        setPillowAddQty(1);
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 12
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: addonPackshot(pillowColorObj === null || pillowColorObj === void 0 || (_pillowColorObj$v = pillowColorObj.v) === null || _pillowColorObj$v === void 0 ? void 0 : _pillowColorObj$v[pillowSize], "textures/addons/pillow/packshot-".concat(pillowSize, "-").concat(pillowColor, ".jpg")),
      key: "".concat(pillowSize, "|").concat(pillowColor),
      onLoad: addonImgOk,
      onError: addonImgError("textures/addons/pillow/packshot-".concat(pillowSize, "-").concat(pillowColor, ".jpg")),
      alt: "".concat(colorLabel(pillowColorObj), " ").concat(pillowSizeObj === null || pillowSizeObj === void 0 ? void 0 : pillowSizeObj.label),
      style: previewStyle
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1,
        minWidth: 0
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 10,
        color: "#6B6B6B",
        marginBottom: 6,
        textTransform: "uppercase",
        letterSpacing: "0.4px"
      }
    }, t("addonsSize")), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 8,
        marginBottom: 12,
        flexWrap: "wrap"
      }
    }, PILLOW_SIZES.map(function (s) {
      return /*#__PURE__*/React.createElement("button", {
        key: s.id,
        onClick: function onClick() {
          return setPillowSize(s.id);
        },
        style: {
          padding: "6px 12px",
          borderRadius: 60,
          fontSize: 12,
          fontFamily: "inherit",
          cursor: "pointer",
          border: pillowSize === s.id ? "1px solid #000" : "1px solid #E0E0E0",
          background: pillowSize === s.id ? "#000" : "transparent",
          color: pillowSize === s.id ? "#fff" : "#000"
        }
      }, s.label);
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 10,
        color: "#6B6B6B",
        marginBottom: 8,
        textTransform: "uppercase",
        letterSpacing: "0.4px",
        lineHeight: "13px",
        minHeight: 26
      }
    }, t("addonsColor"), colorLabel(pillowColorObj) && /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: "none",
        letterSpacing: 0,
        color: "#1A1A1A",
        fontWeight: 500
      }
    }, " — " + colorLabel(pillowColorObj))), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 6,
        flexWrap: "wrap"
      }
    }, PILLOW_COLORS.map(function (c) {
      return colorSwatch(c, pillowColor === c.id, function () {
        return setPillowColor(c.id);
      });
    }))))), blanketFrom != null && /*#__PURE__*/React.createElement(AddonCard, {
      open: blanketOpen,
      setOpen: setBlanketOpen,
      title: t("addonsBlanketTitle"),
      sub: t("addonsBlanketSub"),
      price: blanketFrom,
      count: addons.filter(function (a) {
        return a.kind === "blanket";
      }).reduce(function (n, a) {
        return n + a.qty;
      }, 0),
      qty: blanketAddQty,
      setQty: setBlanketAddQty,
      addDisabled: addonPrice(blanketPick) == null,
      onAdd: function onAdd() {
        if (addonPrice(blanketPick) == null) return;
        addAddon(blanketPick, blanketAddQty);
        setBlanketAddQty(1);
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 12
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: addonPackshot(blanketColorObj === null || blanketColorObj === void 0 ? void 0 : blanketColorObj.v, blanketColorObj === null || blanketColorObj === void 0 ? void 0 : blanketColorObj.packshot),
      key: blanketColor,
      onLoad: addonImgOk,
      onError: addonImgError(blanketColorObj === null || blanketColorObj === void 0 ? void 0 : blanketColorObj.packshot),
      alt: colorLabel(blanketColorObj),
      style: previewStyle
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1,
        minWidth: 0
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 10,
        color: "#6B6B6B",
        marginBottom: 8,
        textTransform: "uppercase",
        letterSpacing: "0.4px",
        lineHeight: "13px",
        minHeight: 26
      }
    }, t("addonsColor"), colorLabel(blanketColorObj) && /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: "none",
        letterSpacing: 0,
        color: "#1A1A1A",
        fontWeight: 500
      }
    }, " — " + colorLabel(blanketColorObj))), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 6,
        flexWrap: "wrap"
      }
    }, BLANKET_COLORS.map(function (c) {
      return colorSwatch(c, blanketColor === c.id, function () {
        return setBlanketColor(c.id);
      });
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 10,
        color: "#6B6B6B",
        margin: "14px 0 5px",
        textTransform: "uppercase",
        letterSpacing: "0.4px"
      }
    }, t("addonsSize")), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 13,
        color: "#000",
        marginBottom: 4
      }
    }, BLANKET_SIZE)))), addons.length > 0 && /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 4
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 10,
        color: "#6B6B6B",
        marginBottom: 6,
        textTransform: "uppercase",
        letterSpacing: "0.4px"
      }
    }, t("addonsChosen")), addons.map(function (a) {
      var _BLANKET_COLORS$find;
      return /*#__PURE__*/React.createElement("div", {
        key: a.key,
        style: {
          display: "flex",
          alignItems: "center",
          gap: 10,
          padding: "8px 0",
          borderTop: "0.5px solid #F0EEE9"
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: addonThumb(a),
        onLoad: addonImgOk,
        onError: addonImgError(a.kind === "pillow" ? "textures/addons/pillow/packshot-".concat(a.size, "-").concat(a.color, ".jpg") : (_BLANKET_COLORS$find = BLANKET_COLORS.find(function (c) {
          return c.id === a.color;
        })) === null || _BLANKET_COLORS$find === void 0 ? void 0 : _BLANKET_COLORS$find.packshot),
        alt: "",
        style: {
          width: 36,
          height: 36,
          borderRadius: 6,
          objectFit: "cover",
          flexShrink: 0,
          background: "#F0EEE9"
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1,
          minWidth: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 12,
          color: "#000",
          lineHeight: 1.3
        }
      }, addonLabel(a)), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 10,
          color: "#6B6B6B",
          marginTop: 1
        }
      }, formatPriceOrDash(addonPrice(a) == null ? null : a.qty * addonPrice(a)))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: 8,
          flexShrink: 0
        }
      }, /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          return setAddonQty(a.key, a.qty - 1);
        },
        "aria-label": t("addonsRemove"),
        style: _objectSpread(_objectSpread({}, sty.zoomBtn), {}, {
          border: "0.5px solid #E0E0E0"
        })
      }, "−"), /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 13,
          minWidth: 14,
          textAlign: "center"
        }
      }, a.qty), /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          return setAddonQty(a.key, a.qty + 1);
        },
        "aria-label": t("addonsAdd"),
        style: _objectSpread(_objectSpread({}, sty.zoomBtn), {}, {
          border: "0.5px solid #E0E0E0"
        })
      }, "+")));
    })));
  };
  var imageFrom = function imageFrom(src) {
    return new Promise(function (res, rej) {
      var im = new Image();
      im.onload = function () {
        return res(im);
      };
      im.onerror = rej;
      im.src = src;
    });
  };
  var downloadPDF = /*#__PURE__*/function () {
    var _ref33 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _COLLECTIONS$find2, _FABRIC_COLLECTIONS$f;
      var S, W, H, M, c, x, FF, logo, lw, lh, locale, mnX, mxX, mnY, mxY, bw, bh, areaW, areaH, areaY, k, ox, oy, _iterator17, _step17, _loop1, ty, groups, _loop0, _i9, _Object$entries4, _iterator18, _step18, a, cartUrl, qr, n, qs, cell, qx, qy, r, cc, jsPDFCtor, doc, _t4, _t5, _t6, _t7;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            if (modules.length) {
              _context4.n = 1;
              break;
            }
            return _context4.a(2);
          case 1:
            if (!(typeof window !== "undefined" && window.FEUM_LOAD_PDF_LIBS)) {
              _context4.n = 5;
              break;
            }
            _context4.p = 2;
            _context4.n = 3;
            return window.FEUM_LOAD_PDF_LIBS();
          case 3:
            _context4.n = 5;
            break;
          case 4:
            _context4.p = 4;
            _t4 = _context4.v;
            console.error(_t4);
            alert(t("pdfLibsFailed"));
            return _context4.a(2);
          case 5:
            track("pdf_download", {
              total: totalCents,
              modules: modules.length
            });
            S = 6; // canvas px per mm (A4 = 210x297mm -> 1260x1782 px)
            W = 210 * S, H = 297 * S, M = 18 * S;
            c = document.createElement("canvas");
            c.width = W;
            c.height = H;
            x = c.getContext("2d");
            FF = "'League Spartan', system-ui, sans-serif";
            x.fillStyle = "#fff";
            x.fillRect(0, 0, W, H);
            _context4.p = 6;
            _context4.n = 7;
            return imageFrom(FEUM_LOGO_URL);
          case 7:
            logo = _context4.v;
            lw = 30 * S, lh = lw * (194 / 536);
            x.drawImage(logo, M, M, lw, lh);
            _context4.n = 9;
            break;
          case 8:
            _context4.p = 8;
            _t5 = _context4.v;
          case 9:
            x.fillStyle = "#6B6B6B";
            x.font = "".concat(3.2 * S, "px ").concat(FF);
            x.textAlign = "right";
            locale = lang === "en" ? "en-GB" : lang === "de" ? "de-DE" : "pl-PL";
            x.fillText(new Date().toLocaleDateString(locale), W - M, M + 3.2 * S);
            x.textAlign = "left";
            x.strokeStyle = "#E0E0E0";
            x.lineWidth = 0.35 * S;
            x.beginPath();
            x.moveTo(M, M + 15 * S);
            x.lineTo(W - M, M + 15 * S);
            x.stroke();
            x.fillStyle = "#000";
            x.font = "500 ".concat(6.4 * S, "px ").concat(FF);
            x.fillText(t("pdfTitle"), M, M + 26 * S);
            x.fillStyle = "#6B6B6B";
            x.font = "".concat(3.4 * S, "px ").concat(FF);
            x.fillText("".concat(((_COLLECTIONS$find2 = COLLECTIONS.find(function (cc) {
              return cc.id === collection;
            })) === null || _COLLECTIONS$find2 === void 0 ? void 0 : _COLLECTIONS$find2.label) || "Umi", " \xB7 ").concat(colorLabel(fabricObj)), M, M + 32 * S);
            mnX = 1e9, mxX = -1e9, mnY = 1e9, mxY = -1e9;
            modules.forEach(function (m) {
              var d = MODULE_DEFS.find(function (dd) {
                return dd.id === m.mid;
              });
              if (!d) return;
              var sw = m.rot === 90 || m.rot === 270;
              var w = (sw ? d.d : d.w) * CM2PX,
                h = (sw ? d.w : d.d) * CM2PX;
              mnX = Math.min(mnX, m.x);
              mxX = Math.max(mxX, m.x + w);
              mnY = Math.min(mnY, m.y);
              mxY = Math.max(mxY, m.y + h);
            });
            bw = mxX - mnX, bh = mxY - mnY;
            areaW = W - 2 * M, areaH = 88 * S, areaY = M + 38 * S;
            k = Math.min(areaW / bw, areaH / bh) * 0.94;
            ox = M + (areaW - bw * k) / 2, oy = areaY + (areaH - bh * k) / 2;
            _iterator17 = _createForOfIteratorHelper(modules);
            _context4.p = 10;
            _loop1 = /*#__PURE__*/_regenerator().m(function _loop1() {
              var m, d, Wp, Hp, sw, bwp, bhp, cx, cy, url, sW, sH, _t2, _t3;
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.p = _context3.n) {
                  case 0:
                    m = _step17.value;
                    d = MODULE_DEFS.find(function (dd) {
                      return dd.id === m.mid;
                    });
                    if (d) {
                      _context3.n = 1;
                      break;
                    }
                    return _context3.a(2, 1);
                  case 1:
                    Wp = d.w * CM2PX * k, Hp = d.d * CM2PX * k;
                    sw = m.rot === 90 || m.rot === 270;
                    bwp = (sw ? d.d : d.w) * CM2PX * k, bhp = (sw ? d.w : d.d) * CM2PX * k;
                    cx = ox + (m.x - mnX) * k + bwp / 2, cy = oy + (m.y - mnY) * k + bhp / 2;
                    url = MODULE_TO_GLB[d.id] ? thumbCache[d.id + "|" + ((fabricObj === null || fabricObj === void 0 ? void 0 : fabricObj.id) || "")] : null;
                    x.save();
                    x.translate(cx, cy);
                    x.rotate((m.rot || 0) * Math.PI / 180);
                    sW = Wp * snugScale(Wp), sH = Hp * snugScale(Hp);
                    if (!url) {
                      _context3.n = 6;
                      break;
                    }
                    _context3.p = 2;
                    _t2 = x;
                    _context3.n = 3;
                    return imageFrom(url);
                  case 3:
                    _t2.drawImage.call(_t2, _context3.v, -sW / 2, -sH / 2, sW, sH);
                    _context3.n = 5;
                    break;
                  case 4:
                    _context3.p = 4;
                    _t3 = _context3.v;
                  case 5:
                    _context3.n = 7;
                    break;
                  case 6:
                    x.fillStyle = (fabricObj === null || fabricObj === void 0 ? void 0 : fabricObj.hex) || "#D4C4A8";
                    x.strokeStyle = "rgba(0,0,0,0.25)";
                    x.lineWidth = 0.3 * S;
                    x.fillRect(-sW / 2, -sH / 2, sW, sH);
                    x.strokeRect(-sW / 2, -sH / 2, sW, sH);
                  case 7:
                    x.restore();
                  case 8:
                    return _context3.a(2);
                }
              }, _loop1, null, [[2, 4]]);
            });
            _iterator17.s();
          case 11:
            if ((_step17 = _iterator17.n()).done) {
              _context4.n = 14;
              break;
            }
            return _context4.d(_regeneratorValues(_loop1()), 12);
          case 12:
            if (!_context4.v) {
              _context4.n = 13;
              break;
            }
            return _context4.a(3, 13);
          case 13:
            _context4.n = 11;
            break;
          case 14:
            _context4.n = 16;
            break;
          case 15:
            _context4.p = 15;
            _t6 = _context4.v;
            _iterator17.e(_t6);
          case 16:
            _context4.p = 16;
            _iterator17.f();
            return _context4.f(16);
          case 17:
            x.fillStyle = "#6B6B6B";
            x.font = "".concat(3.1 * S, "px ").concat(FF);
            x.textAlign = "center";
            x.fillText("".concat(Math.round(bw / CM2PX), " cm \xD7 ").concat(Math.round(bh / CM2PX), " cm"), W / 2, areaY + areaH + 5 * S);
            x.textAlign = "left";
            ty = areaY + areaH + 14 * S;
            x.fillStyle = "#6B6B6B";
            x.font = "500 ".concat(2.9 * S, "px ").concat(FF);
            x.fillText(t("modules").toUpperCase(), M, ty);
            x.textAlign = "right";
            x.fillText(t("pdfPrice").toUpperCase(), W - M, ty);
            x.textAlign = "left";
            ty += 2.4 * S;
            x.strokeStyle = "#000";
            x.lineWidth = 0.35 * S;
            x.beginPath();
            x.moveTo(M, ty);
            x.lineTo(W - M, ty);
            x.stroke();
            ty += 5.6 * S;
            groups = {};
            modules.forEach(function (m) {
              groups[m.mid] = (groups[m.mid] || 0) + 1;
            });
            _loop0 = /*#__PURE__*/_regenerator().m(function _loop0() {
              var _Object$entries4$_i, mid, count, d, price;
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.n) {
                  case 0:
                    _Object$entries4$_i = _slicedToArray(_Object$entries4[_i9], 2), mid = _Object$entries4$_i[0], count = _Object$entries4$_i[1];
                    d = MODULE_DEFS.find(function (dd) {
                      return dd.id === mid;
                    });
                    if (d) {
                      _context2.n = 1;
                      break;
                    }
                    return _context2.a(2, 1);
                  case 1:
                    price = unitPrice(mid) * count;
                    x.fillStyle = "#000";
                    x.font = "".concat(3.5 * S, "px ").concat(FF);
                    x.fillText("".concat(moduleLabel(d)).concat(count > 1 ? "  ×" + count : ""), M, ty);
                    x.fillStyle = "#6B6B6B";
                    x.font = "".concat(2.9 * S, "px ").concat(FF);
                    x.fillText("".concat(d.w, " \xD7 ").concat(d.d, " cm"), M + 52 * S, ty);
                    x.fillStyle = "#000";
                    x.font = "".concat(3.5 * S, "px ").concat(FF);
                    x.textAlign = "right";
                    x.fillText(formatPrice(price), W - M, ty);
                    x.textAlign = "left";
                    ty += 3 * S;
                    x.strokeStyle = "#E0E0E0";
                    x.lineWidth = 0.2 * S;
                    x.beginPath();
                    x.moveTo(M, ty);
                    x.lineTo(W - M, ty);
                    x.stroke();
                    ty += 4.6 * S;
                  case 2:
                    return _context2.a(2);
                }
              }, _loop0);
            });
            _i9 = 0, _Object$entries4 = Object.entries(groups);
          case 18:
            if (!(_i9 < _Object$entries4.length)) {
              _context4.n = 21;
              break;
            }
            return _context4.d(_regeneratorValues(_loop0()), 19);
          case 19:
            if (!_context4.v) {
              _context4.n = 20;
              break;
            }
            return _context4.a(3, 20);
          case 20:
            _i9++;
            _context4.n = 18;
            break;
          case 21:
            _iterator18 = _createForOfIteratorHelper(addons);
            _context4.p = 22;
            _iterator18.s();
          case 23:
            if ((_step18 = _iterator18.n()).done) {
              _context4.n = 26;
              break;
            }
            a = _step18.value;
            if (a.qty) {
              _context4.n = 24;
              break;
            }
            return _context4.a(3, 25);
          case 24:
            x.fillStyle = "#000";
            x.font = "".concat(3.5 * S, "px ").concat(FF);
            x.fillText("".concat(addonLabel(a)).concat(a.qty > 1 ? "  ×" + a.qty : ""), M, ty);
            x.fillStyle = "#000";
            x.font = "".concat(3.5 * S, "px ").concat(FF);
            x.textAlign = "right";
            x.fillText(formatPriceOrDash(addonPrice(a) == null ? null : a.qty * addonPrice(a)), W - M, ty);
            x.textAlign = "left";
            ty += 3 * S;
            x.strokeStyle = "#E0E0E0";
            x.lineWidth = 0.2 * S;
            x.beginPath();
            x.moveTo(M, ty);
            x.lineTo(W - M, ty);
            x.stroke();
            ty += 4.6 * S;
          case 25:
            _context4.n = 23;
            break;
          case 26:
            _context4.n = 28;
            break;
          case 27:
            _context4.p = 27;
            _t7 = _context4.v;
            _iterator18.e(_t7);
          case 28:
            _context4.p = 28;
            _iterator18.f();
            return _context4.f(28);
          case 29:
            x.fillStyle = "#000";
            x.font = "".concat(3.5 * S, "px ").concat(FF);
            x.fillText(t("fabric"), M, ty);
            x.fillStyle = "#6B6B6B";
            x.font = "".concat(2.9 * S, "px ").concat(FF);
            x.fillText(((_FABRIC_COLLECTIONS$f = FABRIC_COLLECTIONS.find(function (g) {
              return g.fabrics.some(function (f) {
                return f.id === (fabricObj === null || fabricObj === void 0 ? void 0 : fabricObj.id);
              });
            })) === null || _FABRIC_COLLECTIONS$f === void 0 ? void 0 : _FABRIC_COLLECTIONS$f.label) || "", M + 52 * S, ty);
            x.fillStyle = "#000";
            x.font = "".concat(3.5 * S, "px ").concat(FF);
            x.textAlign = "right";
            x.fillText(colorLabel(fabricObj), W - M, ty);
            x.textAlign = "left";
            ty += 3 * S;
            x.strokeStyle = "#000";
            x.lineWidth = 0.35 * S;
            x.beginPath();
            x.moveTo(M, ty);
            x.lineTo(W - M, ty);
            x.stroke();
            ty += 6.4 * S;
            x.font = "500 ".concat(4.6 * S, "px ").concat(FF);
            x.fillText(t("total"), M, ty);
            x.textAlign = "right";
            x.fillText(formatPrice(totalCents), W - M, ty);
            x.textAlign = "left";
            cartUrl = buildCartPermalink(modules, fabric, addons);
            if (cartUrl && typeof window.qrcode === "function") {
              try {
                qr = window.qrcode(0, "M");
                qr.addData(cartUrl);
                qr.make();
                n = qr.getModuleCount(), qs = 32 * S, cell = qs / n;
                qx = W - M - qs, qy = H - M - qs - 7 * S;
                x.fillStyle = "#000";
                for (r = 0; r < n; r++) for (cc = 0; cc < n; cc++) if (qr.isDark(r, cc)) x.fillRect(qx + cc * cell, qy + r * cell, Math.ceil(cell), Math.ceil(cell));
                x.fillStyle = "#6B6B6B";
                x.font = "".concat(2.8 * S, "px ").concat(FF);
                x.textAlign = "center";
                x.fillText(t("pdfScan"), qx + qs / 2, qy + qs + 4.6 * S);
                x.textAlign = "left";
              } catch (e) {
                console.error("QR failed", e);
              }
            }
            x.fillStyle = "#6B6B6B";
            x.font = "".concat(2.9 * S, "px ").concat(FF);
            x.fillText(t("pdfNote"), M, H - M - 7 * S);
            x.fillStyle = "#000";
            x.font = "500 ".concat(3.6 * S, "px ").concat(FF);
            x.fillText("feum.eu", M, H - M - 1.5 * S);
            jsPDFCtor = window.jspdf && window.jspdf.jsPDF;
            if (jsPDFCtor) {
              _context4.n = 30;
              break;
            }
            alert("PDF library not loaded");
            return _context4.a(2);
          case 30:
            doc = new jsPDFCtor({
              unit: "mm",
              format: "a4"
            });
            doc.addImage(c.toDataURL("image/jpeg", 0.93), "JPEG", 0, 0, 210, 297);
            doc.save("feum-" + (collection || "umi") + "-" + new Date().toISOString().slice(0, 10) + ".pdf");
          case 31:
            return _context4.a(2);
        }
      }, _callee2, null, [[22, 27, 28, 29], [10, 15, 16, 17], [6, 8], [2, 4]]);
    }));
    return function downloadPDF() {
      return _ref33.apply(this, arguments);
    };
  }();
  var pricingSummary = function pricingSummary() {
    var _setPricing$set;
    return /*#__PURE__*/React.createElement("div", null, hasItems && /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: 20
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 18,
        fontWeight: 500,
        color: "#000",
        letterSpacing: "-0.015em",
        lineHeight: 1.25
      }
    }, t("readyTitle")), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 12,
        color: "#6B6B6B",
        marginTop: 5,
        lineHeight: 1.45
      }
    }, t("readySub")), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        if (viewMode !== "3d") track("view_3d");
        setViewMode("3d");
      },
      style: {
        marginTop: 12,
        padding: "6px 14px",
        background: "transparent",
        color: "#000",
        border: "1px solid #E0E0E0",
        borderRadius: 60,
        fontFamily: "inherit",
        fontSize: 11,
        cursor: "pointer",
        whiteSpace: "nowrap"
      }
    }, t("see3d"))), /*#__PURE__*/React.createElement("div", {
      style: sty.label
    }, t("summary")), !hasItems ? /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 12,
        color: "#6B6B6B",
        padding: "8px 0"
      }
    }, t("addModulesToStart")) : /*#__PURE__*/React.createElement(React.Fragment, null, modules.map(function (m) {
      var d = MODULE_DEFS.find(function (dd) {
        return dd.id === m.mid;
      });
      if (!d) return null;
      return /*#__PURE__*/React.createElement("div", {
        key: m.iid,
        onClick: function onClick() {
          return setSelected(m.iid);
        },
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 6,
          fontSize: 12,
          color: selected === m.iid ? "#000" : "#6B6B6B",
          padding: "4px 2px 4px 6px",
          margin: "1px 0",
          borderRadius: 4,
          background: selected === m.iid ? "#EFEFEF" : "transparent",
          cursor: "pointer",
          transition: "background 0.1s"
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: 6,
          minWidth: 0
        }
      }, moduleLabel(d), selected === m.iid && /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 9,
          color: "#4A9E6F",
          fontWeight: 500
        }
      }, t("selectedTag"))), /*#__PURE__*/React.createElement("span", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexShrink: 0
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: REQUIRE_LIVE_PRICES && livePriceOf(m.mid) == null ? {
          color: "#C0392B",
          fontWeight: 500
        } : undefined
      }, REQUIRE_LIVE_PRICES && livePriceOf(m.mid) == null ? "brak ceny live" : formatPrice(unitPrice(m.mid))), /*#__PURE__*/React.createElement("button", {
        onClick: function onClick(e) {
          e.stopPropagation();
          removeModule(m.iid);
        },
        title: removeWord(),
        "aria-label": "".concat(removeWord(), " \xB7 ").concat(moduleLabel(d)),
        style: sty.rowDelBtn
      }, "\u2715")));
    }), addons.map(function (a) {
      return /*#__PURE__*/React.createElement("div", {
        key: a.key,
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: 12,
          color: "#6B6B6B",
          padding: "4px 2px 4px 6px",
          gap: 8
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          minWidth: 0
        }
      }, a.qty, "\xD7 ", addonLabel(a)), /*#__PURE__*/React.createElement("span", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexShrink: 0
        }
      }, /*#__PURE__*/React.createElement("span", null, formatPriceOrDash(addonPrice(a) == null ? null : a.qty * addonPrice(a))), /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          return setAddonQty(a.key, 0);
        },
        title: removeWord(),
        "aria-label": "".concat(removeWord(), " \xB7 ").concat(addonLabel(a)),
        style: sty.rowDelBtn
      }, "\u2715")));
    }), savingsCents > 0 && /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        fontSize: 12,
        color: "#9A9A94",
        borderTop: "0.5px solid #E0E0E0",
        marginTop: 8,
        paddingTop: 10
      }
    }, /*#__PURE__*/React.createElement("span", null, t("separatePrice")), /*#__PURE__*/React.createElement("span", {
      style: {
        textDecoration: "line-through"
      }
    }, formatPrice(totalCents + savingsCents))), /*#__PURE__*/React.createElement("div", {
      "data-total-row": true,
      style: _objectSpread({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline",
        color: "#000"
      }, savingsCents > 0 ? {
        marginTop: 12
      } : {
        borderTop: "0.5px solid #E0E0E0",
        marginTop: 8,
        paddingTop: 10
      })
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 13,
        fontWeight: 500
      }
    }, t("total")), /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 22,
        fontWeight: 500,
        letterSpacing: "-0.02em"
      }
    }, formatPrice(totalCents))), savingsCents > 0 && /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 10,
        background: "#F3F8F5",
        border: "0.5px solid #DCEAE1",
        borderRadius: 8,
        padding: "9px 11px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        gap: 8,
        fontSize: 11,
        fontWeight: 500,
        color: "#3F8C63"
      }
    }, /*#__PURE__*/React.createElement("span", null, setPricing.sets.length === 1 && (_setPricing$set = setPricing.set) !== null && _setPricing$set !== void 0 && _setPricing$set.label ? "".concat(t("setPriceLabel"), " \xB7 ").concat(setPricing.set.label) : t("setPriceLabelMulti")), /*#__PURE__*/React.createElement("span", {
      style: {
        flexShrink: 0
      }
    }, "\u2212", formatPrice(savingsCents))), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 10,
        color: "#7A9A88",
        marginTop: 4,
        lineHeight: 1.45
      }
    }, t("setPriceNote")))), /*#__PURE__*/React.createElement("button", {
      disabled: !hasItems,
      onClick: function onClick() {
        track("add_to_cart_click", {
          total: totalCents,
          modules: modules.length
        });
        var url = buildCartPermalink(modules, fabric, addons);
        if (url && window.Shopify) {
          window.location.href = url;
          return;
        }
        if (url) window.open(url, "_blank");else {
          var _navigator$clipboard;
          var l = buildShoppingList(modules, colorLabel(fabricObj) || fabric, addonsLines, moduleLabel);
          (_navigator$clipboard = navigator.clipboard) === null || _navigator$clipboard === void 0 || _navigator$clipboard.writeText(l);
          alert(t("copied") + "\n\n" + l);
        }
      },
      style: _objectSpread(_objectSpread({}, sty.cartBtn), {}, {
        opacity: !hasItems ? 0.4 : 1,
        cursor: !hasItems ? "not-allowed" : "pointer",
        marginTop: 12
      })
    }, VARIANT_IDS[fabric] ? t("addToCart") : t("copyList")), hasItems && leadTime && /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 11,
        color: "#6B6B6B",
        marginTop: 8,
        textAlign: "center"
      }
    }, leadTime), /*#__PURE__*/React.createElement("button", {
      disabled: !hasItems,
      onClick: function onClick() {
        var _navigator$clipboard2;
        var l = buildShoppingList(modules, colorLabel(fabricObj) || fabric, addonsLines, moduleLabel);
        (_navigator$clipboard2 = navigator.clipboard) === null || _navigator$clipboard2 === void 0 || _navigator$clipboard2.writeText(l);
        alert(t("copied") + "\n\n" + l);
      },
      style: _objectSpread(_objectSpread({}, sty.shareBtn), {}, {
        opacity: !hasItems ? 0.4 : 1,
        marginTop: 8
      })
    }, t("copyConfig")), /*#__PURE__*/React.createElement("button", {
      disabled: modules.length === 0,
      onClick: downloadPDF,
      style: _objectSpread(_objectSpread({}, sty.shareBtn), {}, {
        opacity: modules.length === 0 ? 0.4 : 1,
        marginTop: 6
      })
    }, t("downloadPdf")), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 6,
        marginTop: 6
      }
    }, /*#__PURE__*/React.createElement("button", {
      disabled: modules.length === 0 || variants.length >= 3,
      onClick: saveVariant,
      style: _objectSpread(_objectSpread({}, sty.shareBtn), {}, {
        opacity: modules.length === 0 || variants.length >= 3 ? 0.4 : 1
      })
    }, t("saveVariant"), variants.length ? " (".concat(variants.length, "/3)") : ""), /*#__PURE__*/React.createElement("button", {
      disabled: variants.length === 0,
      onClick: function onClick() {
        return setShowCompare(true);
      },
      style: _objectSpread(_objectSpread({}, sty.shareBtn), {}, {
        opacity: variants.length === 0 ? 0.4 : 1
      })
    }, t("compare"), variants.length ? " (".concat(variants.length, ")") : "")), showCompare && /*#__PURE__*/React.createElement(CompareModal, null), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "center",
        gap: 6,
        flexWrap: "wrap",
        marginTop: 14,
        fontSize: 10,
        color: "#6B6B6B",
        letterSpacing: "0.02em"
      }
    }, /*#__PURE__*/React.createElement("span", null, "Made in Europe"), /*#__PURE__*/React.createElement("span", null, "·"), /*#__PURE__*/React.createElement("span", null, t("freeShip")), /*#__PURE__*/React.createElement("span", null, "·"), /*#__PURE__*/React.createElement("span", null, t("returns100"))));
  };
  var build3DScene = useCallback(function () {
    var sr = threeRef.current;
    if (!sr.scene) return;
    var old = [];
    sr.scene.traverse(function (c) {
      if (c.userData.isModule) old.push(c);
    });
    old.forEach(function (c) {
      return sr.scene.remove(c);
    });
    if (modules.length === 0) return;
    var col = new THREE.Color(fabHex);
    var darkCol = new THREE.Color(fabHex).multiplyScalar(0.7);
    var lightCol = col.clone().lerp(new THREE.Color(0xffffff), 0.2);
    var legMat = new THREE.MeshPhongMaterial({
      color: 0x1a1a1a,
      shininess: 30
    });
    var seatMat, backMat, cushionMat;
    if (fabTexture) {
      var loader = sr.texLoader || (sr.texLoader = new THREE.TextureLoader());
      var loadMap = function loadMap(url, srgb) {
        var t = loader.load(assetUrl(url));
        t.wrapS = t.wrapT = THREE.RepeatWrapping;
        t.repeat.set(1.4, 1.4);
        if (srgb && "colorSpace" in t) t.colorSpace = THREE.SRGBColorSpace;
        return t;
      };
      var colorMap = loadMap(fabTexture, true);
      var normalMap = fabricObj.normalMap ? loadMap(fabricObj.normalMap, false) : null;
      var roughnessMap = fabricObj.roughnessMap ? loadMap(fabricObj.roughnessMap, false) : null;
      var metalnessMap = fabricObj.metalnessMap ? loadMap(fabricObj.metalnessMap, false) : null;
      var stdOpts = function stdOpts(tint) {
        return {
          map: colorMap,
          color: tint,
          normalMap: normalMap || undefined,
          roughnessMap: roughnessMap || undefined,
          roughness: roughnessMap ? 1 : 0.85,
          metalnessMap: metalnessMap || undefined,
          metalness: metalnessMap ? 1 : 0
        };
      };
      seatMat = new THREE.MeshStandardMaterial(stdOpts(0xffffff));
      backMat = new THREE.MeshStandardMaterial(stdOpts(0xaaaaaa));
      cushionMat = new THREE.MeshStandardMaterial(stdOpts(0xffffff));
    } else {
      seatMat = new THREE.MeshPhongMaterial({
        color: lightCol,
        shininess: 10
      });
      backMat = new THREE.MeshPhongMaterial({
        color: darkCol,
        shininess: 5
      });
      cushionMat = new THREE.MeshPhongMaterial({
        color: col,
        shininess: 8
      });
    }
    var mnX = 1e9,
      mxX = -1e9,
      mnY = 1e9,
      mxY = -1e9;
    modules.forEach(function (m) {
      var dd = MODULE_DEFS.find(function (d) {
        return d.id === m.mid;
      });
      if (!dd) return;
      var sw = m.rot === 90 || m.rot === 270;
      var w = (sw ? dd.d : dd.w) * CM2PX,
        h = (sw ? dd.w : dd.d) * CM2PX;
      mnX = Math.min(mnX, m.x);
      mxX = Math.max(mxX, m.x + w);
      mnY = Math.min(mnY, m.y);
      mxY = Math.max(mxY, m.y + h);
    });
    var cx2d = (mnX + mxX) / 2,
      cy2d = (mnY + mxY) / 2;
    var S = 0.01;
    modules.forEach(function (m) {
      var def = MODULE_DEFS.find(function (d) {
        return d.id === m.mid;
      });
      if (!def) return;
      var g = new THREE.Group();
      g.userData.isModule = true;
      var px2d = m.x,
        py2d = m.y; // px in 2D
      var cmX = px2d / CM2PX,
        cmZ = py2d / CM2PX; // convert to cm
      var cmCX = cx2d / CM2PX,
        cmCZ = cy2d / CM2PX;
      g.position.set((cmX - cmCX) * S, 0, (cmZ - cmCZ) * S);
      if (m.rot) {
        g.rotation.y = -(m.rot * Math.PI / 180);
        if (m.rot === 90) g.position.x += def.d * S;else if (m.rot === 180) {
          g.position.x += def.w * S;
          g.position.z += def.d * S;
        } else if (m.rot === 270) g.position.z += def.w * S;
      }
      sr.scene.add(g);
      var glbPath = MODULE_TO_GLB[def.id];
      if (glbPath) {
        var loadInto = function loadInto(root) {
          if (sr.disposed || !sr.scene.children.includes(g)) return;
          root.rotation.y = MODULE_GLB_Y_ROT[def.id] || 0;
          root.updateMatrixWorld(true);
          var size0 = new THREE.Box3().setFromObject(root).getSize(new THREE.Vector3());
          var ratio = Math.max(def.w, def.d) * S / (Math.max(size0.x, size0.z) || 1);
          if (ratio > 2 || ratio < 0.5) root.scale.multiplyScalar(ratio);
          root.updateMatrixWorld(true);
          var pudloPrzed = new THREE.Box3().setFromObject(root);
          var rozmPrzed = pudloPrzed.getSize(new THREE.Vector3());
          var zapas = OVERLAP_3D_CM * S;
          var podlokietnik = def.id === "long-l" || def.id === "long-r" ? LONG_ARM_CM * S : 0;
          var celX = def.w * S + podlokietnik + 2 * zapas;
          var celZ = def.d * S + 2 * zapas;
          var fX = rozmPrzed.x > 0 ? celX / rozmPrzed.x : 1;
          var fZ = rozmPrzed.z > 0 ? celZ / rozmPrzed.z : 1;
          var cwiartka = Math.abs(Math.sin(root.rotation.y)) > 0.5;
          root.scale.x *= cwiartka ? fZ : fX;
          root.scale.z *= cwiartka ? fX : fZ;
          root.updateMatrixWorld(true);
          var box = new THREE.Box3().setFromObject(root);
          var ctr = box.getCenter(new THREE.Vector3());
          root.position.x += def.w * S / 2 - ctr.x;
          root.position.z += def.d * S / 2 - ctr.z;
          root.position.y -= box.min.y;
          if (def.id === "long-l" || def.id === "long-r") {
            var seatCorrection = LONG_ARM_CM / 2 * S;
            root.position.x += def.id === "long-l" ? seatCorrection : -seatCorrection;
          }
          applyFabricMaterials(root, fabricObj, fabHex, sr);
          root.traverse(function (o) {
            if (o.isMesh) {
              o.castShadow = true;
              o.receiveShadow = true;
            }
          });
          g.add(root);
        };
        sr.gltfCache = sr.gltfCache || {};
        if (sr.gltfCache[glbPath]) {
          loadInto(sr.gltfCache[glbPath].clone(true));
        } else {
          var _loader = sr.gltfLoader || (sr.gltfLoader = makeGltfLoader());
          var url = modelUrl(glbPath);
          var _attempt = function attempt(n) {
            _loader.load(url, function (gltf) {
              if (sr.disposed) return;
              sr.gltfCache[glbPath] = gltf.scene;
              loadInto(gltf.scene.clone(true));
            }, undefined, function (err) {
              if (sr.disposed) return;
              if (n < 3) {
                setTimeout(function () {
                  return _attempt(n + 1);
                }, 400 * n);
                return;
              }
              console.error("3D GLB load failed", glbPath, err);
            });
          };
          _attempt(1);
        }
        return; // skip procedural box building for this module
      }
      var w = def.w,
        d = def.d,
        bh = 30;
      var hasBk = def.id !== "pouf";
      var isCorner = def.id === "corner";
      var armSide = def.id === "left" || def.id === "long-l" ? "left" : def.id === "right" || def.id === "long-r" ? "right" : null;
      var armW = armSide ? 7 : 0;
      var armRatio = def.id === "long-l" || def.id === "long-r" ? 0.55 : 1;
      var backRatio = def.id === "chaise-l" ? 0.65 : def.id === "chaise-r" ? 0.65 : 1;
      var backFromRight = def.id === "chaise-r";
      var legH = 6,
        seatT = 6,
        backT = 10,
        cushH = 10,
        armH = 15;
      var lG = new THREE.CylinderGeometry(1.2 * S, 1.2 * S, legH * S, 6);
      [[5, 5], [w - 5, 5], [5, d - 5], [w - 5, d - 5]].forEach(function (_ref34) {
        var _ref35 = _slicedToArray(_ref34, 2),
          lx = _ref35[0],
          lz = _ref35[1];
        var l = new THREE.Mesh(lG, legMat);
        l.position.set(lx * S, legH * S / 2, lz * S);
        l.castShadow = true;
        g.add(l);
      });
      var sG = new THREE.BoxGeometry(w * S, seatT * S, d * S);
      var s = new THREE.Mesh(sG, seatMat);
      s.position.set(w / 2 * S, (legH + seatT / 2) * S, d / 2 * S);
      s.castShadow = true;
      s.receiveShadow = true;
      g.add(s);
      var cw = w - armW - 1,
        cd = d - (hasBk ? backT : 0) - 1;
      var cG = new THREE.BoxGeometry(cw * S, cushH * S, cd * S);
      var cu = new THREE.Mesh(cG, cushionMat);
      var cux = armSide === "left" ? armW + cw / 2 + 0.5 : armSide === "right" ? cw / 2 + 0.5 : w / 2;
      var cuz = hasBk ? backT + cd / 2 + 0.5 : d / 2;
      cu.position.set(cux * S, (legH + seatT + cushH / 2) * S, cuz * S);
      cu.castShadow = true;
      g.add(cu);
      if (hasBk) {
        var bw = backRatio < 1 ? w * backRatio : w;
        var bx = backFromRight ? w - bw / 2 : backRatio < 1 ? bw / 2 : w / 2;
        var bG = new THREE.BoxGeometry(bw * S, bh * S, backT * S);
        var bk = new THREE.Mesh(bG, backMat);
        bk.position.set(bx * S, (legH + seatT + bh / 2) * S, backT / 2 * S);
        bk.castShadow = true;
        g.add(bk);
        if (isCorner) {
          var sbG = new THREE.BoxGeometry(backT * S, bh * S, (d - backT) * S);
          var sb = new THREE.Mesh(sbG, backMat);
          sb.position.set(backT / 2 * S, (legH + seatT + bh / 2) * S, (backT + (d - backT) / 2) * S);
          sb.castShadow = true;
          g.add(sb);
        }
      }
      if (armSide) {
        var aLen = armRatio < 1 ? d * armRatio : d;
        var aG = new THREE.BoxGeometry(armW * S, armH * S, aLen * S);
        var ar = new THREE.Mesh(aG, backMat);
        var ax = armSide === "left" ? armW / 2 : w - armW / 2;
        ar.position.set(ax * S, (legH + seatT + armH / 2) * S, aLen / 2 * S);
        ar.castShadow = true;
        g.add(ar);
      }
    });
  }, [modules, fabHex, fabTexture, fabricObj]);
  useEffect(function () {
    if (viewMode !== "3d") return;
    var el = threeContainerRef.current;
    if (!el) return;
    var sr = threeRef.current;
    sr.disposed = false;
    var w = el.offsetWidth,
      h = el.offsetHeight;
    var scene = new THREE.Scene();
    scene.background = new THREE.Color(0xF6F6F5);
    var camera = new THREE.PerspectiveCamera(32, w / h, 0.1, 50);
    var renderer = new THREE.WebGLRenderer({
      antialias: true
    });
    renderer.setSize(w, h);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.shadowMap.enabled = true;
    el.appendChild(renderer.domElement);
    renderer.domElement.style.pointerEvents = "none";
    var LIGHT_SCALE = 0.80;
    scene.add(new THREE.AmbientLight(0xffffff, 0.55 * LIGHT_SCALE));
    var dl = new THREE.DirectionalLight(0xffffff, 1.0 * LIGHT_SCALE);
    dl.position.set(4, 7, 5);
    dl.castShadow = true;
    dl.shadow.bias = -0.0005;
    dl.shadow.normalBias = 0.008;
    dl.shadow.mapSize.width = 1024;
    dl.shadow.mapSize.height = 1024;
    dl.shadow.camera.near = 0.5;
    dl.shadow.camera.far = 20;
    dl.shadow.camera.left = -4;
    dl.shadow.camera.right = 4;
    dl.shadow.camera.top = 4;
    dl.shadow.camera.bottom = -4;
    scene.add(dl);
    scene.add(new THREE.DirectionalLight(0xE8E8E8, 0.35 * LIGHT_SCALE).translateX(-3).translateY(4).translateZ(-2));
    var floor = new THREE.Mesh(new THREE.PlaneGeometry(10, 10), new THREE.ShadowMaterial({
      opacity: 0.16
    }));
    floor.rotation.x = -Math.PI / 2;
    floor.receiveShadow = true;
    scene.add(floor);
    sr.scene = scene;
    sr.camera = camera;
    sr.renderer = renderer;
    orbRef.current = {
      theta: 0.8,
      phi: 1.0,
      dist: 4.2,
      dragging: false,
      lx: 0,
      ly: 0,
      auto: true
    };
    var _anim = function anim() {
      if (sr.disposed) return;
      requestAnimationFrame(_anim);
      var o = orbRef.current;
      if (o.auto) o.theta += 0.003;
      camera.position.x = o.dist * Math.sin(o.phi) * Math.sin(o.theta);
      camera.position.y = o.dist * Math.cos(o.phi);
      camera.position.z = o.dist * Math.sin(o.phi) * Math.cos(o.theta);
      camera.lookAt(0, 0.3, 0);
      renderer.render(scene, camera);
    };
    _anim();
    var lastW = 0,
      lastH = 0;
    var onR = function onR() {
      if (sr.disposed) return;
      var ww = el.offsetWidth,
        hh = el.offsetHeight;
      if (!ww || !hh || ww === lastW && hh === lastH) return;
      lastW = ww;
      lastH = hh;
      camera.aspect = ww / hh;
      camera.updateProjectionMatrix();
      renderer.setSize(ww, hh);
      renderer.render(scene, camera);
    };
    onR();
    window.addEventListener("resize", onR);
    var ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(onR) : null;
    if (ro) ro.observe(el);
    return function () {
      sr.disposed = true;
      if (ro) ro.disconnect();
      window.removeEventListener("resize", onR);
      renderer.dispose();
      if (el.contains(renderer.domElement)) el.removeChild(renderer.domElement);
      sr.scene = null;
      sr.camera = null;
      sr.renderer = null;
    };
  }, [viewMode, presetScreen, isMobile, isLandscape]);
  useEffect(function () {
    if (viewMode === "3d" && threeRef.current.scene) build3DScene();
  }, [viewMode, build3DScene]);
  var ptrs3dRef = useRef(new Map());
  var pinch3dRef = useRef(null);
  var on3DPointerDown = function on3DPointerDown(e) {
    clearTextSelection();
    ptrs3dRef.current.set(e.pointerId, {
      x: e.clientX,
      y: e.clientY
    });
    try {
      e.currentTarget.setPointerCapture(e.pointerId);
    } catch (err) {}
    if (ptrs3dRef.current.size === 2) {
      var pts = _toConsumableArray(ptrs3dRef.current.values());
      var dx = pts[0].x - pts[1].x,
        dy = pts[0].y - pts[1].y;
      pinch3dRef.current = {
        dist: Math.sqrt(dx * dx + dy * dy),
        startDist: orbRef.current.dist
      };
      orbRef.current.dragging = false;
      return;
    }
    if (ptrs3dRef.current.size === 1) {
      orbRef.current.dragging = true;
      orbRef.current.lx = e.clientX;
      orbRef.current.ly = e.clientY;
      orbRef.current.auto = false;
    }
  };
  var on3DPointerMove = function on3DPointerMove(e) {
    ptrs3dRef.current.set(e.pointerId, {
      x: e.clientX,
      y: e.clientY
    });
    if (ptrs3dRef.current.size >= 2 && pinch3dRef.current) {
      var pts = _toConsumableArray(ptrs3dRef.current.values());
      var dx = pts[0].x - pts[1].x,
        dy = pts[0].y - pts[1].y;
      var newDist = Math.sqrt(dx * dx + dy * dy);
      var ratio = pinch3dRef.current.dist / newDist;
      orbRef.current.dist = Math.max(1.8, Math.min(20, pinch3dRef.current.startDist * ratio));
      return;
    }
    var o = orbRef.current;
    if (!o.dragging) return;
    o.theta -= (e.clientX - o.lx) * 0.008;
    o.phi = Math.max(0.3, Math.min(1.45, o.phi + (e.clientY - o.ly) * 0.008));
    o.lx = e.clientX;
    o.ly = e.clientY;
  };
  var on3DPointerUp = function on3DPointerUp(e) {
    ptrs3dRef.current["delete"](e.pointerId);
    e.currentTarget.releasePointerCapture(e.pointerId);
    if (ptrs3dRef.current.size < 2) pinch3dRef.current = null;
    if (ptrs3dRef.current.size === 0) orbRef.current.dragging = false;
  };
  var on3DWheel = function on3DWheel(e) {
    e.preventDefault();
    orbRef.current.dist = Math.max(1.8, Math.min(20, orbRef.current.dist + e.deltaY * 0.004));
  };
  wheelRef.current = function (e) {
    if (viewMode === "2d") handleWheel(e);else on3DWheel(e);
  };
  var threeCanvasJsx = /*#__PURE__*/React.createElement("div", {
    ref: threeContainerRef,
    onPointerDown: on3DPointerDown,
    onPointerMove: on3DPointerMove,
    onPointerUp: on3DPointerUp,
    onPointerCancel: on3DPointerUp,
    style: {
      position: "absolute",
      inset: 0,
      cursor: "grab",
      touchAction: "none"
    }
  }, modules.length === 0 && /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      pointerEvents: "none",
      color: "#6B6B6B",
      fontSize: 14
    }
  }, t("empty3d")));
  var EmptyCanvasHint = function EmptyCanvasHint() {
    var ic = isMobile ? 34 : 48;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
        padding: isMobile ? "0 58px" : 0
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: "center",
        color: "#6B6B6B"
      }
    }, /*#__PURE__*/React.createElement("svg", {
      width: ic,
      height: ic,
      viewBox: "0 0 48 48",
      style: {
        marginBottom: isMobile ? 4 : 8,
        opacity: 0.4
      }
    }, /*#__PURE__*/React.createElement("rect", {
      x: "4",
      y: "12",
      width: "40",
      height: "28",
      rx: "4",
      fill: "none",
      stroke: "#6B6B6B",
      strokeWidth: "1.5"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "8",
      y: "8",
      width: "32",
      height: "6",
      rx: "2",
      fill: "none",
      stroke: "#6B6B6B",
      strokeWidth: "1.5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "24",
      y1: "18",
      x2: "24",
      y2: "36",
      stroke: "#6B6B6B",
      strokeWidth: "1",
      opacity: "0.4",
      strokeDasharray: "2,2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "12",
      y1: "26",
      x2: "36",
      y2: "26",
      stroke: "#6B6B6B",
      strokeWidth: "1",
      opacity: "0.4",
      strokeDasharray: "2,2"
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: isMobile ? 13 : 14,
        marginBottom: isMobile ? 3 : 6,
        fontWeight: 500,
        color: "#333"
      }
    }, t("emptyTitle")), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: isMobile ? 11 : 12,
        lineHeight: 1.5
      }
    }, t("emptyHint1"), !isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), t("emptyHint2"))), /*#__PURE__*/React.createElement("button", {
      onPointerDown: function onPointerDown(e) {
        return e.stopPropagation();
      },
      onClick: function onClick(e) {
        e.stopPropagation();
        setPresetScreen(true);
        setWizOpen(false);
        setWizResults(null);
      },
      style: _objectSpread(_objectSpread({}, sty.topBtn), {}, {
        pointerEvents: "auto",
        marginTop: isMobile ? 9 : 14,
        padding: isMobile ? "0 12px" : "8px 16px",
        height: isMobile ? 28 : undefined,
        fontSize: isMobile ? 11 : 12,
        background: "#fff"
      })
    }, SHOW_WIZARD ? "".concat(t("inspirations"), " \xB7 ").concat(t("helpChoose")) : t("inspirations"))));
  };
  var SelectionActions = function SelectionActions() {
    if (!selected) return null;
    var m = modules.find(function (mm) {
      return mm.iid === selected;
    });
    if (!m) return null;
    var b = _objectSpread(_objectSpread({}, zb), {}, {
      height: "100%",
      minWidth: 0,
      padding: "0 12px",
      fontSize: 12,
      fontWeight: 500,
      whiteSpace: "nowrap"
    });
    return /*#__PURE__*/React.createElement("div", {
      onPointerDown: function onPointerDown(e) {
        return e.stopPropagation();
      },
      style: {
        position: "absolute",
        left: 10,
        bottom: 10,
        height: PILL_W,
        boxSizing: "border-box",
        display: "flex",
        alignItems: "stretch",
        gap: 3,
        background: "rgba(255,255,255,0.94)",
        borderRadius: 60,
        border: "0.5px solid #E0E0E0",
        padding: 4,
        zIndex: 200
      }
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return rotateModule(selected);
      },
      style: b
    }, t("rotate")), /*#__PURE__*/React.createElement("div", {
      style: {
        width: 1,
        alignSelf: "stretch",
        background: "#E0E0E0",
        margin: "2px 1px"
      }
    }), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return removeModule(selected);
      },
      style: b
    }, t("remove")));
  };
  var canvasInner = function canvasInner() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, viewMode === "2d" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: innerStyle
    }, modules.map(function (m) {
      return /*#__PURE__*/React.createElement(ModuleOnCanvas, {
        key: m.iid,
        m: m
      });
    }), /*#__PURE__*/React.createElement(DimsOverlay, null), /*#__PURE__*/React.createElement(GhostPreview, null), !isMobile && /*#__PURE__*/React.createElement(FloatingRotateBtn, null)), isMobile && /*#__PURE__*/React.createElement(SelectionActions, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, threeCanvasJsx, isMobile && /*#__PURE__*/React.createElement("div", {
      onPointerDown: function onPointerDown(e) {
        return e.stopPropagation();
      },
      style: {
        position: "absolute",
        left: 10,
        bottom: 10,
        height: PILL_W,
        boxSizing: "border-box",
        display: "flex",
        alignItems: "stretch",
        background: "rgba(255,255,255,0.94)",
        borderRadius: 60,
        border: "0.5px solid #E0E0E0",
        padding: 4,
        zIndex: 200
      }
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return setViewMode("2d");
      },
      style: _objectSpread(_objectSpread({}, zb), {}, {
        height: "100%",
        minWidth: 0,
        padding: "0 14px",
        fontSize: 12,
        fontWeight: 500,
        whiteSpace: "nowrap"
      })
    }, "\u2190 ", t("backToEdit")))), modules.length === 0 && viewMode === "2d" && /*#__PURE__*/React.createElement(EmptyCanvasHint, null), zoomControls());
  };
  if (presetScreen) return /*#__PURE__*/React.createElement("div", {
    className: "umi-app",
    style: _objectSpread(_objectSpread({}, NO_TEXT_SELECT), {}, {
      fontFamily: "'League Spartan',system-ui,sans-serif",
      color: "#000",
      height: "100%",
      boxSizing: "border-box",
      background: "#F6F6F5",
      padding: isMobile ? "16px 14px 40px" : "24px 20px 48px",
      position: "relative",
      overflowY: "auto",
      overscrollBehavior: "contain",
      WebkitOverflowScrolling: "touch"
    })
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 940,
      margin: "0 auto"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 25,
      fontWeight: 500,
      textAlign: "center",
      marginBottom: 8,
      letterSpacing: "0.01em",
      paddingTop: 16
    }
  }, t("presetsTitle")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      color: "#6B6B6B",
      textAlign: "center",
      marginBottom: 20
    }
  }, t("presetsSub")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      gap: 8,
      marginBottom: 24,
      flexWrap: "wrap"
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setPresetScreen(false);
      track("preset_skip");
    },
    style: _objectSpread(_objectSpread({}, sty.topBtn), {}, {
      height: 38,
      padding: "0 20px",
      fontSize: 13
    })
  }, t("fromScratch")), SHOW_WIZARD && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setWizOpen(function (v) {
        return !v;
      });
      setWizResults(null);
    },
    style: _objectSpread(_objectSpread({}, sty.topBtn), {}, {
      height: 38,
      padding: "0 20px",
      fontSize: 13,
      background: wizOpen ? "#000" : undefined,
      color: wizOpen ? "#fff" : undefined
    })
  }, t("helpChoose"))), SHOW_WIZARD && wizOpen && wizardPanelJsx, wizResults && /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 10,
      flexWrap: "wrap",
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13,
      fontWeight: 500,
      color: "#3F8C63",
      background: "#EDF6F1",
      borderRadius: 60,
      padding: "6px 14px"
    }
  }, t("wizMatches"), ": ", wizResults.length), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setWizResults(null);
    },
    style: _objectSpread(_objectSpread({}, sty.paletteActionBtn), {}, {
      fontSize: 12
    })
  }, t("wizShowAll"))), /*#__PURE__*/React.createElement("div", {
    "data-preset-grid": true,
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(210px, 1fr))",
      gap: 14,
      scrollMarginTop: 16
    }
  }, (wizResults || PRESETS_BUILT).map(function (p) {
    return /*#__PURE__*/React.createElement(PresetCard, {
      key: p.id,
      p: p
    });
  }))));
  var MOBILE_SECTIONS = ["modules", "fabric", "summary"];
  var scrollToSection = function scrollToSection(tab) {
    var sc = panelScrollRef.current,
      el = sectionRefs.current[tab];
    setMobileTab(tab);
    if (!sc || !el) return;
    spyLockRef.current = Date.now() + 800;
    var top = Math.max(0, el.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - 2);
    var before = sc.scrollTop;
    if (sc.scrollTo) sc.scrollTo({
      top: top,
      behavior: "smooth"
    });else sc.scrollTop = top;
    setTimeout(function () {
      if (panelScrollRef.current === sc && Math.abs(sc.scrollTop - before) < 2 && Math.abs(top - before) >= 2) {
        sc.scrollTop = top;
      }
    }, 320);
  };
  var onPanelScroll = function onPanelScroll() {
    if (Date.now() < spyLockRef.current) return;
    var sc = panelScrollRef.current;
    if (!sc) return;
    var cur = MOBILE_SECTIONS[0];
    if (sc.scrollTop + sc.clientHeight >= sc.scrollHeight - 4) {
      cur = MOBILE_SECTIONS[MOBILE_SECTIONS.length - 1];
    } else {
      var top = sc.getBoundingClientRect().top;
      for (var _i0 = 0, _MOBILE_SECTIONS = MOBILE_SECTIONS; _i0 < _MOBILE_SECTIONS.length; _i0++) {
        var tab = _MOBILE_SECTIONS[_i0];
        var el = sectionRefs.current[tab];
        if (el && el.getBoundingClientRect().top - top <= 24) cur = tab;
      }
    }
    setMobileTab(function (prev) {
      return prev === cur ? prev : cur;
    });
  };
  var mobileTabsJsx = /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      borderBottom: "0.5px solid #E0E0E0",
      flexShrink: 0,
      touchAction: "none"
    }
  }, MOBILE_SECTIONS.map(function (tab) {
    return /*#__PURE__*/React.createElement("button", {
      key: tab,
      onClick: function onClick() {
        return scrollToSection(tab);
      },
      style: {
        flex: 1,
        padding: "10px 0",
        fontSize: 12,
        background: "none",
        border: "none",
        borderBottom: mobileTab === tab ? "2px solid #000" : "2px solid transparent",
        color: mobileTab === tab ? "#000" : "#6B6B6B",
        fontWeight: mobileTab === tab ? 500 : 400,
        fontFamily: "inherit",
        cursor: "pointer",
        textTransform: "capitalize"
      }
    }, t(tab));
  }));
  var mobilePanelBodyJsx = /*#__PURE__*/React.createElement("div", {
    ref: panelScrollRef,
    onScroll: onPanelScroll,
    style: {
      padding: 12,
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
      overscrollBehavior: "contain",
      WebkitOverflowScrolling: "touch",
      touchAction: "pan-y"
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: function ref(el) {
      sectionRefs.current.modules = el;
    }
  }, modulePalette()), /*#__PURE__*/React.createElement("div", {
    ref: function ref(el) {
      sectionRefs.current.fabric = el;
    },
    style: {
      marginTop: 22,
      paddingTop: 22,
      borderTop: "0.5px solid #E0E0E0"
    }
  }, fabricSelector()), /*#__PURE__*/React.createElement("div", {
    ref: function ref(el) {
      sectionRefs.current.summary = el;
    },
    style: {
      marginTop: 22,
      paddingTop: 22,
      borderTop: "0.5px solid #E0E0E0"
    }
  }, addonsSection(), pricingSummary()));
  var mobileCartBarJsx = /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 10,
      padding: "10px 16px",
      borderTop: "0.5px solid #E0E0E0",
      background: "#fff",
      flexShrink: 0,
      touchAction: "none"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flexShrink: 0,
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 16,
      fontWeight: 500
    }
  }, formatPrice(totalCents)), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 10,
      color: "#6B6B6B",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  }, colorLabel(fabricObj))), mobileTab !== "summary" && /*#__PURE__*/React.createElement("button", {
    disabled: !hasItems,
    onClick: function onClick() {
      setViewMode("2d");
      scrollToSection("summary");
    },
    style: _objectSpread(_objectSpread({}, sty.cartBtn), {}, {
      width: "50%",
      flex: "0 0 50%",
      minWidth: 0,
      padding: "12px 16px",
      fontSize: 15,
      marginTop: 0,
      whiteSpace: "nowrap",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      opacity: !hasItems ? 0.4 : 1
    })
  }, t("summary")));
  if (isMobile && isLandscape) return /*#__PURE__*/React.createElement("div", {
    className: "umi-app",
    style: _objectSpread(_objectSpread({}, NO_TEXT_SELECT), {}, {
      fontFamily: "'League Spartan',system-ui,sans-serif",
      color: "#000",
      height: "100%",
      display: "flex",
      background: "#fff",
      overflow: "hidden"
    })
  }, /*#__PURE__*/React.createElement("div", _extends({
    ref: canvasRef,
    style: {
      flex: 1,
      minWidth: 0,
      background: "#F6F6F5",
      position: "relative",
      overflow: "hidden",
      touchAction: "none",
      userSelect: "none",
      WebkitUserSelect: "none"
    }
  }, viewMode === "2d" ? {
    onPointerDown: onPointerDownCanvas,
    onPointerMove: onPointerMoveCanvas,
    onPointerUp: onPointerUpCanvas,
    onPointerCancel: onPointerCancelCanvas,
    onLostPointerCapture: onPointerCancelCanvas
  } : {}), canvasInner()), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: "0 0 300px",
      maxWidth: "46%",
      minWidth: 0,
      borderLeft: "0.5px solid #E0E0E0",
      background: "#fff",
      display: "flex",
      flexDirection: "column",
      minHeight: 0
    }
  }, mobileTabsJsx, mobilePanelBodyJsx, mobileCartBarJsx));
  if (isMobile) return /*#__PURE__*/React.createElement("div", {
    className: "umi-app",
    style: _objectSpread(_objectSpread({}, NO_TEXT_SELECT), {}, {
      fontFamily: "'League Spartan',system-ui,sans-serif",
      color: "#000",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: "#fff",
      overflow: "hidden"
    })
  }, /*#__PURE__*/React.createElement("div", _extends({
    ref: canvasRef,
    style: {
      flex: "1 1 42%",
      minHeight: 130,
      background: "#F6F6F5",
      position: "relative",
      overflow: "hidden",
      touchAction: "none",
      userSelect: "none",
      WebkitUserSelect: "none"
    }
  }, viewMode === "2d" ? {
    onPointerDown: onPointerDownCanvas,
    onPointerMove: onPointerMoveCanvas,
    onPointerUp: onPointerUpCanvas,
    onPointerCancel: onPointerCancelCanvas,
    onLostPointerCapture: onPointerCancelCanvas
  } : {}), canvasInner()), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: "1 1 58%",
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
      borderTop: "0.5px solid #E0E0E0",
      background: "#fff"
    }
  }, mobileTabsJsx, mobilePanelBodyJsx), mobileCartBarJsx);
  return /*#__PURE__*/React.createElement("div", {
    className: "umi-app",
    style: _objectSpread(_objectSpread({}, NO_TEXT_SELECT), {}, {
      fontFamily: "'League Spartan',system-ui,sans-serif",
      color: "#000",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: "#fff",
      overflow: "hidden"
    })
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flex: 1,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", _extends({
    ref: canvasRef
  }, viewMode === "2d" ? {
    onPointerDown: onPointerDownCanvas,
    onPointerMove: onPointerMoveCanvas,
    onPointerUp: onPointerUpCanvas,
    onPointerCancel: onPointerCancelCanvas,
    onLostPointerCapture: onPointerCancelCanvas
  } : {}, {
    style: {
      flex: 1,
      background: "#F6F6F5",
      position: "relative",
      overflow: "hidden",
      cursor: viewMode === "2d" ? "grab" : "default",
      touchAction: "none"
    }
  }), canvasInner()), /*#__PURE__*/React.createElement("div", {
    ref: sidebarElRef,
    style: _objectSpread(_objectSpread({}, sty.sidebarWrap), {}, {
      width: sidebarWRef.current != null ? sidebarWRef.current : sidebarW
    })
  }, /*#__PURE__*/React.createElement("div", {
    onPointerDown: onSidebarResizeDown,
    onPointerMove: onSidebarResizeMove,
    onPointerUp: onSidebarResizeUp,
    onPointerCancel: onSidebarResizeUp,
    onLostPointerCapture: onSidebarResizeUp,
    role: "separator",
    "aria-orientation": "vertical",
    "aria-label": t("resizePanel"),
    title: t("resizePanel"),
    style: {
      position: "absolute",
      left: -4,
      top: 0,
      bottom: 0,
      width: 9,
      cursor: "col-resize",
      zIndex: 300,
      touchAction: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 3,
      height: 34,
      borderRadius: 2,
      background: "#D8D7D3"
    }
  })), /*#__PURE__*/React.createElement("div", {
    ref: attachSidebarScroll,
    style: sty.sidebar
  }, /*#__PURE__*/React.createElement("div", {
    style: sty.section
  }, modulePalette()), /*#__PURE__*/React.createElement("div", {
    style: sty.section
  }, fabricSelector()), /*#__PURE__*/React.createElement("div", {
    style: sty.section
  }, addonsSection()), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 24,
      marginTop: "auto"
    }
  }, pricingSummary())), hasItems && !totalOnScreen && /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      alignItems: "baseline",
      gap: 10,
      padding: "12px 24px",
      background: "rgba(255,255,255,0.94)",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
      borderTop: "0.5px solid #E0E0E0",
      zIndex: 5,
      pointerEvents: "none"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12,
      color: "#6B6B6B"
    }
  }, t("total")), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 17,
      fontWeight: 500,
      color: "#000",
      letterSpacing: "-0.02em"
    }
  }, formatPrice(totalCents))))));
}
var sty = {
  topBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 20px",
    borderBottom: "0.5px solid #E0E0E0",
    background: "#fff",
    flexShrink: 0
  },
  paletteActionBtn: {
    height: 32,
    padding: "0 14px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    color: "#000",
    border: "1px solid #E0E0E0",
    borderRadius: 60,
    fontFamily: "inherit",
    fontSize: 11,
    cursor: "pointer",
    whiteSpace: "nowrap",
    boxSizing: "border-box"
  },
  topBtn: {
    padding: "0 14px",
    height: 30,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    background: "transparent",
    border: "1px solid rgba(0,0,0,0.25)",
    borderRadius: 60,
    cursor: "pointer",
    fontFamily: "inherit",
    color: "#000"
  },
  sidebarWrap: {
    position: "relative",
    width: 390,
    borderLeft: "0.5px solid #E0E0E0",
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    minHeight: 0
  },
  sidebar: {
    flex: 1,
    minHeight: 0,
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    overscrollBehavior: "contain"
  },
  section: {
    padding: 24,
    borderBottom: "0.5px solid #E0E0E0"
  },
  label: {
    fontSize: 11,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    color: "#6B6B6B",
    marginBottom: 16,
    fontWeight: 500
  },
  card: {
    background: "transparent",
    borderRadius: 12,
    padding: "10px 6px",
    border: "0.5px solid #E6E4E0",
    cursor: "pointer",
    textAlign: "center",
    fontFamily: "inherit"
  },
  cartBtn: {
    width: "100%",
    padding: "13px 24px",
    background: BRAND,
    color: "#fff",
    border: "none",
    borderRadius: 60,
    fontFamily: "inherit",
    fontSize: 15,
    fontWeight: 400,
    letterSpacing: "0.01em",
    cursor: "pointer"
  },
  rowDelBtn: {
    width: 20,
    height: 20,
    display: "grid",
    placeItems: "center",
    background: "transparent",
    border: "none",
    borderRadius: 4,
    color: "#B0AFAB",
    fontSize: 11,
    lineHeight: 1,
    cursor: "pointer",
    fontFamily: "inherit",
    flexShrink: 0,
    padding: 0
  },
  shareBtn: {
    width: "100%",
    padding: "10px 18px",
    background: "transparent",
    color: "#000",
    border: "1px solid #000",
    borderRadius: 60,
    fontFamily: "inherit",
    fontSize: 12,
    cursor: "pointer"
  },
  zoomBtn: {
    minWidth: 28,
    height: 28,
    display: "grid",
    placeItems: "center",
    background: "transparent",
    border: "none",
    borderRadius: 60,
    cursor: "pointer",
    fontFamily: "inherit",
    fontSize: 14,
    color: "#000"
  },
  floatBtn: {
    fontFamily: "'League Spartan',system-ui,sans-serif",
    fontSize: 11,
    lineHeight: 1,
    padding: "7px 13px",
    background: "#fff",
    color: "#000",
    border: "1px solid rgba(0,0,0,0.2)",
    borderRadius: 60,
    cursor: "pointer",
    fontWeight: 500,
    boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
    whiteSpace: "nowrap"
  }
};
var NO_TEXT_SELECT = {
  userSelect: "none",
  WebkitUserSelect: "none",
  WebkitTouchCallout: "none"
};
function clearTextSelection() {
  try {
    var sel = window.getSelection && window.getSelection();
    if (sel && sel.rangeCount) sel.removeAllRanges();
  } catch (e) {}
}
function Configurator() {
  return /*#__PURE__*/React.createElement(ConfiguratorErrorBoundary, null, /*#__PURE__*/React.createElement(ConfiguratorApp, null));
}
try {
  var root = ReactDOM.createRoot(document.getElementById("umi-configurator-root"));
  root.render(React.createElement(Configurator));
} catch (e) {
  document.getElementById("umi-configurator-root").innerHTML = '<pre style="padding:20px;color:#b00;white-space:pre-wrap;">' + (e && e.stack ? e.stack : e) + '</pre>';
}
window.FEUM_APP_BUILD = "2026-09-29 11:50";
